/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./scripts/Bundles/BundleAddToCart.ts":
/*!********************************************!*\
  !*** ./scripts/Bundles/BundleAddToCart.ts ***!
  \********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EditionBundleAddToCart; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var EditionBundleAddToCart = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EditionBundleAddToCart, _HTMLElement);
  var _super = _createSuper(EditionBundleAddToCart);
  function EditionBundleAddToCart() {
    var _this;
    _classCallCheck(this, EditionBundleAddToCart);
    _this = _super.call(this);
    _this.addBundleToCart = _this.addBundleToCart.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(EditionBundleAddToCart, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.addEventListener("click", function (event) {
        event.preventDefault();
        if (_this2.checkRequiredSelects()) {
          var formData = {
            items: []
          };
          var selectedElements = Array.from(document.querySelectorAll("edition-bundle-product input:checked"));
          selectedElements.forEach(function (element) {
            formData.items.push({
              id: element.dataset.id,
              quantity: 1
            });
          });
          _this2.addBundleToCart(formData);
        }
      });
    }
  }, {
    key: "addBundleToCart",
    value: function () {
      var _addBundleToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(formdata) {
        var response, openDrawer;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(formdata)
              });
            case 3:
              response = _context.sent;
              if (response.ok) {}
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 10:
              _context.prev = 10;
              document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: true
              }));
              openDrawer = document.querySelector('a[data-drawer-id="sidebar-cart"]');
              openDrawer.click();
              return _context.finish(10);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7, 10, 15]]);
      }));
      function addBundleToCart(_x) {
        return _addBundleToCart.apply(this, arguments);
      }
      return addBundleToCart;
    }()
  }, {
    key: "checkRequiredSelects",
    value: function checkRequiredSelects() {
      var requiredAmountOfSelects = Array.from(document.querySelectorAll("edition-bundle-product")).length;
      var amountOfSelects = Array.from(document.querySelectorAll("edition-bundle-product input:checked")).length;
      var bundleAtc = document.querySelector("edition-bundle-atc");
      if (amountOfSelects < requiredAmountOfSelects) {
        bundleAtc.setAttribute("disabled", "disabled");
        bundleAtc.classList.add("button-is-hidden");
      } else {
        bundleAtc.removeAttribute("disabled");
        bundleAtc.classList.remove("button-is-hidden");
      }
      return requiredAmountOfSelects === amountOfSelects ? true : false;
    }
  }]);
  return EditionBundleAddToCart;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./scripts/Bundles/BundleProduct.ts":
/*!******************************************!*\
  !*** ./scripts/Bundles/BundleProduct.ts ***!
  \******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EditionBundleProduct; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var EditionBundleProduct = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EditionBundleProduct, _HTMLElement);
  var _super = _createSuper(EditionBundleProduct);
  function EditionBundleProduct() {
    var _this;
    _classCallCheck(this, EditionBundleProduct);
    _this = _super.call(this);
    _this.handleSizeChange = _this.handleSizeChange.bind(_assertThisInitialized(_this));
    _this.toggleSizePicker = _this.toggleSizePicker.bind(_assertThisInitialized(_this));
    _this.handleProductChange = _this.handleProductChange.bind(_assertThisInitialized(_this));
    _this.handleUpdateProductVariantData = _this.handleUpdateProductVariantData.bind(_assertThisInitialized(_this));
    _this.initSizeOptionListeners = _this.initSizeOptionListeners.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(EditionBundleProduct, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.initSizeOptionListeners();
      var productOptions = Array.from(this.querySelectorAll(".edition_product_available"));
      productOptions.forEach(function (product) {
        product.addEventListener("click", function (event) {
          event.preventDefault();
          productOptions.forEach(function (product) {
            product.classList.remove("active");
          });
          product.classList.add("active");
          _this2.handleProductChange(product);
        });
      });
    }
  }, {
    key: "initSizeOptionListeners",
    value: function initSizeOptionListeners() {
      var _this3 = this;
      var sizeOptions = Array.from(this.querySelectorAll(".edition-bundle-product-sizes input"));
      sizeOptions.forEach(function (sizeOption) {
        sizeOption.addEventListener("click", function (event) {
          _this3.handleSizeChange(event);
        });
      });
    }
  }, {
    key: "handleProductChange",
    value: function handleProductChange(product) {
      var _this4 = this;
      var productData = {
        id: product.dataset.id,
        handle: product.dataset.handle,
        url: product.dataset.url,
        title: product.dataset.title,
        color: product.dataset.color,
        img: product.dataset.img,
        price: product.dataset.price,
        index: product.dataset.index
      };
      this.handleUpdateProductVariantData(productData.handle, productData.index);
      var productInfo = this.querySelector(".edition-bundle-content");
      var productImage = this.querySelector(".edition-bundle-image img");
      if (productImage && productData.img && productImage.src !== productData.img) {
        productImage.src = productData.img;
        productImage.srcset = productData.img;
      }
      var productTitle = productInfo.querySelector(".ProductMeta__Title");
      if (productTitle && productData.title && productTitle.innerText !== productData.title) {
        productTitle.innerText = productData.title;
      }
      var productColor = productInfo.querySelector(".ProductForm__Label");
      if (productColor && productData.color && productColor.innerText !== productData.color) {
        productColor.innerText = productData.color;
      }
      var price = productInfo.querySelector(".ProductMeta__Price");
      if (price && productData.price && price.innerText !== productData.price) {
        price.innerText = productData.price;
      }
      var productModal = this.querySelector("edition-productmodal-trigger");
      if (productModal) {
        productModal.setAttribute("data-id", productData.id);
        productModal.setAttribute("data-url", productData.url);
        productModal.setAttribute("data-title", productData.title);
      }
      setTimeout(function () {
        _this4.checkRequiredSelects();
      }, 500);
    }
  }, {
    key: "handleSizeChange",
    value: function handleSizeChange(event) {
      var selectedOption = event.target;
      this.checkRequiredSelects();
    }
  }, {
    key: "toggleSizePicker",
    value: function toggleSizePicker() {
      var sizeOptionsHolder = this.querySelector(".edition-bundle-product-sizes");
      if (sizeOptionsHolder) {
        sizeOptionsHolder.style.display = sizeOptionsHolder.style.display === "none" ? "block" : "none";
      }
    }
  }, {
    key: "handleUpdateProductVariantData",
    value: function () {
      var _handleUpdateProductVariantData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(handle, index) {
        var response, data, variants, variantsHolder, editionArrows;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch("/products/".concat(handle, ".js"));
            case 3:
              response = _context.sent;
              if (!response.ok) {
                _context.next = 12;
                break;
              }
              _context.next = 7;
              return response.json();
            case 7:
              data = _context.sent;
              variants = data.variants;
              variants.forEach(function (variant) {
                var variantData = {
                  id: "".concat(variant.id),
                  title: "".concat(variant.title),
                  available: "".concat(variant.available)
                };
              });
              variantsHolder = this.querySelector(".edition-bundle-product-sizez-options");
              if (variantsHolder) {
                editionArrows = variantsHolder.querySelectorAll("edition-arrow");
                variantsHolder.innerHTML = variants.map(function (variant) {
                  return "\n\t\t\t\t<span>\n\t\t\t\t  <input type=\"radio\"\n\t\t\t\t\t  id=\"variant-".concat(variant.id, "\" \n\t\t\t\t\t  name=\"variant-").concat(index, "\" \n\t\t\t\t\t  value=\"variant-").concat(index, "\"\n\t\t\t\t\t  class=\"SizeSwatch__Radio\"\n\t\t\t\t\t  data-id=\"").concat(variant.id, "\"\n\t\t\t\t\t  data-title=\"").concat(variant.title, "\">\n  \n\t\t\t\t  <label for=\"variant-").concat(variant.id, "\"\n\t\t\t\t\t\t  class=\"SizeSwatch ").concat(variant.available == false ? "is-unavailable" : "", "\">\n\t\t\t\t\t  ").concat(variant.title, "\n\t\t\t\t  </label>\n\t\t\t\t</span>\n\t\t\t\t");
                }).join("");
                // append arrows
                editionArrows.forEach(function (arrow) {
                  variantsHolder.appendChild(arrow);
                });
              }
            case 12:
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 17:
              _context.prev = 17;
              this.initSizeOptionListeners();
              return _context.finish(17);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 14, 17, 20]]);
      }));
      function handleUpdateProductVariantData(_x, _x2) {
        return _handleUpdateProductVariantData.apply(this, arguments);
      }
      return handleUpdateProductVariantData;
    }()
  }, {
    key: "checkRequiredSelects",
    value: function checkRequiredSelects() {
      var requiredAmountOfSelects = Array.from(document.querySelectorAll("edition-bundle-product")).length;
      var amountOfSelects = Array.from(document.querySelectorAll("edition-bundle-product input:checked")).length;
      var bundleAtc = document.querySelector("edition-bundle-atc");
      if (amountOfSelects < requiredAmountOfSelects) {
        bundleAtc.setAttribute("disabled", "disabled");
        bundleAtc.classList.add("button-is-hidden");
      } else {
        bundleAtc.removeAttribute("disabled");
        bundleAtc.classList.remove("button-is-hidden");
      }
      return requiredAmountOfSelects === amountOfSelects ? true : false;
    }
  }]);
  return EditionBundleProduct;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./scripts/Bundles/BundleProductModalTrigger.ts":
/*!******************************************************!*\
  !*** ./scripts/Bundles/BundleProductModalTrigger.ts ***!
  \******************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EditionBundleProductModalTrigger; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var EditionBundleProductModalTrigger = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EditionBundleProductModalTrigger, _HTMLElement);
  var _super = _createSuper(EditionBundleProductModalTrigger);
  function EditionBundleProductModalTrigger() {
    var _this;
    _classCallCheck(this, EditionBundleProductModalTrigger);
    _this = _super.call(this);
    _this.toggleModal = _this.toggleModal.bind(_assertThisInitialized(_this));
    _this.fetchProductSection = _this.fetchProductSection.bind(_assertThisInitialized(_this));
    _this.fetchKiwiData = _this.fetchKiwiData.bind(_assertThisInitialized(_this));
    _this.handleProductModalEvents = _this.handleProductModalEvents.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(EditionBundleProductModalTrigger, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.addEventListener("click", function (event) {
        event.preventDefault();
        _this2.toggleModal();
        _this2.fetchProductSection("".concat(_this2.dataset.url, "?view=product"), _this2.dataset.kiwihandle);
      });
    }
  }, {
    key: "toggleModal",
    value: function toggleModal() {
      var productModal = document.querySelector(".edition-product-modal");
      if (productModal) {
        productModal.classList.toggle("modal-active");
      }
    }
  }, {
    key: "fetchProductSection",
    value: function () {
      var _fetchProductSection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(sectionUrl, productHandle) {
        var productModalContentSkeleton, productModal, productModalContent, response, data, fresh, contentToFetch;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              productModalContentSkeleton = document.querySelector(".product-modal-content-skeleton");
              productModalContentSkeleton.style.display = "block";
              productModal = document.querySelector(".edition-product-modal");
              productModalContent = productModal.querySelector(".product-modal-content");
              productModalContent.innerHTML = "";
              _context.prev = 5;
              _context.next = 8;
              return window.fetch("".concat(sectionUrl));
            case 8:
              response = _context.sent;
              if (!response.ok) {
                _context.next = 17;
                break;
              }
              _context.next = 12;
              return response.text();
            case 12:
              data = _context.sent;
              fresh = document.createElement("div");
              fresh.innerHTML = data;
              contentToFetch = fresh.querySelector(".Product__Holder");
              if (productModal && productModalContent && contentToFetch) {
                productModalContent.innerHTML = contentToFetch.innerHTML;
              }
            case 17:
              _context.next = 22;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](5);
              console.error(_context.t0);
            case 22:
              _context.prev = 22;
              productModalContentSkeleton.style.display = "none";
              this.fetchKiwiData(productHandle);
              this.handleProductModalEvents(productModalContent);
              return _context.finish(22);
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[5, 19, 22, 27]]);
      }));
      function fetchProductSection(_x, _x2) {
        return _fetchProductSection.apply(this, arguments);
      }
      return fetchProductSection;
    }()
  }, {
    key: "fetchKiwiData",
    value: function () {
      var _fetchKiwiData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(productHandle) {
        var handle;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              handle = productHandle;
              try {
                setTimeout(function () {
                  var productSizingData = window[handle];
                  window.ks.loadSizing({
                    productData: productSizingData,
                    options: {
                      el: "elementToInject",
                      displayMode: 0
                    }
                  });
                }, 2000);
              } catch (error) {
                console.error(error);
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function fetchKiwiData(_x3) {
        return _fetchKiwiData.apply(this, arguments);
      }
      return fetchKiwiData;
    }()
  }, {
    key: "handleProductModalEvents",
    value: function handleProductModalEvents(content) {
      var _this3 = this;
      var productOptions = Array.from(content.querySelectorAll(".colors__item"));
      productOptions.forEach(function (option) {
        option.addEventListener("click", function (event) {
          event.preventDefault();
          _this3.fetchProductSection("".concat(option.dataset.url, "?view=product"), option.dataset.kiwihandle);
        });
      });
    }
  }]);
  return EditionBundleProductModalTrigger;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./scripts/Bundles/Bundles.ts":
/*!************************************!*\
  !*** ./scripts/Bundles/Bundles.ts ***!
  \************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EditionBundles; }
/* harmony export */ });
/* harmony import */ var _scripts_Bundles_BundleProduct__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../scripts/Bundles/BundleProduct */ "./scripts/Bundles/BundleProduct.ts");
/* harmony import */ var _scripts_Bundles_BundleAddToCart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../scripts/Bundles/BundleAddToCart */ "./scripts/Bundles/BundleAddToCart.ts");
/* harmony import */ var _scripts_Bundles_BundleProductModalTrigger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../scripts/Bundles/BundleProductModalTrigger */ "./scripts/Bundles/BundleProductModalTrigger.ts");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}



var EditionBundles = /*#__PURE__*/function () {
  function EditionBundles() {
    _classCallCheck(this, EditionBundles);
    this.init = this.init.bind(this);
  }
  _createClass(EditionBundles, [{
    key: "init",
    value: function init() {
      customElements.define("edition-bundle-product", _scripts_Bundles_BundleProduct__WEBPACK_IMPORTED_MODULE_0__["default"]);
      customElements.define("edition-productmodal-trigger", _scripts_Bundles_BundleProductModalTrigger__WEBPACK_IMPORTED_MODULE_2__["default"]);
      customElements.define("edition-bundle-atc", _scripts_Bundles_BundleAddToCart__WEBPACK_IMPORTED_MODULE_1__["default"]);
    }
  }]);
  return EditionBundles;
}();


/***/ }),

/***/ "./scripts/ClubBisgaard/ClubBisgaard.ts":
/*!**********************************************!*\
  !*** ./scripts/ClubBisgaard/ClubBisgaard.ts ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ClubBisgaard; }
/* harmony export */ });
/* harmony import */ var _Growave_Growave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Growave/Growave */ "./scripts/ClubBisgaard/Growave/Growave.ts");
/* harmony import */ var _ClubBisgaardContent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ClubBisgaardContent */ "./scripts/ClubBisgaard/ClubBisgaardContent.ts");
/* harmony import */ var _ConfirmationModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ConfirmationModal */ "./scripts/ClubBisgaard/ConfirmationModal.ts");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}



var ClubBisgaard = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ClubBisgaard, _HTMLElement);
  var _super = _createSuper(ClubBisgaard);
  function ClubBisgaard() {
    var _this;
    _classCallCheck(this, ClubBisgaard);
    _this = _super.call(this);
    _this.initClubBisgaardContent = _this.initClubBisgaardContent.bind(_assertThisInitialized(_this));
    _this.initGrowave = _this.initGrowave.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ClubBisgaard, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initClubBisgaardContent();
      this.initGrowave();
      var logout = this.querySelector("a[href='/account/logout']");
      if (logout) {
        logout.addEventListener("click", function () {
          sessionStorage.removeItem("cachedCustomer");
          sessionStorage.removeItem("cachedSpendingRules");
          sessionStorage.removeItem("cachedActiveRewards");
          sessionStorage.removeItem("cachedActivityHistory");
          sessionStorage.removeItem("cachedEarningRules");
        });
      }
      customElements.define("confirmation-modal", _ConfirmationModal__WEBPACK_IMPORTED_MODULE_2__["default"]);
    }
    // initiate the Growave components
  }, {
    key: "initGrowave",
    value: function initGrowave() {
      var growave = new _Growave_Growave__WEBPACK_IMPORTED_MODULE_0__["default"]();
      growave.init();
    }
    // initiate the ClubBisgaard content components
  }, {
    key: "initClubBisgaardContent",
    value: function initClubBisgaardContent() {
      customElements.define("club-bisgaard-content", _ClubBisgaardContent__WEBPACK_IMPORTED_MODULE_1__["default"]);
    }
  }]);
  return ClubBisgaard;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./scripts/ClubBisgaard/ClubBisgaardContent.ts":
/*!*****************************************************!*\
  !*** ./scripts/ClubBisgaard/ClubBisgaardContent.ts ***!
  \*****************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ClubBisgaardContent; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ClubBisgaardContent = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ClubBisgaardContent, _HTMLElement);
  var _super = _createSuper(ClubBisgaardContent);
  function ClubBisgaardContent() {
    var _this;
    _classCallCheck(this, ClubBisgaardContent);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "tabs", Array.from(_this.querySelectorAll("li.club-bisgaard_tab")));
    _defineProperty(_assertThisInitialized(_this), "panels", Array.from(_this.querySelectorAll("div.club-bisgaard_panel")));
    _defineProperty(_assertThisInitialized(_this), "clubTabs", Array.from(_this.querySelectorAll("li.club-bisgaard_tab-club")));
    _defineProperty(_assertThisInitialized(_this), "clubPanels", Array.from(_this.querySelectorAll("div.club-bisgaard_panel-club")));
    _defineProperty(_assertThisInitialized(_this), "rewardsContainer", _this.querySelector("#rewards"));
    _defineProperty(_assertThisInitialized(_this), "rewardsTabs", Array.from(_this.rewardsContainer.querySelectorAll(".club-bisgaard-reward-options a")));
    _this.handleTabClick = _this.handleTabClick.bind(_assertThisInitialized(_this));
    _this.handleClubTabClick = _this.handleClubTabClick.bind(_assertThisInitialized(_this));
    _this.handleRewardTabClick = _this.handleRewardTabClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ClubBisgaardContent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.tabs.forEach(function (tab) {
        tab.addEventListener("click", function (event) {
          event.preventDefault();
          if (tab.dataset.type === "logout") {
            window.location.href = "/account/logout";
          } else {
            _this2.handleTabClick(tab);
          }
        });
      });
      this.clubTabs.forEach(function (tab) {
        tab.addEventListener("click", function (event) {
          event.preventDefault();
          _this2.handleClubTabClick(tab);
        });
      });
      this.rewardsTabs.forEach(function (tab) {
        tab.addEventListener("click", function (event) {
          event.preventDefault();
          _this2.handleRewardTabClick(tab);
        });
      });
    }
  }, {
    key: "handleTabClick",
    value: function handleTabClick(tab) {
      this.tabs.forEach(function (tab) {
        tab.removeAttribute("aria-selected");
      });
      tab.setAttribute("aria-selected", "true");
      var tabType = tab.dataset.type;
      this.panels.forEach(function (panel) {
        panel.dataset.type === tabType ? panel.setAttribute("aria-hidden", "false") : panel.setAttribute("aria-hidden", "true");
      });
    }
  }, {
    key: "handleClubTabClick",
    value: function handleClubTabClick(tab) {
      this.clubTabs.forEach(function (tab) {
        tab.removeAttribute("aria-selected");
      });
      tab.setAttribute("aria-selected", "true");
      var tabType = tab.dataset.type;
      this.clubPanels.forEach(function (panel) {
        panel.dataset.type === tabType ? panel.setAttribute("aria-hidden", "false") : panel.setAttribute("aria-hidden", "true");
      });
    }
  }, {
    key: "handleRewardTabClick",
    value: function handleRewardTabClick(tab) {
      this.rewardsTabs.forEach(function (tab) {
        tab.removeAttribute("aria-selected");
      });
      tab.setAttribute("aria-selected", "true");
      var panels = Array.from(this.rewardsContainer.querySelectorAll(".rewards-tab"));
      panels.forEach(function (panel) {
        panel.setAttribute("aria-hidden", "true");
      });
      var panel = this.rewardsContainer.querySelector("#".concat(tab.dataset.target));
      if (panel) {
        panel.setAttribute("aria-hidden", "false");
      }
    }
  }]);
  return ClubBisgaardContent;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./scripts/ClubBisgaard/ConfirmationModal.ts":
/*!***************************************************!*\
  !*** ./scripts/ClubBisgaard/ConfirmationModal.ts ***!
  \***************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EditionConfirmationModal; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var EditionConfirmationModal = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EditionConfirmationModal, _HTMLElement);
  var _super = _createSuper(EditionConfirmationModal);
  function EditionConfirmationModal() {
    var _this;
    _classCallCheck(this, EditionConfirmationModal);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "loader", _this.querySelector(".club-bisgaard_loader"));
    _defineProperty(_assertThisInitialized(_this), "confirmAction", _this.querySelector("#confirm-action"));
    _defineProperty(_assertThisInitialized(_this), "cancelAction", _this.querySelector("#cancel-action"));
    _defineProperty(_assertThisInitialized(_this), "confirmHandler", void 0);
    _defineProperty(_assertThisInitialized(_this), "cancelHandler", void 0);
    _this.toggleConfirmationBox = _this.toggleConfirmationBox.bind(_assertThisInitialized(_this));
    _this.initActions = _this.initActions.bind(_assertThisInitialized(_this));
    _this.handleConfirm = _this.handleConfirm.bind(_assertThisInitialized(_this));
    _this.handleCancel = _this.handleCancel.bind(_assertThisInitialized(_this));
    _this.removeEventListeners = _this.removeEventListeners.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(EditionConfirmationModal, [{
    key: "connectedCallback",
    value: function connectedCallback() {}
  }, {
    key: "toggleConfirmationBox",
    value: function toggleConfirmationBox() {
      this.classList.toggle("confirmation-box--visible");
    }
  }, {
    key: "initActions",
    value: function initActions(func) {
      var _this2 = this;
      this.confirmHandler = function (event) {
        event.preventDefault();
        _this2.handleConfirm(func);
      };
      this.cancelHandler = function (event) {
        event.preventDefault();
        _this2.handleCancel();
      };
      this.confirmAction.addEventListener("click", this.confirmHandler);
      this.cancelAction.addEventListener("click", this.cancelHandler);
    }
  }, {
    key: "handleConfirm",
    value: function () {
      var _handleConfirm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(func) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              this.loader.style.display = "block";
              _context.next = 4;
              return func();
            case 4:
              this.loader.style.display = "none";
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error("Error", _context.t0);
            case 10:
              _context.prev = 10;
              this.toggleConfirmationBox();
              return _context.finish(10);
            case 13:
              // remove the event listener
              this.removeEventListeners();
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 7, 10, 13]]);
      }));
      function handleConfirm(_x) {
        return _handleConfirm.apply(this, arguments);
      }
      return handleConfirm;
    }()
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      this.toggleConfirmationBox();
      this.removeEventListeners();
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      this.confirmAction.removeEventListener("click", this.confirmHandler);
      this.cancelAction.removeEventListener("click", this.cancelHandler);
    }
  }]);
  return EditionConfirmationModal;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./scripts/ClubBisgaard/Growave/Growave.ts":
/*!*************************************************!*\
  !*** ./scripts/ClubBisgaard/Growave/Growave.ts ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EditionGrowave; }
/* harmony export */ });
/* harmony import */ var _GrowaveGetCustomer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./GrowaveGetCustomer */ "./scripts/ClubBisgaard/Growave/GrowaveGetCustomer.ts");
/* harmony import */ var _GrowaveGetEarningRules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./GrowaveGetEarningRules */ "./scripts/ClubBisgaard/Growave/GrowaveGetEarningRules.ts");
/* harmony import */ var _GrowaveGetSpendingRules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./GrowaveGetSpendingRules */ "./scripts/ClubBisgaard/Growave/GrowaveGetSpendingRules.ts");
/* harmony import */ var _GrowaveGetCustomerActiveRewards__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./GrowaveGetCustomerActiveRewards */ "./scripts/ClubBisgaard/Growave/GrowaveGetCustomerActiveRewards.ts");
/* harmony import */ var _GrowaveGetCustomerActivityHistory__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./GrowaveGetCustomerActivityHistory */ "./scripts/ClubBisgaard/Growave/GrowaveGetCustomerActivityHistory.ts");
/* harmony import */ var _GrowaveGetCustomerWishlists__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./GrowaveGetCustomerWishlists */ "./scripts/ClubBisgaard/Growave/GrowaveGetCustomerWishlists.ts");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
// Initiate all growave components into one class






var EditionGrowave = /*#__PURE__*/function () {
  function EditionGrowave() {
    _classCallCheck(this, EditionGrowave);
    this.init = this.init.bind(this);
    this.initComponents = this.initComponents.bind(this);
  }
  _createClass(EditionGrowave, [{
    key: "init",
    value: function init() {
      var _this = this;
      var getGrowaveCustomer = new _GrowaveGetCustomer__WEBPACK_IMPORTED_MODULE_0__["default"]();
      getGrowaveCustomer.init();
      // check if the customer data is already cached if it is not then wait for the customerDataFetched event
      if (sessionStorage.getItem("cachedCustomer")) {
        this.initComponents();
      } else {
        document.addEventListener("customerDataFetched", function () {
          _this.initComponents();
        });
      }
    }
  }, {
    key: "initComponents",
    value: function initComponents() {
      var getGrowaveEarningRules = new _GrowaveGetEarningRules__WEBPACK_IMPORTED_MODULE_1__["default"]();
      getGrowaveEarningRules.init();
      var getGrowaveSpendingRules = new _GrowaveGetSpendingRules__WEBPACK_IMPORTED_MODULE_2__["default"]();
      getGrowaveSpendingRules.init();
      var getGrowaveActiveRewards = new _GrowaveGetCustomerActiveRewards__WEBPACK_IMPORTED_MODULE_3__["default"]();
      getGrowaveActiveRewards.init();
      var getGrowaveCustomerWishlists = new _GrowaveGetCustomerWishlists__WEBPACK_IMPORTED_MODULE_5__["default"]();
      getGrowaveCustomerWishlists.init();
      var getGrowaveCustomerActivityHistory = new _GrowaveGetCustomerActivityHistory__WEBPACK_IMPORTED_MODULE_4__["default"]();
      getGrowaveCustomerActivityHistory.init();
    }
  }]);
  return EditionGrowave;
}();


/***/ }),

/***/ "./scripts/ClubBisgaard/Growave/GrowaveGetCustomer.ts":
/*!************************************************************!*\
  !*** ./scripts/ClubBisgaard/Growave/GrowaveGetCustomer.ts ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EditionGrowaveGetCustomer; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var EditionGrowaveGetCustomer = /*#__PURE__*/function () {
  function EditionGrowaveGetCustomer() {
    _classCallCheck(this, EditionGrowaveGetCustomer);
    _defineProperty(this, "clubBisgaard", document.querySelector("club-bisgaard"));
    _defineProperty(this, "customerId", this.clubBisgaard.dataset.customerid);
    _defineProperty(this, "loader", this.clubBisgaard.querySelector(".club-bisgaard_loader"));
    this.init = this.init.bind(this);
    this.getCustomer = this.getCustomer.bind(this);
    this.displayCustomerData = this.displayCustomerData.bind(this);
  }
  _createClass(EditionGrowaveGetCustomer, [{
    key: "init",
    value: function init() {
      var _this = this;
      // check if the customer data is already cached
      var cachedCustomer = sessionStorage.getItem("cachedCustomer");
      if (!cachedCustomer) {
        this.getCustomer(this.customerId);
      } else {
        var customer = JSON.parse(cachedCustomer);
        this.displayCustomerData(customer);
      }
      document.addEventListener("customerUpdated", function (event) {
        _this.getCustomer(_this.customerId);
      });
    }
  }, {
    key: "getCustomer",
    value: function () {
      var _getCustomer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var customeridParam, response, data, customer;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              customeridParam = "customerid=".concat(id);
              _context.next = 4;
              return fetch("https://club-bisgaard.vercel.app/apiv1/get-customer?".concat(customeridParam), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json"
                }
              });
            case 4:
              response = _context.sent;
              if (!response.ok) {
                _context.next = 14;
                break;
              }
              _context.next = 8;
              return response.json();
            case 8:
              data = _context.sent;
              customer = data;
              this.displayCustomerData(customer);
              sessionStorage.setItem("cachedCustomer", JSON.stringify(customer));
              _context.next = 16;
              break;
            case 14:
              console.error("HTTP-Error: " + response.status);
              this.loader.style.display = "none";
            case 16:
              _context.next = 22;
              break;
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
              this.loader.style.display = "none";
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 18]]);
      }));
      function getCustomer(_x) {
        return _getCustomer.apply(this, arguments);
      }
      return getCustomer;
    }()
  }, {
    key: "displayCustomerData",
    value: function () {
      var _displayCustomerData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(customer) {
        var pointsBalance, pointsIndicator, birthday, acceptsEmailMarketing;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.loader.style.display = "block";
              try {
                pointsBalance = customer.pointsBalance === 0 ? "0" : customer.pointsBalance.toString();
                pointsIndicator = this.clubBisgaard.querySelector("#points_balance");
                if (pointsIndicator && pointsBalance) {
                  // Replace dot with comma in pointsBalance if present
                  pointsBalance = pointsBalance.replace(".", ",");
                  // If pointsBalance is not null, the customer has redeemed points.
                  // Subtract the redeemed points from the current points balance.
                  pointsIndicator.innerHTML = pointsBalance;
                  pointsIndicator.dataset.points = pointsBalance;
                  localStorage.setItem("customerPoints", pointsBalance);
                  document.dispatchEvent(new CustomEvent("customerDataFetched"));
                }
                // Set birthday attribute if the customer has a birthday set
                birthday = customer.birthday;
                if (birthday !== null && birthday !== void 0 ? birthday : false) {
                  this.clubBisgaard.setAttribute("data-birthday", birthday);
                }
                // Set email marketing attribute if the customer has accepted email marketing
                acceptsEmailMarketing = customer.acceptsEmailMarketing;
                if (acceptsEmailMarketing !== null && acceptsEmailMarketing !== void 0 ? acceptsEmailMarketing : false) {
                  this.clubBisgaard.setAttribute("data-marketing", "true");
                }
              } catch (error) {
                console.error(error);
              } finally {
                this.loader.style.display = "none";
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function displayCustomerData(_x2) {
        return _displayCustomerData.apply(this, arguments);
      }
      return displayCustomerData;
    }()
  }]);
  return EditionGrowaveGetCustomer;
}();


/***/ }),

/***/ "./scripts/ClubBisgaard/Growave/GrowaveGetCustomerActiveRewards.ts":
/*!*************************************************************************!*\
  !*** ./scripts/ClubBisgaard/Growave/GrowaveGetCustomerActiveRewards.ts ***!
  \*************************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EditionGrowaveGetCustomerActiveRewards; }
/* harmony export */ });
/* harmony import */ var _utils_Animations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/Animations */ "./scripts/utils/Animations.ts");
/* harmony import */ var _utils_CartApiEndpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils/CartApiEndpoints */ "./scripts/utils/CartApiEndpoints.ts");
/* harmony import */ var _utils_DiscountCode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/DiscountCode */ "./scripts/utils/DiscountCode.ts");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}



var EditionGrowaveGetCustomerActiveRewards = /*#__PURE__*/function () {
  function EditionGrowaveGetCustomerActiveRewards() {
    _classCallCheck(this, EditionGrowaveGetCustomerActiveRewards);
    _defineProperty(this, "clubBisgaard", document.querySelector("club-bisgaard"));
    _defineProperty(this, "customerId", this.clubBisgaard.dataset.customerid);
    _defineProperty(this, "loader", this.clubBisgaard.querySelector(".club-bisgaard_loader"));
    _defineProperty(this, "rewardsSelector", document.querySelector("#rewards"));
    _defineProperty(this, "confirmationModal", document.querySelector("confirmation-modal"));
    this.init = this.init.bind(this);
    this.getActiveRewards = this.getActiveRewards.bind(this);
    this.displayActiveRewards = this.displayActiveRewards.bind(this);
  }
  _createClass(EditionGrowaveGetCustomerActiveRewards, [{
    key: "init",
    value: function init() {
      var _this = this;
      // check if the active rewards are already cached
      var cachedActiveRewards = sessionStorage.getItem("cachedActiveRewards");
      if (!cachedActiveRewards) {
        this.getActiveRewards(this.customerId);
      } else {
        var activeRewards = JSON.parse(cachedActiveRewards);
        this.displayActiveRewards(activeRewards);
      }
      document.addEventListener("customerUpdated", function (event) {
        setTimeout(function () {
          _this.getActiveRewards(_this.customerId);
        }, 1500);
      });
    }
    // Get active rewards for the customer
  }, {
    key: "getActiveRewards",
    value: function () {
      var _getActiveRewards = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var customeridParam, response, data, activeRewards;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              this.loader.style.display = "block";
              customeridParam = "customerid=".concat(id);
              _context.next = 5;
              return fetch("https://club-bisgaard.vercel.app/apiv1/get-active-rewards?".concat(customeridParam), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json"
                }
              });
            case 5:
              response = _context.sent;
              if (!response.ok) {
                _context.next = 15;
                break;
              }
              _context.next = 9;
              return response.json();
            case 9:
              data = _context.sent;
              activeRewards = data.rewards;
              this.displayActiveRewards(activeRewards);
              sessionStorage.setItem("cachedActiveRewards", JSON.stringify(activeRewards));
              _context.next = 16;
              break;
            case 15:
              console.error("HTTP-Error: " + response.status);
            case 16:
              _context.next = 21;
              break;
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 21:
              _context.prev = 21;
              this.loader.style.display = "none";
              return _context.finish(21);
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 18, 21, 24]]);
      }));
      function getActiveRewards(_x) {
        return _getActiveRewards.apply(this, arguments);
      }
      return getActiveRewards;
    }()
  }, {
    key: "displayActiveRewards",
    value: function displayActiveRewards(rewards) {
      var _this2 = this;
      var pointsBalancesStorage = localStorage.getItem("customerPoints");
      var pointsBalance = Number(pointsBalancesStorage);
      // create active rewards selector for outputting the different active rewards
      var activeRewardsSelector = this.rewardsSelector.querySelector("#active-rewards");
      if (rewards.length === 0) {
        activeRewardsSelector.innerHTML = "Du har ikke brugt nogle point på belønninger endnu.";
        return;
      } else {
        activeRewardsSelector.innerHTML = "";
        var activeRewardsList = document.createElement("ul");
        activeRewardsList.classList.add("spending-rules-grid");
        rewards.forEach(function (reward) {
          var rewardItem = document.createElement("li");
          // set iconSrc based on the reward type
          var iconSrc, redeemRewardEle;
          if (reward.reward.type === "free_product") {
            iconSrc = reward.reward.productImage;
          } else if (reward.spendingRule.icon) {
            iconSrc = reward.spendingRule.icon;
          } else {
            iconSrc = "https://imgs.growave.io/qEMxIUmtCekFAGNHHuaYTghtUYzUdZAg-SD-DK6y_DY/rot:0/q:80/rs:auto:40:40/aHR0cHM6Ly9zc3dmaWxlcy5zMy5hbWF6b25hd3MuY29tL2NsaWVudDEzMzM2My9yZXdhcmRzLzY2ODI2YzZkMThjMmJfNjVkZjI5ZmE5OWI0ZV9kaXNjb3VudDEucG5n";
          }
          // set the custom element to redeem the reward
          if (reward.reward.type === "free_product") {
            redeemRewardEle = "<a class=\"club-bisgaard_primary-btn\" hred=\"#\" data-variantid=\"".concat(reward.reward.variantId, "\" data-discountcode=\"").concat(reward.reward.discountCode, "\">Brug bel\xF8nning</a>");
          } else {
            redeemRewardEle = "<a class=\"club-bisgaard_primary-btn\" ref=\"#\" data-discountcode=\"".concat(reward.reward.discountCode, "\">Brug bel\xF8nning</a>");
          }
          // Create the reward item for the active rewards list
          rewardItem.innerHTML = "\n          <div class=\"rule-icon\">\n            <img src=\"".concat(iconSrc, "\"\n                alt=\"").concat(reward.spendingRule.title, "\"/>\n          </div>\n          <div>\n            <p class=\"rule-title\">").concat(reward.spendingRule.title, "</p>\n          </div>\n          <div>\n            <p class=\"rule-points tw-flex tw-flex-col\">\n            <span>Rabatkode</span>\n              ").concat(reward.reward.discountCode, "\n            </p>\n          </div>\n          <div class=\"tw-mt-auto\">\n            ").concat(redeemRewardEle, "\n          </div>\n\t\t    ");
          activeRewardsList.appendChild(rewardItem);
          rewardItem.querySelector(".club-bisgaard_primary-btn").addEventListener("click", function (event) {
            event.preventDefault();
            _this2.confirmationModal.toggleConfirmationBox();
            _this2.confirmationModal.initActions(function () {
              return _this2.redeemReward(event.target);
            });
          });
        });
        activeRewardsSelector.appendChild(activeRewardsList);
        // fade elements in
        Array.from(activeRewardsList.children).forEach(function (child, index) {
          (0,_utils_Animations__WEBPACK_IMPORTED_MODULE_0__.fadeUp)(child, index, 750, 100);
        });
      }
    }
  }, {
    key: "redeemReward",
    value: function redeemReward(target) {
      var discountCode = target.dataset.discountcode;
      var variantId = target.dataset.variantid;
      if (variantId) {
        (0,_utils_CartApiEndpoints__WEBPACK_IMPORTED_MODULE_1__.addVariantToCart)(variantId);
      }
      if (discountCode) {
        (0,_utils_DiscountCode__WEBPACK_IMPORTED_MODULE_2__.fetchDiscountCode)(discountCode);
      }
    }
  }]);
  return EditionGrowaveGetCustomerActiveRewards;
}();


/***/ }),

/***/ "./scripts/ClubBisgaard/Growave/GrowaveGetCustomerActivityHistory.ts":
/*!***************************************************************************!*\
  !*** ./scripts/ClubBisgaard/Growave/GrowaveGetCustomerActivityHistory.ts ***!
  \***************************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EditionGrowaveGetCustomerActivityHistory; }
/* harmony export */ });
/* harmony import */ var _utils_Animations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/Animations */ "./scripts/utils/Animations.ts");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

var EditionGrowaveGetCustomerActivityHistory = /*#__PURE__*/function () {
  function EditionGrowaveGetCustomerActivityHistory() {
    _classCallCheck(this, EditionGrowaveGetCustomerActivityHistory);
    _defineProperty(this, "actvititySelector", document.querySelector("#history"));
    _defineProperty(this, "activityHistorySet", false);
    _defineProperty(this, "clubBisgaard", document.querySelector("club-bisgaard"));
    _defineProperty(this, "customerId", this.clubBisgaard.dataset.customerid);
    _defineProperty(this, "loader", this.clubBisgaard.querySelector(".club-bisgaard_loader"));
    this.init = this.init.bind(this);
    this.getCustomerActivityHistory = this.getCustomerActivityHistory.bind(this);
    this.displayCustomerActivityHistory = this.displayCustomerActivityHistory.bind(this);
  }
  _createClass(EditionGrowaveGetCustomerActivityHistory, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Get activity history when the history tab is selected.
      // If the activity history has already been set, don't fetch it again.
      var activityHisotryTab = document.querySelector("li.club-bisgaard_tab-club[data-type='history']");
      activityHisotryTab.addEventListener("click", function () {
        if (_this.activityHistorySet === false) {
          _this.loader.style.display = "block";
          // check if the activity history is already cached
          var cachedActivityHistory = sessionStorage.getItem("cachedActivityHistory");
          if (!cachedActivityHistory) {
            _this.getCustomerActivityHistory(_this.customerId);
          } else {
            var activityHistory = JSON.parse(cachedActivityHistory);
            _this.displayCustomerActivityHistory(activityHistory);
          }
          _this.activityHistorySet = true;
        }
      });
      document.addEventListener("customerUpdated", function (event) {
        setTimeout(function () {
          _this.getCustomerActivityHistory(_this.customerId);
        }, 2500);
      });
    }
  }, {
    key: "getCustomerActivityHistory",
    value: function () {
      var _getCustomerActivityHistory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var customeridParam, response, data, activties;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              customeridParam = "customerid=".concat(id);
              _context.next = 4;
              return fetch("https://club-bisgaard.vercel.app/apiv1/get-customer-activity-history?".concat(customeridParam), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json"
                }
              });
            case 4:
              response = _context.sent;
              if (!response.ok) {
                _context.next = 14;
                break;
              }
              _context.next = 8;
              return response.json();
            case 8:
              data = _context.sent;
              activties = data.activities;
              this.displayCustomerActivityHistory(activties);
              sessionStorage.setItem("cachedActivityHistory", JSON.stringify(activties));
              _context.next = 15;
              break;
            case 14:
              console.error("HTTP-Error: " + response.status);
            case 15:
              _context.next = 20;
              break;
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 17]]);
      }));
      function getCustomerActivityHistory(_x) {
        return _getCustomerActivityHistory.apply(this, arguments);
      }
      return getCustomerActivityHistory;
    }()
  }, {
    key: "displayCustomerActivityHistory",
    value: function displayCustomerActivityHistory(activities) {
      if (activities.length === 0) {
        this.actvititySelector.innerHTML = "Ingen aktiviteter fundet.";
        this.loader.style.display = "none";
        return;
      } else {
        var activityList = document.createElement("ul");
        console.log(activities);
        activities.forEach(function (activity) {
          if (activity.type === "reward" || activity.type === "refund" || activity.type === "redeem" || activity.type === "manual") {
            var activityItem = document.createElement("li");
            activityItem.classList.add("activity-item");
            var title, points, date;
            if (activity.type === "reward") {
              title = activity.earningRule.title;
              points = "+ ".concat(activity.reward.points);
            } else if (activity.type === "refund") {
              title = "".concat(activity.refundedActivity.earningRule.title, " (refunderet)");
              points = "- ".concat(activity.refundedActivity.reward.points);
            } else if (activity.type === "redeem") {
              title = activity.spendingRule.title;
              points = "- ".concat(activity.spentPoints);
            } else if (activity.type === "manual") {
              title = "Manual Activity";
              points = activity.points;
            }
            date = activity.createdAt;
            var dateOptions = {
              year: "numeric",
              month: "numeric",
              day: "numeric"
            };
            date = new Date(date).toLocaleDateString("da-DK", dateOptions);
            activityItem.innerHTML = "\n            <div class=\"activity-title\">\n              ".concat(title, "\n            </div>\n            <div class=\"activity-points\">\n              ").concat(points, " point\n            </div>\n            <div class=\"activity-date\">\n              ").concat(date, "\n            </div>\n          ");
            activityList.appendChild(activityItem);
          }
        });
        this.actvititySelector.appendChild(activityList);
        // fade elements in
        Array.from(activityList.children).forEach(function (child, index) {
          (0,_utils_Animations__WEBPACK_IMPORTED_MODULE_0__.fadeUp)(child, index, 750, 50);
        });
      }
      this.loader.style.display = "none";
    }
  }]);
  return EditionGrowaveGetCustomerActivityHistory;
}();


/***/ }),

/***/ "./scripts/ClubBisgaard/Growave/GrowaveGetCustomerWishlists.ts":
/*!*********************************************************************!*\
  !*** ./scripts/ClubBisgaard/Growave/GrowaveGetCustomerWishlists.ts ***!
  \*********************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EditionGrowaveGetCustomerWishlists; }
/* harmony export */ });
/* harmony import */ var _GrowaveWishlistActionsBtn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./GrowaveWishlistActionsBtn */ "./scripts/ClubBisgaard/Growave/GrowaveWishlistActionsBtn.ts");
/* harmony import */ var _GrowaveWishlistCreateBtn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./GrowaveWishlistCreateBtn */ "./scripts/ClubBisgaard/Growave/GrowaveWishlistCreateBtn.ts");
/* harmony import */ var _utils_ProductApiEndpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/ProductApiEndpoints */ "./scripts/utils/ProductApiEndpoints.ts");
/* harmony import */ var _utils_Animations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/Animations */ "./scripts/utils/Animations.ts");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}




var EditionGrowaveGetCustomerWishlists = /*#__PURE__*/function () {
  function EditionGrowaveGetCustomerWishlists() {
    _classCallCheck(this, EditionGrowaveGetCustomerWishlists);
    _defineProperty(this, "clubBisgaard", document.querySelector("club-bisgaard"));
    _defineProperty(this, "customerId", this.clubBisgaard.dataset.customerid);
    _defineProperty(this, "loader", this.clubBisgaard.querySelector(".club-bisgaard_loader"));
    _defineProperty(this, "wishlistsSet", false);
    _defineProperty(this, "wishlistSelector", document.querySelector("#club-bisgaard_wishlist-lists"));
    _defineProperty(this, "confirmationModal", document.querySelector("confirmation-modal"));
    this.init = this.init.bind(this);
    this.getWishlists = this.getWishlists.bind(this);
    this.displayWishlists = this.displayWishlists.bind(this);
    this.unfavoriteProduct = this.unfavoriteProduct.bind(this);
    this.shareWishlist = this.shareWishlist.bind(this);
    customElements.define("wishlist-actions-btn", _GrowaveWishlistActionsBtn__WEBPACK_IMPORTED_MODULE_0__["default"]);
    customElements.define("wishlist-create-btn", _GrowaveWishlistCreateBtn__WEBPACK_IMPORTED_MODULE_1__["default"]);
  }
  _createClass(EditionGrowaveGetCustomerWishlists, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Get wishlists when the wishlsit tab is selected.
      // If the wishlists has already been set, don't fetch it again.
      var wishlistsTab = document.querySelector("li.club-bisgaard_li.club-bisgaard_tab[data-type='wishlist']");
      wishlistsTab.addEventListener("click", function () {
        if (_this.wishlistsSet === false) {
          _this.loader.style.display = "block";
          _this.getWishlists(_this.customerId);
          _this.wishlistsSet = true;
        }
        // Add event listeners to the share buttons
        var shareBtns = Array.from(document.querySelectorAll(".wishlist-share-btn"));
        shareBtns.forEach(function (btn) {
          btn.addEventListener("click", function (event) {
            event.preventDefault();
            var growaveCustomerid = _this.clubBisgaard.dataset.growavecustomerid;
            var media = btn.dataset.media;
            _this.shareWishlist(growaveCustomerid, media);
          });
        });
      });
      // Listen for the wishlist-created event to update the wishlists
      document.addEventListener("wishlist-created", function () {
        _this.loader.style.display = "block";
        _this.getWishlists(_this.customerId);
      });
    }
  }, {
    key: "getWishlists",
    value: function () {
      var _getWishlists = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var customeridParam, response, data, wishlists;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              customeridParam = "customerid=".concat(id);
              _context.next = 4;
              return fetch("https://club-bisgaard.vercel.app/apiv1/get-customer-wishlists?".concat(customeridParam), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json"
                }
              });
            case 4:
              response = _context.sent;
              if (!response.ok) {
                _context.next = 13;
                break;
              }
              _context.next = 8;
              return response.json();
            case 8:
              data = _context.sent;
              wishlists = data.wishlists;
              this.displayWishlists(wishlists);
              _context.next = 14;
              break;
            case 13:
              console.error("HTTP-Error: " + response.status);
            case 14:
              _context.next = 19;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 16]]);
      }));
      function getWishlists(_x) {
        return _getWishlists.apply(this, arguments);
      }
      return getWishlists;
    }()
  }, {
    key: "displayWishlists",
    value: function displayWishlists(wishlists) {
      var _this2 = this;
      if (wishlists.length === 0) {
        this.wishlistSelector.innerHTML = "Ingen ønskesedler fundet.";
        this.loader.style.display = "none";
        return;
      } else {
        this.wishlistSelector.innerHTML = "";
        wishlists.forEach( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(wishlist) {
            var wistlistItemsHtml, handles, productsInfo, wishlistProductsInfo, wishlistItem, chevronDown, unfavoriteBtns;
            return _regeneratorRuntime().wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  _this2.clubBisgaard.dataset.growavecustomerid = wishlist.customer.shopifyCustomerId.toString();
                  if (!(wishlist.items.length === 0)) {
                    _context4.next = 5;
                    break;
                  }
                  wistlistItemsHtml = "<p>Denne ønskeseddel er tom.</p>";
                  _context4.next = 11;
                  break;
                case 5:
                  // Get the products in the wishlist by fetching the products from the restapi. We use the product ids in the wishlist items to get the products.
                  handles = wishlist.items.map(function (item) {
                    return item.product.handle;
                  });
                  _context4.next = 8;
                  return Promise.all(handles.map( /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(handle) {
                      var productInfo;
                      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                        while (1) switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return (0,_utils_ProductApiEndpoints__WEBPACK_IMPORTED_MODULE_2__.getProduct)(handle);
                          case 2:
                            productInfo = _context2.sent;
                            return _context2.abrupt("return", productInfo);
                          case 4:
                          case "end":
                            return _context2.stop();
                        }
                      }, _callee2);
                    }));
                    return function (_x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }()));
                case 8:
                  productsInfo = _context4.sent;
                  // Filter the products in the wishlist items, so we only get the variants of the products that are in the wishlist.
                  // We also add the product image and handle to the variant object.
                  wishlistProductsInfo = productsInfo.map(function (product) {
                    var filteredVariants = product.variants.filter(function (variant) {
                      return wishlist.items.some(function (item) {
                        return item.product.variantId === variant.id;
                      });
                    }).map(function (variant) {
                      return _objectSpread(_objectSpread({}, variant), {}, {
                        productImage: product.image,
                        productHandle: product.handle,
                        productTitle: product.title
                      });
                    });
                    return filteredVariants;
                  }).flat();
                  wistlistItemsHtml = "\n            ".concat(wishlistProductsInfo.map(function (item) {
                    return "\n                <div class=\"wishlist-item-product-wrapper\">\n                  <a href=\"/products/".concat(item.productHandle, "?variant=").concat(item.id, "\" class=\"wishlist-item-product-link\">\n                    <div class=\"wishlist-item-product-img\">\n                      <img src=\"").concat(item.productImage.src, "\" alt=\"").concat(item.title, "\">\n                    </div>\n                    <div class=\"wishlist-item-product-info\">\n                      <p class=\"club-bisgaard_extra-small-heading\">\n                      ").concat(item.productTitle.replace("Bisgaard ", "").replace("bisgaard ", ""), "\n                      </p>\n                      <p class=\"club-bisgaard_extra-small-heading\">\n                        ").concat(item.price, " DKK\n                      </p>\n                    </div>\n                  </a>\n                  <div class=\"wishlist-item-unfavorite\" data-productid=\"").concat(item.product_id, "\">\n                  <svg viewBox=\"0 -1 32 32\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\" fill=\"#90786b\" stroke=\"#90786b\"><g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\"></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></g><g id=\"SVGRepo_iconCarrier\"> <defs> </defs> <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\"> <g id=\"Icon-Set-Filled\" sketch:type=\"MSLayerGroup\" transform=\"translate(-102.000000, -882.000000)\" fill=\"#90786b\"> <path d=\"M126,882 C122.667,882 119.982,883.842 117.969,886.235 C116.013,883.76 113.333,882 110,882 C105.306,882 102,886.036 102,890.438 C102,892.799 102.967,894.499 104.026,896.097 L116.459,911.003 C117.854,912.312 118.118,912.312 119.513,911.003 L131.974,896.097 C133.22,894.499 134,892.799 134,890.438 C134,886.036 130.694,882 126,882\" id=\"heart-like\" sketch:type=\"MSShapeGroup\"> </path> </g> </g> </g></svg>\n                  </div>\n                </div>\n              ");
                  }).join(""), "\n          ");
                case 11:
                  wishlistItem = document.createElement("div");
                  wishlistItem.classList.add("club-bisgaard_wishlist-item");
                  wishlistItem.setAttribute("aria-hidden", "false");
                  wishlistItem.setAttribute("data-wishlistid", wishlist.wishlistId.toString());
                  wishlistItem.setAttribute("data-growavecustomerid", wishlist.customer.shopifyCustomerId.toString());
                  wishlistItem.innerHTML = "\n          <div class=\"club-bisgaard_wishlist-item-header\">\n            <div class=\"club-bisgaard_wishlist-item-header_title\">\n              <svg fill=\"#90786b\" height=\"14px\" width=\"14px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 407.437 407.437\" xml:space=\"preserve\"><g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\"></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></g><g id=\"SVGRepo_iconCarrier\"> <polygon points=\"386.258,91.567 203.718,273.512 21.179,91.567 0,112.815 203.718,315.87 407.437,112.815 \"></polygon> </g></svg>\n              <h4 class=\"club-bisgaard_extra-small-heading\">".concat(wishlist.wishlistTitle, "</h4>\n              <h4 class=\"wishlist-item-counter club-bisgaard_extra-small-heading\" data-itemscount=\"").concat(wishlist.items.length, "\">").concat(wishlist.items.length, "</h4>\n            </div>\n            <div class=\"club-bisgaard_wishlist-item-header_actions\">\n              <wishlist-actions-btn class=\"club-bisgaard_medium-heading\" href=\"#\">\n              ...\n              </wishlist-actions-btn>\n              <div class=\"club-bisgaard_wishlist-item-header_actions-dropdown\" aria-hidden=\"true\">\n                <a data-wishlistid=\"").concat(wishlist.wishlistId, "\" class=\"rename-wishlist\"href=\"#\">Omd\xF8b</a>\n                <a data-wishlistid=\"").concat(wishlist.wishlistId, "\" class=\"delete-wishlist\"href=\"#\">Slet</a>\n              </div>\n            </div>\n          </div>\n          <div class=\"club-bisgaard_wishlist-item-products-grid\">\n            ").concat(wistlistItemsHtml, "\n          </div>\n        ");
                  // fade in the wishlist item
                  _this2.wishlistSelector.appendChild(wishlistItem);
                  Array.from(wishlistItem.querySelectorAll(".wishlist-item-product-wrapper")).forEach(function (child, index) {
                    (0,_utils_Animations__WEBPACK_IMPORTED_MODULE_3__.fadeIn)(child, index, 750, 50);
                  });
                  // Add event listener to the dropdown chevron
                  chevronDown = wishlistItem.querySelector("svg");
                  chevronDown.addEventListener("click", function () {
                    wishlistItem.getAttribute("aria-hidden") === "false" ? wishlistItem.setAttribute("aria-hidden", "true") : wishlistItem.setAttribute("aria-hidden", "false");
                  });
                  // Add event listener to the unfavorite button
                  unfavoriteBtns = Array.from(wishlistItem.querySelectorAll(".wishlist-item-unfavorite"));
                  unfavoriteBtns.forEach(function (btn) {
                    btn.addEventListener("click", /*#__PURE__*/function () {
                      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(event) {
                        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                          while (1) switch (_context3.prev = _context3.next) {
                            case 0:
                              event.preventDefault();
                              _this2.confirmationModal.toggleConfirmationBox();
                              _this2.confirmationModal.initActions(function () {
                                return _this2.unfavoriteProduct(btn);
                              });
                            case 3:
                            case "end":
                              return _context3.stop();
                          }
                        }, _callee3);
                      }));
                      return function (_x4) {
                        return _ref3.apply(this, arguments);
                      };
                    }());
                  });
                case 23:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }));
          return function (_x2) {
            return _ref.apply(this, arguments);
          };
        }());
        this.loader.style.display = "none";
      }
    }
  }, {
    key: "unfavoriteProduct",
    value: function () {
      var _unfavoriteProduct = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(target) {
        var productId, response, wishlistItemProduct, counter, currentCount, newCount;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              productId = target.dataset.productid;
              if (!productId) {
                _context5.next = 7;
                break;
              }
              _context5.next = 5;
              return fetch("https://club-bisgaard.vercel.app/apiv1/wishlist-unfavorite-product", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  customerid: this.customerId,
                  productid: Number(productId)
                })
              });
            case 5:
              response = _context5.sent;
              // If the response i ok, we remove the product from the wishlist and update the counter
              if (response.ok) {
                wishlistItemProduct = target.closest(".wishlist-item-product-wrapper");
                counter = target.closest(".club-bisgaard_wishlist-item").querySelector(".wishlist-item-counter");
                currentCount = Number(counter.dataset.itemscount);
                newCount = (currentCount - 1).toString();
                counter.dataset.itemscount = newCount;
                counter.textContent = newCount;
                wishlistItemProduct.remove();
              }
            case 7:
              _context5.next = 12;
              break;
            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](0);
              console.error("Error", _context5.t0);
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 9]]);
      }));
      function unfavoriteProduct(_x5) {
        return _unfavoriteProduct.apply(this, arguments);
      }
      return unfavoriteProduct;
    }()
  }, {
    key: "shareWishlist",
    value: function shareWishlist(growaveCustomerid, media) {
      var shareLink, shareSite, shareUrl, shareTitle, shareText;
      if (media === "facebook") {
        shareSite = "https://www.facebook.com/sharer/sharer.php";
        shareUrl = "?u=https://bisgaardshoes.dk/pages/wishlist?from_user_id=".concat(growaveCustomerid);
        shareTitle = "&p[title]=Se+min+ønskeseddel";
        shareLink = "".concat(shareSite).concat(shareUrl).concat(shareTitle);
      } else if (media === "x") {
        shareSite = "https://www.x.com/share";
        shareText = "?text=Se+min+ønskeseddel";
        shareUrl = "&url=https://bisgaardshoes.dk/pages/wishlist?from_user_id=".concat(growaveCustomerid);
        shareLink = "".concat(shareSite).concat(shareText).concat(shareUrl);
      } else if (media === "pinterest") {
        shareSite = "https://pinterest.com/pin/create/button/";
        shareUrl = "?url=https://bisgaardshoes.dk/pages/wishlist?from_user_id=".concat(growaveCustomerid);
        shareText = "&description=Se+min+ønskeseddel";
        shareLink = "".concat(shareSite).concat(shareUrl).concat(shareText);
      } else if (media === "mail") {
        var mailBody = encodeURIComponent("https://bisgaardshoes.dk/pages/wishlist?from_user_id=".concat(growaveCustomerid));
        var mailtoLink = "mailto:?body=".concat(mailBody);
        shareLink = mailtoLink;
      }
      if (shareLink) {
        window.open(shareLink, "_blank");
      }
    }
  }]);
  return EditionGrowaveGetCustomerWishlists;
}();


/***/ }),

/***/ "./scripts/ClubBisgaard/Growave/GrowaveGetEarningRules.ts":
/*!****************************************************************!*\
  !*** ./scripts/ClubBisgaard/Growave/GrowaveGetEarningRules.ts ***!
  \****************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EditionGrowaveGetEarningRules; }
/* harmony export */ });
/* harmony import */ var _utils_Animations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/Animations */ "./scripts/utils/Animations.ts");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

var EditionGrowaveGetEarningRules = /*#__PURE__*/function () {
  function EditionGrowaveGetEarningRules() {
    _classCallCheck(this, EditionGrowaveGetEarningRules);
    _defineProperty(this, "earningRulesSelector", document.querySelector("#points"));
    _defineProperty(this, "earningRulesSet", false);
    _defineProperty(this, "clubBisgaard", document.querySelector("club-bisgaard"));
    _defineProperty(this, "customerId", this.clubBisgaard.dataset.customerid);
    _defineProperty(this, "loader", this.clubBisgaard.querySelector(".club-bisgaard_loader"));
    this.init = this.init.bind(this);
    this.getEarningRules = this.getEarningRules.bind(this);
    this.displayEarningRules = this.displayEarningRules.bind(this);
  }
  _createClass(EditionGrowaveGetEarningRules, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Get earning rules when the earning rules tab is selected.
      // If the earning rules have already been set, don't fetch them again.
      var earningRulesTab = document.querySelector("li.club-bisgaard_tab-club[data-type='points']");
      earningRulesTab.addEventListener("click", function () {
        if (_this.earningRulesSet === false) {
          _this.loader.style.display = "block";
          // check if the earning rules are already cached
          var cachedEarningRules = sessionStorage.getItem("cachedEarningRules");
          if (!cachedEarningRules) {
            _this.getEarningRules(_this.customerId);
          } else {
            var earningRules = JSON.parse(cachedEarningRules);
            _this.displayEarningRules(earningRules);
          }
          _this.earningRulesSet = true;
        }
      });
    }
  }, {
    key: "getEarningRules",
    value: function () {
      var _getEarningRules = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var customeridParam, response, data, rules;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              customeridParam = "customerid=".concat(id);
              _context.next = 4;
              return fetch("https://club-bisgaard.vercel.app/apiv1/get-earning-rules?".concat(customeridParam), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json"
                }
              });
            case 4:
              response = _context.sent;
              if (!response.ok) {
                _context.next = 14;
                break;
              }
              _context.next = 8;
              return response.json();
            case 8:
              data = _context.sent;
              rules = data.rules;
              this.displayEarningRules(rules);
              sessionStorage.setItem("cachedEarningRules", JSON.stringify(rules));
              _context.next = 15;
              break;
            case 14:
              console.error("HTTP-Error: " + response.status);
            case 15:
              _context.next = 20;
              break;
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 17]]);
      }));
      function getEarningRules(_x) {
        return _getEarningRules.apply(this, arguments);
      }
      return getEarningRules;
    }()
  }, {
    key: "displayEarningRules",
    value: function displayEarningRules(rules) {
      var _this2 = this;
      if (rules.length === 0) {
        this.earningRulesSelector.innerHTML = "No earning rules found";
        return;
      } else {
        var rulesList = document.createElement("ul");
        rulesList.classList.add("earning-rules-grid");
        rules.forEach(function (rule) {
          var ruleItem = document.createElement("li");
          var points, additionalInfo;
          if (rule.rewarding.amountSpent) {
            points = "".concat(rule.rewarding.points, " point for hver ").concat(rule.rewarding.amountSpent, " DKK");
          } else {
            points = "".concat(rule.rewarding.points, " point");
          }
          // Add additional info for birthday gift rule
          if (rule.type === "birthday_gift") {
            if (_this2.clubBisgaard.dataset.birthday) {
              additionalInfo = "<a class=\"rule-additional-info\" href=\"#\">Din f\xF8dselsdag: ".concat(_this2.clubBisgaard.dataset.birthday, "</a>");
            } else {
              additionalInfo = "<a class=\"rule-additional-info\" href=\"#\" id=\"set-birthday\">Tilf\xF8j din f\xF8dselsdag</a>";
            }
          } else if (rule.type === "newsletter_subscribe") {
            if (_this2.clubBisgaard.dataset.marketing === "true") {
              additionalInfo = "<a class=\"rule-additional-info\" href=\"#\">Du er tilmeldt nyhedsbrevet</a>";
            } else {
              additionalInfo = "<a class=\"rule-additional-info\" href=\"#\" id=\"subscribe-newsletter\">Tilmeld dig nyhedsbrevet</a>";
            }
          } else {
            additionalInfo = "";
          }
          ruleItem.innerHTML = "\n          <div class=\"rule-icon\">\n          <img src=\"https://imgs.growave.io/qEMxIUmtCekFAGNHHuaYTghtUYzUdZAg-SD-DK6y_DY/rot:0/q:80/rs:auto:40:40/aHR0cHM6Ly9zc3dmaWxlcy5zMy5hbWF6b25hd3MuY29tL2NsaWVudDEzMzM2My9yZXdhcmRzLzY2ODI2YzZkMThjMmJfNjVkZjI5ZmE5OWI0ZV9kaXNjb3VudDEucG5n\"\n              alt=\"".concat(rule.title, "\"/>\n          </div>\n          <div>\n          <p class=\"rule-title\">").concat(rule.title, "</p>\n          </div>\n          <div>\n          <p class=\"rule-points\">").concat(points, "</p>\n          <p>").concat(additionalInfo, "</p>\n          </div>\n          ");
          rulesList.appendChild(ruleItem);
        });
        this.earningRulesSelector.appendChild(rulesList);
        // Add event listener to subscribe to newsletter
        var subscribeNewsletter = rulesList.querySelector("#subscribe-newsletter");
        subscribeNewsletter === null || subscribeNewsletter === void 0 || subscribeNewsletter.addEventListener("click", function (event) {
          event.preventDefault();
          subscribeNewsletter.innerHTML = "Du er tilmeldt nyhedsbrevet";
          _this2.updateNewsletterSubscription(_this2.clubBisgaard.dataset.customerid);
        });
        // Add event listener to set birthday
        var setBirthday = rulesList.querySelector("#set-birthday");
        setBirthday === null || setBirthday === void 0 || setBirthday.addEventListener("click", function (event) {
          event.preventDefault();
          var birthday = prompt("Indtast din fødselsdag (dd-mm-yyyy)");
          if (birthday) {
            var day = Number(birthday.split("-")[0]);
            var month = Number(birthday.split("-")[1]);
            var year = Number(birthday.split("-")[2]);
            if (day > 31 || month > 12 || year > new Date().getFullYear()) {
              alert("Indtast en gyldig fødselsdag");
              return;
            }
            _this2.clubBisgaard.setAttribute("data-birthday", birthday);
            setBirthday.innerHTML = "Din f\xF8dselsdag: ".concat(birthday);
            _this2.updateBirthday(day, month, year);
          }
        });
        // fade elements in
        Array.from(rulesList.children).forEach(function (child, index) {
          (0,_utils_Animations__WEBPACK_IMPORTED_MODULE_0__.fadeIn)(child, index, 750, 50);
        });
      }
      this.loader.style.display = "none";
    }
  }, {
    key: "updateBirthday",
    value: function () {
      var _updateBirthday = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(day, month, year) {
        var body, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              body = {
                customerid: this.customerId,
                day: day,
                month: month,
                year: year
              };
              _context2.next = 4;
              return fetch("https://club-bisgaard.vercel.app/apiv1/customer-update-birthday", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
              });
            case 4:
              response = _context2.sent;
              if (response.ok) {
                console.log("Birthday updated");
                document.dispatchEvent(new CustomEvent("customerUpdated"));
              } else {
                console.error("HTTP-Error: " + response.status);
              }
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 8]]);
      }));
      function updateBirthday(_x2, _x3, _x4) {
        return _updateBirthday.apply(this, arguments);
      }
      return updateBirthday;
    }()
  }, {
    key: "updateNewsletterSubscription",
    value: function () {
      var _updateNewsletterSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(customerid) {
        var body, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              body = {
                customerid: customerid
              };
              _context3.next = 4;
              return fetch("https://club-bisgaard.vercel.app/apiv1/update-customer-marketing", {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
              });
            case 4:
              response = _context3.sent;
              if (response.ok) {
                console.log("Newsletter subscription updated");
                document.dispatchEvent(new CustomEvent("customerUpdated"));
              } else {
                console.error("HTTP-Error: " + response.status);
              }
              _context3.next = 11;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              console.error(_context3.t0);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 8]]);
      }));
      function updateNewsletterSubscription(_x5) {
        return _updateNewsletterSubscription.apply(this, arguments);
      }
      return updateNewsletterSubscription;
    }()
  }]);
  return EditionGrowaveGetEarningRules;
}();


/***/ }),

/***/ "./scripts/ClubBisgaard/Growave/GrowaveGetSpendingRules.ts":
/*!*****************************************************************!*\
  !*** ./scripts/ClubBisgaard/Growave/GrowaveGetSpendingRules.ts ***!
  \*****************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EditionGrowaveGetSpendingRules; }
/* harmony export */ });
/* harmony import */ var _utils_Animations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/Animations */ "./scripts/utils/Animations.ts");
/* harmony import */ var _utils_ProductApiEndpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils/ProductApiEndpoints */ "./scripts/utils/ProductApiEndpoints.ts");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}


var EditionGrowaveGetSpendingRules = /*#__PURE__*/function () {
  function EditionGrowaveGetSpendingRules() {
    _classCallCheck(this, EditionGrowaveGetSpendingRules);
    _defineProperty(this, "spendSelector", document.querySelector("#spend"));
    _defineProperty(this, "spendingRulesSet", false);
    _defineProperty(this, "confirmationModal", document.querySelector("confirmation-modal"));
    _defineProperty(this, "clubBisgaard", document.querySelector("club-bisgaard"));
    _defineProperty(this, "customerId", this.clubBisgaard.dataset.customerid);
    _defineProperty(this, "loader", this.clubBisgaard.querySelector(".club-bisgaard_loader"));
    this.init = this.init.bind(this);
    this.getSpendingRules = this.getSpendingRules.bind(this);
    this.displaySpendingRules = this.displaySpendingRules.bind(this);
  }
  _createClass(EditionGrowaveGetSpendingRules, [{
    key: "init",
    value: function init() {
      var _this = this;
      var spendingRulesTab = document.querySelector("li.club-bisgaard_tab-club[data-type='spend']");
      spendingRulesTab.addEventListener("click", function () {
        if (_this.spendingRulesSet === false) {
          _this.loader.style.display = "block";
          // check if the spending rules are already cached
          var cachedSpendingRules = sessionStorage.getItem("cachedSpendingRules");
          if (!cachedSpendingRules) {
            _this.getSpendingRules(_this.customerId);
          } else {
            var spendingRules = JSON.parse(cachedSpendingRules);
            _this.displaySpendingRules(spendingRules);
          }
          _this.spendingRulesSet = true;
        }
      });
      document.addEventListener("customerUpdated", function () {
        _this.getSpendingRules(_this.customerId);
      });
    }
  }, {
    key: "getSpendingRules",
    value: function () {
      var _getSpendingRules = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var customeridParam, response, data, rules;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              customeridParam = "customerid=".concat(id);
              _context.next = 4;
              return fetch("https://club-bisgaard.vercel.app/apiv1/get-spending-rules?".concat(customeridParam), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json"
                }
              });
            case 4:
              response = _context.sent;
              if (!response.ok) {
                _context.next = 14;
                break;
              }
              _context.next = 8;
              return response.json();
            case 8:
              data = _context.sent;
              rules = data.rules;
              this.displaySpendingRules(rules);
              sessionStorage.setItem("cachedSpendingRules", JSON.stringify(rules));
              _context.next = 15;
              break;
            case 14:
              console.error("HTTP-Error: " + response.status);
            case 15:
              _context.next = 20;
              break;
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 17]]);
      }));
      function getSpendingRules(_x) {
        return _getSpendingRules.apply(this, arguments);
      }
      return getSpendingRules;
    }()
  }, {
    key: "displaySpendingRules",
    value: function displaySpendingRules(rules) {
      var _this2 = this;
      var pointsBalancesStorage = localStorage.getItem("customerPoints");
      var pointsBalance = Number(pointsBalancesStorage);
      // create spending rules selector for outputting the different spending rules
      var spendingRulesSelector = this.spendSelector.querySelector("#spending-rules");
      if (rules.length === 0) {
        spendingRulesSelector.innerHTML = "No spending rules found";
        return;
      } else {
        spendingRulesSelector.innerHTML = "";
        var rulesList = document.createElement("ul");
        rulesList.classList.add("spending-rules-grid");
        rules.forEach(function (rule) {
          if (rule.title !== "Fleksibel rabat") {
            var ruleItem = document.createElement("li");
            var iconSrc, ruleDesc, redeemEle;
            // set iconSrc based on the rule type
            if (rule.type === "free_product") {
              iconSrc = rule.productImage;
            } else if (rule.icon) {
              iconSrc = rule.icon;
            } else {
              iconSrc = "https://imgs.growave.io/qEMxIUmtCekFAGNHHuaYTghtUYzUdZAg-SD-DK6y_DY/rot:0/q:80/rs:auto:40:40/aHR0cHM6Ly9zc3dmaWxlcy5zMy5hbWF6b25hd3MuY29tL2NsaWVudDEzMzM2My9yZXdhcmRzLzY2ODI2YzZkMThjMmJfNjVkZjI5ZmE5OWI0ZV9kaXNjb3VudDEucG5n";
            }
            // set ruleDesc and redeemEle based on the rule type
            if (rule.pointsPrice > pointsBalance) {
              ruleDesc = "Optjen ".concat(rule.pointsPrice - pointsBalance, " point mere.");
              redeemEle = "<a href=\"#\" class=\"club-bisgaard_primary-btn\" disabled>Optjen point</a>";
            } else {
              var productIdAttribute = rule.productId ? "data-productid=\"".concat(rule.productId, "\"") : "";
              var productHandleAttribute = rule.productHandle ? "data-producthandle=\"".concat(rule.productHandle, "\"") : "";
              ruleDesc = "Brug ".concat(rule.pointsPrice, " point og f\xE5 ").concat(rule.title, ".");
              redeemEle = "<a href=\"#\" class=\"club-bisgaard_primary-btn\" data-rewardid=\"".concat(rule.id, "\" data-points=\"").concat(rule.pointsPrice, "\" ").concat(productIdAttribute, " ").concat(productHandleAttribute, ">Brug point</a>");
            }
            ruleItem.innerHTML = "\n          <div class=\"rule-icon\">\n          <img src=\"".concat(iconSrc, "\"\n              alt=\"").concat(rule.title, "\"/>\n          </div>\n          <div>\n            <p class=\"rule-title\">").concat(rule.title, "</p>\n          </div>\n          <div>\n            <p class=\"rule-points\">\n              ").concat(ruleDesc, "\n            </p>\n          </div>\n          <div class=\"tw-mt-auto\">\n            ").concat(redeemEle, "\n          </div>\n        ");
            rulesList.appendChild(ruleItem);
            ruleItem.querySelector(".club-bisgaard_primary-btn").addEventListener("click", function (event) {
              event.preventDefault();
              _this2.confirmationModal.toggleConfirmationBox();
              _this2.confirmationModal.initActions(function () {
                return _this2.purchaseReward(event.target);
              });
            });
          }
        });
        spendingRulesSelector.appendChild(rulesList);
        // fade elements in
        Array.from(rulesList.children).forEach(function (child, index) {
          (0,_utils_Animations__WEBPACK_IMPORTED_MODULE_0__.fadeUp)(child, index, 750, 50);
        });
      }
      this.loader.style.display = "none";
    }
  }, {
    key: "purchaseReward",
    value: function () {
      var _purchaseReward = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(target) {
        var points, customerId, rewardId, productId, productHandle, body, product, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              customerId = this.clubBisgaard.dataset.customerid;
              rewardId = target.dataset.rewardid;
              points = target.dataset.points;
              productId = target.dataset.productid;
              productHandle = target.dataset.producthandle;
              body = {};
              if (customerId) {
                body.customerid = customerId;
              }
              if (rewardId) {
                body.ruleid = Number(rewardId);
              }
              if (!productHandle) {
                _context2.next = 14;
                break;
              }
              _context2.next = 12;
              return (0,_utils_ProductApiEndpoints__WEBPACK_IMPORTED_MODULE_1__.getProduct)(productHandle);
            case 12:
              product = _context2.sent;
              body.selectedVariantId = product.variants[0].id;
            case 14:
              _context2.next = 16;
              return fetch("https://club-bisgaard.vercel.app/apiv1/redeem-reward", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
              });
            case 16:
              response = _context2.sent;
              _context2.next = 22;
              break;
            case 19:
              _context2.prev = 19;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);
            case 22:
              _context2.prev = 22;
              setTimeout(function () {
                document.dispatchEvent(new CustomEvent("customerUpdated", {
                  detail: {
                    pointsSpent: points
                  }
                }));
              }, 1500);
              return _context2.finish(22);
            case 25:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 19, 22, 25]]);
      }));
      function purchaseReward(_x2) {
        return _purchaseReward.apply(this, arguments);
      }
      return purchaseReward;
    }()
  }]);
  return EditionGrowaveGetSpendingRules;
}();


/***/ }),

/***/ "./scripts/ClubBisgaard/Growave/GrowaveWishlistActionsBtn.ts":
/*!*******************************************************************!*\
  !*** ./scripts/ClubBisgaard/Growave/GrowaveWishlistActionsBtn.ts ***!
  \*******************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EditionGrowaveWishlistActionsBtn; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var EditionGrowaveWishlistActionsBtn = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EditionGrowaveWishlistActionsBtn, _HTMLElement);
  var _super = _createSuper(EditionGrowaveWishlistActionsBtn);
  function EditionGrowaveWishlistActionsBtn() {
    var _this;
    _classCallCheck(this, EditionGrowaveWishlistActionsBtn);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "parent", _this.closest(".club-bisgaard_wishlist-item-header_actions"));
    _defineProperty(_assertThisInitialized(_this), "actionsMenu", _this.parent.querySelector(".club-bisgaard_wishlist-item-header_actions-dropdown"));
    _defineProperty(_assertThisInitialized(_this), "clubBisgaard", document.querySelector("club-bisgaard"));
    _defineProperty(_assertThisInitialized(_this), "customerId", _this.clubBisgaard.dataset.customerid);
    _defineProperty(_assertThisInitialized(_this), "confirmationModal", document.querySelector("confirmation-modal"));
    _this.toggleActionsMenu = _this.toggleActionsMenu.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(EditionGrowaveWishlistActionsBtn, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.addEventListener("click", function (event) {
        event.preventDefault();
        _this2.toggleActionsMenu();
      });
      var renameWishlistBtn = this.parent.querySelector(".rename-wishlist");
      renameWishlistBtn.addEventListener("click", function (event) {
        event.preventDefault();
        var wishlistid = renameWishlistBtn.dataset.wishlistid;
        _this2.renameWishlist(wishlistid);
      });
      var deleteWishlistBtn = this.parent.querySelector(".delete-wishlist");
      deleteWishlistBtn.addEventListener("click", function (event) {
        event.preventDefault();
        var wishlistid = deleteWishlistBtn.dataset.wishlistid;
        // Open the confirmation modal
        _this2.confirmationModal.toggleConfirmationBox();
        _this2.confirmationModal.initActions(function () {
          return _this2.deleteWishlist(wishlistid, _this2.customerId);
        });
      });
      // Close the actions menu when clicking outside of it
      document.addEventListener("click", function (event) {
        if (_this2.actionsMenu.getAttribute("aria-hidden") === "false") {
          if (!_this2.contains(event.target)) {
            _this2.actionsMenu.setAttribute("aria-hidden", "true");
          }
        }
      });
    }
  }, {
    key: "toggleActionsMenu",
    value: function toggleActionsMenu() {
      this.actionsMenu.setAttribute("aria-hidden", this.actionsMenu.getAttribute("aria-hidden") === "true" ? "false" : "true");
    }
    // Hit our server to rename the wishlist
  }, {
    key: "renameWishlist",
    value: function () {
      var _renameWishlist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(wishlistid) {
        var newTitle, response, data, newWishListTitle, wishlistItem, wishlistItemTitle;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              newTitle = prompt("Enter new title");
              if (newTitle) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              _context.next = 6;
              return fetch("https://club-bisgaard.vercel.app/apiv1/wishlist-rename", {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  wishlistid: wishlistid,
                  newtitle: newTitle
                })
              });
            case 6:
              response = _context.sent;
              if (!response.ok) {
                _context.next = 17;
                break;
              }
              _context.next = 10;
              return response.json();
            case 10:
              data = _context.sent;
              newWishListTitle = data.updatedWishlist.wishlistTitle;
              wishlistItem = this.closest(".club-bisgaard_wishlist-item");
              wishlistItemTitle = wishlistItem.querySelector(".club-bisgaard_wishlist-item-header_title .club-bisgaard_extra-small-heading");
              wishlistItemTitle.textContent = newWishListTitle;
              _context.next = 18;
              break;
            case 17:
              console.error("HTTP-Error: " + response.status);
            case 18:
              _context.next = 23;
              break;
            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 20]]);
      }));
      function renameWishlist(_x) {
        return _renameWishlist.apply(this, arguments);
      }
      return renameWishlist;
    }() // Hit our server to delete the wishlist
  }, {
    key: "deleteWishlist",
    value: function () {
      var _deleteWishlist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(wishlistid, customerId) {
        var response, wishlistItem;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return fetch("https://club-bisgaard.vercel.app/apiv1/wishlist-delete", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  customerid: customerId,
                  wishlistid: wishlistid
                })
              });
            case 3:
              response = _context2.sent;
              if (response.ok) {
                wishlistItem = this.closest(".club-bisgaard_wishlist-item");
                wishlistItem.remove();
              } else {
                console.error("HTTP-Error: " + response.status);
              }
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 7]]);
      }));
      function deleteWishlist(_x2, _x3) {
        return _deleteWishlist.apply(this, arguments);
      }
      return deleteWishlist;
    }()
  }]);
  return EditionGrowaveWishlistActionsBtn;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./scripts/ClubBisgaard/Growave/GrowaveWishlistCreateBtn.ts":
/*!******************************************************************!*\
  !*** ./scripts/ClubBisgaard/Growave/GrowaveWishlistCreateBtn.ts ***!
  \******************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EditionGrowaveWishlistCreateBtn; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var EditionGrowaveWishlistCreateBtn = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EditionGrowaveWishlistCreateBtn, _HTMLElement);
  var _super = _createSuper(EditionGrowaveWishlistCreateBtn);
  function EditionGrowaveWishlistCreateBtn() {
    var _this;
    _classCallCheck(this, EditionGrowaveWishlistCreateBtn);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "clubBisgaard", document.querySelector("club-bisgaard"));
    return _this;
  }
  _createClass(EditionGrowaveWishlistCreateBtn, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.addEventListener("click", function (event) {
        event.preventDefault();
        _this2.handleClick();
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var customerId = this.clubBisgaard.dataset.customerid;
      var wishlistTitle = prompt("Enter wishlist title");
      if (!wishlistTitle || wishlistTitle === "") {
        return;
      }
      this.createWishlist(customerId, wishlistTitle);
    }
  }, {
    key: "createWishlist",
    value: function () {
      var _createWishlist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(customerId, wishlistTitle) {
        var response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch("https://club-bisgaard.vercel.app/apiv1/wishlist-create", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  customerid: customerId,
                  wishlisttitle: wishlistTitle
                })
              });
            case 3:
              response = _context.sent;
              if (response.ok) {
                document.dispatchEvent(new CustomEvent("wishlist-created"));
              }
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error("Error creating wishlist", _context.t0);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7]]);
      }));
      function createWishlist(_x, _x2) {
        return _createWishlist.apply(this, arguments);
      }
      return createWishlist;
    }()
  }]);
  return EditionGrowaveWishlistCreateBtn;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./scripts/Consent.ts":
/*!****************************!*\
  !*** ./scripts/Consent.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Consent; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
// Consent Component
//
// This class manages user consent tracking and interaction with Shopify's consent-tracking API.
// It includes methods for initializing consent features, handling consent updates, and interacting
// with Shopify's privacy settings.
//
// Key Functionalities:
// - `init()`: Loads Shopify's consent-tracking API and initializes the consent component.
// - `initConsentComponent()`: Sets up event listeners for consent actions, such as recalling consent preferences.
// - `handleConsentUpdate(state: string)`: Updates consent settings based on the user's current preferences.
//   - Parameters:
//     - `state`: A string representing the consent state ("granted", "denied", etc.).
// - `checkConsentBannerInteraction()`: Verifies if the user has interacted with the consent banner.
// - `gtag(...args)`: Pushes consent-related events to the Google Tag Manager data layer.
// - `recallConsent()`: Displays the privacy banner to allow users to update their consent preferences.
// - `logConsent(consentSettings: object)`: Logs the user's consent preferences to a database or analytics tool.
//
// Dependencies:
// - `window.dataLayer`: Required for Google Consent Mode V2 integration.
// - Shopify Customer Privacy Banner: Must be enabled in the Shopify admin panel.
//
// Error Handling:
// - Errors in loading Shopify features (e.g., API initialization failures) are logged to the console without blocking the process.
//
// Extensibility:
// - Support additional consent categories or analytics tools by extending `handleConsentUpdate` and other methods.
// - Update `logConsent` to integrate with custom databases or third-party analytics platforms as needed.
//
// Notes:
// - Local storage is used to persist consent settings across sessions.
// Usage Example:
// 1. Import the `Consent` class and initialize it in your application:
// ---- import Consent from './scripts/components/Consent/Consent';
// ---- const consent = new Consent();
// ---- consent.init();
//
// 2. To enable the recall consent feature, add an element with the ID "recall-consent" to the DOM:
// ---- <a href="#" id="recall-consent"></a>
//
// 3. Add Locales: en: "change_cookie_settings": "Change your cookie settings", da: "change_cookie_settings": "Tilpas dine cookie-indstillinger",
var Consent = /*#__PURE__*/function () {
  // declare dataLayer
  function Consent() {
    _classCallCheck(this, Consent);
    this.init = this.init.bind(this);
    this.handleConsentUpdate = this.handleConsentUpdate.bind(this);
    this.checkConsentBannerInteraction = this.checkConsentBannerInteraction.bind(this);
    this.gtag = this.gtag.bind(this);
    this.recallConsent = this.recallConsent.bind(this);
  }
  _createClass(Consent, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this = this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              ;
              window.Shopify.loadFeatures([{
                name: "consent-tracking-api",
                version: "0.1"
              }], function (error) {
                if (error) {
                  // eslint-disable-next-line no-console
                  console.error("Error loading features: ", error);
                  return;
                }
                // eslint-disable-next-line no-console
                console.log("Consent tracking API loaded");
                _this.initConsentComponent();
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initConsentComponent",
    value: function () {
      var _initConsentComponent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this2 = this;
        var recallConsentElement;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              ;
              window.dataLayer = window.dataLayer || [];
              document.addEventListener("visitorConsentCollected", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _this2.handleConsentUpdate("update");
                    case 1:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              })));
              recallConsentElement = document.getElementById("recall-consent");
              if (recallConsentElement) {
                recallConsentElement.addEventListener("click", function (event) {
                  event.preventDefault();
                  _this2.recallConsent();
                });
              }
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function initConsentComponent() {
        return _initConsentComponent.apply(this, arguments);
      }
      return initConsentComponent;
    }()
  }, {
    key: "handleConsentUpdate",
    value: function () {
      var _handleConsentUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(state) {
        var visitorConsent, consent;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 2:
              visitorConsent = _context4.sent;
              consent = {
                functionality_storage: "granted",
                analytics_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
                personalization_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
                ad_storage: visitorConsent.marketing === "yes" ? "granted" : "denied",
                ad_user_data: visitorConsent.marketing === "yes" ? "granted" : "denied",
                ad_personalization: visitorConsent.marketing === "yes" ? "granted" : "denied",
                wait_for_update: 3000
              };
              this.gtag("consent", state, consent);
              // set local Storage for consent settings for further use on other pages or after page
              localStorage.setItem("consentSettings", JSON.stringify(consent));
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleConsentUpdate(_x) {
        return _handleConsentUpdate.apply(this, arguments);
      }
      return handleConsentUpdate;
    }() /* eslint-disable */
  }, {
    key: "checkConsentBannerInteraction",
    value: function () {
      var _checkConsentBannerInteraction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var visitorConsent;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 2:
              visitorConsent = _context5.sent;
              if (!(visitorConsent.preferences === "" && visitorConsent.analytics === "" && visitorConsent.marketing === "")) {
                _context5.next = 5;
                break;
              }
              return _context5.abrupt("return", false);
            case 5:
              return _context5.abrupt("return", true);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function checkConsentBannerInteraction() {
        return _checkConsentBannerInteraction.apply(this, arguments);
      }
      return checkConsentBannerInteraction;
    }()
    /* eslint-disable */
    /* eslint-disable */
  }, {
    key: "gtag",
    value: function gtag() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      ;
      window.dataLayer.push(arguments);
    }
    /* eslint-enable */
    /* eslint-disable */
  }, {
    key: "recallConsent",
    value: function () {
      var _recallConsent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              ;
              window.privacyBanner.showPreferences();
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function recallConsent() {
        return _recallConsent.apply(this, arguments);
      }
      return recallConsent;
    }()
  }]);
  return Consent;
}();


/***/ }),

/***/ "./scripts/CountdownTimer.ts":
/*!***********************************!*\
  !*** ./scripts/CountdownTimer.ts ***!
  \***********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CountdownTimer; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var CountdownTimer = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CountdownTimer, _HTMLElement);
  var _super = _createSuper(CountdownTimer);
  function CountdownTimer() {
    var _this;
    _classCallCheck(this, CountdownTimer);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "countdownDateString", _this.dataset.date);
    _defineProperty(_assertThisInitialized(_this), "days", _this.querySelector("#days"));
    _defineProperty(_assertThisInitialized(_this), "hours", _this.querySelector("#hours"));
    _defineProperty(_assertThisInitialized(_this), "minutes", _this.querySelector("#minutes"));
    _defineProperty(_assertThisInitialized(_this), "seconds", _this.querySelector("#seconds"));
    _this.startTimer = _this.startTimer.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(CountdownTimer, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.startTimer();
    }
  }, {
    key: "startTimer",
    value: function startTimer() {
      var _this2 = this;
      // Split date string in "DD-MM-YYYY" format
      var _this$countdownDateSt = this.countdownDateString.split("-").map(Number),
        _this$countdownDateSt2 = _slicedToArray(_this$countdownDateSt, 3),
        day = _this$countdownDateSt2[0],
        month = _this$countdownDateSt2[1],
        year = _this$countdownDateSt2[2];
      var countDownDateObject = new Date(year, month - 1, day).getTime();
      console.log(countDownDateObject); // For debugging
      var x = setInterval(function () {
        var now = new Date().getTime();
        var distance = countDownDateObject - now;
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
        var seconds = Math.floor(distance % (1000 * 60) / 1000);
        // Display the result in the element
        _this2.days.innerHTML = days.toString();
        _this2.hours.innerHTML = hours.toString();
        _this2.minutes.innerHTML = minutes.toString();
        if (_this2.seconds) {
          _this2.seconds.innerHTML = seconds.toString();
        }
        // If the countdown is finished, display "EXPIRED"
        if (distance < 0) {
          clearInterval(x);
          _this2.innerHTML = "EXPIRED";
        }
      }, 1000);
    }
  }]);
  return CountdownTimer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./scripts/OpenKiwi.ts":
/*!*****************************!*\
  !*** ./scripts/OpenKiwi.ts ***!
  \*****************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ OpenKiwi; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var OpenKiwi = /*#__PURE__*/function (_HTMLElement) {
  _inherits(OpenKiwi, _HTMLElement);
  var _super = _createSuper(OpenKiwi);
  function OpenKiwi() {
    var _this;
    _classCallCheck(this, OpenKiwi);
    _this = _super.call(this);
    _this.openKiwi = _this.openKiwi.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(OpenKiwi, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.addEventListener("click", function (event) {
        event.preventDefault();
        _this2.openKiwi();
      });
    }
  }, {
    key: "openKiwi",
    value: function openKiwi() {
      var kiwi = document.querySelector(".btn.ks-calculator-modal-button.sizing-calculator-modal-button");
      if (kiwi) {
        kiwi.click();
      }
    }
  }]);
  return OpenKiwi;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./scripts/SearchFormSubmit.ts":
/*!*************************************!*\
  !*** ./scripts/SearchFormSubmit.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ FormSubmit; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var FormSubmit = /*#__PURE__*/function (_HTMLElement) {
  _inherits(FormSubmit, _HTMLElement);
  var _super = _createSuper(FormSubmit);
  function FormSubmit() {
    var _this;
    _classCallCheck(this, FormSubmit);
    _this = _super.call(this);
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(FormSubmit, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.addEventListener("click", function (event) {
        event.preventDefault();
        _this2.handleSubmit();
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var form = document.getElementById("predictive-search-form");
      var searchInput = form.querySelector('input[type="search"]');
      var searchTerm = searchInput.value;
      var formType = this.dataset.type;
      window.location.href = "/search?q=".concat(searchTerm, "&type=").concat(formType);
    }
  }]);
  return FormSubmit;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./scripts/ShowMoreVariants.ts":
/*!*************************************!*\
  !*** ./scripts/ShowMoreVariants.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ShowMoreVariants; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var ShowMoreVariants = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ShowMoreVariants, _HTMLElement);
  var _super = _createSuper(ShowMoreVariants);
  function ShowMoreVariants() {
    var _this;
    _classCallCheck(this, ShowMoreVariants);
    _this = _super.call(this);
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ShowMoreVariants, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.addEventListener("click", this.handleClick);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var closestVariantHolder = this.closest(".ProductMeta__Variants");
      var elementsToHide = closestVariantHolder.querySelectorAll(".hide");
      elementsToHide.forEach(function (element) {
        element.classList.remove("hide");
      });
      this.remove();
    }
  }]);
  return ShowMoreVariants;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./scripts/TermsAndConditions.ts":
/*!***************************************!*\
  !*** ./scripts/TermsAndConditions.ts ***!
  \***************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ TermsAndConditions; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var TermsAndConditions = /*#__PURE__*/function (_HTMLElement) {
  _inherits(TermsAndConditions, _HTMLElement);
  var _super = _createSuper(TermsAndConditions);
  function TermsAndConditions() {
    var _this;
    _classCallCheck(this, TermsAndConditions);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "termsCheckmark", _this.querySelector(".terms_checkmark"));
    _defineProperty(_assertThisInitialized(_this), "termsCheckbox", _this.querySelector("#terms_checkbox"));
    _defineProperty(_assertThisInitialized(_this), "checkoutBtn", _this.querySelector("button[name='checkout']"));
    _defineProperty(_assertThisInitialized(_this), "popoverTerms", document.querySelector("#popover_terms"));
    _defineProperty(_assertThisInitialized(_this), "popoverTermsContainer", document.querySelector(".popover_terms_container"));
    _defineProperty(_assertThisInitialized(_this), "popoverTermsClose", document.querySelector("#popover_terms_close"));
    _defineProperty(_assertThisInitialized(_this), "acceptTermsButton", document.querySelector("#accept_terms_button"));
    _this.documentClickHandler = _this.documentClickHandler.bind(_assertThisInitialized(_this));
    _this.checkoutBtnHandler = _this.checkoutBtnHandler.bind(_assertThisInitialized(_this));
    _this.acceptTermsCloseHandler = _this.acceptTermsCloseHandler.bind(_assertThisInitialized(_this));
    _this.acceptTermsButtonHandler = _this.acceptTermsButtonHandler.bind(_assertThisInitialized(_this));
    _this.termsCheckboxChangeHandler = _this.termsCheckboxChangeHandler.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(TermsAndConditions, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (this.checkoutBtn && this.termsCheckbox) {
        this.checkoutBtn.addEventListener("click", this.checkoutBtnHandler);
        this.popoverTermsClose.addEventListener("click", this.acceptTermsCloseHandler);
        this.termsCheckbox.addEventListener("change", this.termsCheckboxChangeHandler);
        this.acceptTermsButton.addEventListener("click", this.acceptTermsButtonHandler);
      }
    }
  }, {
    key: "checkoutBtnHandler",
    value: function checkoutBtnHandler(e) {
      if (!this.termsCheckbox.checked) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.popoverTerms.classList.remove("tw-hidden");
      }
    }
  }, {
    key: "termsCheckboxChangeHandler",
    value: function termsCheckboxChangeHandler() {
      if (this.termsCheckbox.checked) {
        this.checkoutBtn.setAttribute("name", "checkout");
      } else {
        this.checkoutBtn.removeAttribute("name");
      }
    }
  }, {
    key: "acceptTermsButtonHandler",
    value: function acceptTermsButtonHandler() {
      var _this2 = this;
      this.termsCheckbox.click();
      this.termsCheckboxChangeHandler();
      setTimeout(function () {
        if (_this2.termsCheckbox.checked) {
          _this2.checkoutBtn.click();
        }
      }, 200);
    }
  }, {
    key: "documentClickHandler",
    value: function documentClickHandler(e) {
      var target = e.target;
      if (this.popoverTerms && !this.popoverTermsContainer.contains(target) && !this.checkoutBtn.contains(target)) {
        this.popoverTerms.classList.add("tw-hidden");
      }
    }
  }, {
    key: "acceptTermsCloseHandler",
    value: function acceptTermsCloseHandler(e) {
      e.preventDefault();
      this.popoverTerms.classList.add("tw-hidden");
    }
  }]);
  return TermsAndConditions;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./scripts/app.ts":
/*!************************!*\
  !*** ./scripts/app.ts ***!
  \************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _scripts_Bundles_Bundles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../scripts/Bundles/Bundles */ "./scripts/Bundles/Bundles.ts");
/* harmony import */ var _ClubBisgaard_ClubBisgaard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ClubBisgaard/ClubBisgaard */ "./scripts/ClubBisgaard/ClubBisgaard.ts");
/* harmony import */ var _scripts_ShowMoreVariants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scripts/ShowMoreVariants */ "./scripts/ShowMoreVariants.ts");
/* harmony import */ var _scripts_SearchFormSubmit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../scripts/SearchFormSubmit */ "./scripts/SearchFormSubmit.ts");
/* harmony import */ var _scripts_OpenKiwi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../scripts/OpenKiwi */ "./scripts/OpenKiwi.ts");
/* harmony import */ var _scripts_utils_AccountRegisterCheckbox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../scripts/utils/AccountRegisterCheckbox */ "./scripts/utils/AccountRegisterCheckbox.ts");
/* harmony import */ var _scripts_TermsAndConditions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../scripts/TermsAndConditions */ "./scripts/TermsAndConditions.ts");
/* harmony import */ var _scripts_CountdownTimer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../scripts/CountdownTimer */ "./scripts/CountdownTimer.ts");
/* harmony import */ var _scripts_Consent__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../scripts/Consent */ "./scripts/Consent.ts");
// initiate Bundles

var bundles = new _scripts_Bundles_Bundles__WEBPACK_IMPORTED_MODULE_0__["default"]();
bundles.init();
// initiate Growave Customer Handling

customElements.define("club-bisgaard", _ClubBisgaard_ClubBisgaard__WEBPACK_IMPORTED_MODULE_1__["default"]);
// Initiate smaller components like ShowMoreVariants, FormSubmit, OpenKiwi, AccountRegisterCheckbox

customElements.define("show-more-variants", _scripts_ShowMoreVariants__WEBPACK_IMPORTED_MODULE_2__["default"]);

customElements.define("form-submit", _scripts_SearchFormSubmit__WEBPACK_IMPORTED_MODULE_3__["default"]);

customElements.define("open-kiwi", _scripts_OpenKiwi__WEBPACK_IMPORTED_MODULE_4__["default"]);

var accountRegisterCheckbox = new _scripts_utils_AccountRegisterCheckbox__WEBPACK_IMPORTED_MODULE_5__["default"]();
accountRegisterCheckbox.init();

customElements.define("terms-conditions", _scripts_TermsAndConditions__WEBPACK_IMPORTED_MODULE_6__["default"]);

customElements.define("countdown-timer", _scripts_CountdownTimer__WEBPACK_IMPORTED_MODULE_7__["default"]);

var consent = new _scripts_Consent__WEBPACK_IMPORTED_MODULE_8__["default"]();
consent.init();
var forms = Array.from(document.querySelectorAll("form[action=\"/contact#footer-newsletter\"], form#create_customer"));
if (forms.length) {
  forms.forEach(function (form) {
    var submitButton = form.querySelector("button[type=\"submit\"]");
    submitButton.setAttribute("disabled", "true");
    console.log("submit button", submitButton);
    setTimeout(function () {
      submitButton.removeAttribute("disabled");
    }, 5000);
    form.addEventListener("submit", function (event) {
      if (submitButton.hasAttribute("disabled")) {
        event.preventDefault();
      }
    });
  });
}

/***/ }),

/***/ "./scripts/utils/AccountRegisterCheckbox.ts":
/*!**************************************************!*\
  !*** ./scripts/utils/AccountRegisterCheckbox.ts ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ AccountRegisterCheckbox; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var AccountRegisterCheckbox = /*#__PURE__*/function () {
  function AccountRegisterCheckbox() {
    _classCallCheck(this, AccountRegisterCheckbox);
    this.init = this.init.bind(this);
  }
  _createClass(AccountRegisterCheckbox, [{
    key: "init",
    value: function init() {
      var accountCreationForm = document.getElementById("create_customer");
      // listen for changes to the form using mutation observer
      if (accountCreationForm) {
        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type === "childList") {
              var checkBoxWrapper = accountCreationForm.querySelector(".ssw-accept-wrapper");
              var checkBox = checkBoxWrapper === null || checkBoxWrapper === void 0 ? void 0 : checkBoxWrapper.querySelector(".ssw-accept-marketing__input");
              var label = checkBoxWrapper === null || checkBoxWrapper === void 0 ? void 0 : checkBoxWrapper.querySelector(".ssw-accept-marketing");
              if (!checkBoxWrapper || !checkBox || !label) return;
              var labelInputs = Array.from(checkBoxWrapper === null || checkBoxWrapper === void 0 ? void 0 : checkBoxWrapper.querySelectorAll("input"));
              if (checkBoxWrapper && label) {
                checkBox.classList.add("!tw-hidden");
                label.innerHTML = "\n              ".concat(labelInputs.map(function (input) {
                  return input.outerHTML;
                }).join(""), "\n              <p class=\"tw-text-[10px] tw-mt-2\">\n                ").concat(window.theme.acceptMarketingText, "\n\t\t\t        </p>\n\t\t\t        ");
                label.click();
                observer.disconnect();
              }
            }
          });
        });
        observer.observe(accountCreationForm, {
          childList: true,
          subtree: true
        });
      }
      document.addEventListener("click", function (event) {
        var target = event.target;
        if (target.classList.contains("gw-link-login") || target.classList.contains("ssw-reward-auth-reg-btn")) {
          var _accountCreationForm = document.getElementById("he_create_customer");
          var checkBoxLabel = _accountCreationForm.querySelector("#ssw-signup-accept-marketing");
          var checkBox = checkBoxLabel.querySelector("input");
          checkBox.classList.add("!tw-hidden");
          checkBoxLabel.style.padding = "0";
          checkBoxLabel.innerHTML = "\n          ".concat(checkBox.outerHTML, "\n          <p class=\"!tw-text-[10px] tw-mt-2\" style=\"font-size:10px;text-align:left;\">\n            ").concat(window.theme.acceptMarketingText, "\n          </p>\n        ");
          checkBoxLabel.click();
        }
      });
    }
  }]);
  return AccountRegisterCheckbox;
}();


/***/ }),

/***/ "./scripts/utils/Animations.ts":
/*!*************************************!*\
  !*** ./scripts/utils/Animations.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   fadeIn: function() { return /* binding */ fadeIn; },
/* harmony export */   fadeUp: function() { return /* binding */ fadeUp; }
/* harmony export */ });
var fadeIn = function fadeIn(element, index, duration, timeOut) {
  element.style.willChange = "opacity";
  element.style.opacity = "0";
  requestAnimationFrame(function () {
    setTimeout(function () {
      element.style.transition = "opacity ".concat(duration, "ms");
      element.style.opacity = "1";
    }, index * timeOut);
  });
};
var fadeUp = function fadeUp(element, index, duration, timeOut) {
  // Apply initial styles
  element.style.willChange = "transform, opacity";
  element.style.transform = "translateY(70px)";
  element.style.opacity = "0";
  element.style.transition = "none"; // Temporarily disable transition
  // Define the fade-up animation
  var animate = function animate(delay) {
    setTimeout(function () {
      requestAnimationFrame(function () {
        element.style.transition = "opacity ".concat(duration, "ms, transform ").concat(duration, "ms");
        element.style.opacity = "1";
        element.style.transform = "translateY(0)";
      });
    }, delay);
  };
  // Helper function to check if the element is visible from the top of the window
  var isVisibleFromTop = function isVisibleFromTop(element, threshold) {
    var rect = element.getBoundingClientRect();
    return rect.top < threshold;
  };
  var threshold = 350; // Adjust this value as needed
  // Initial check for elements visible from the top of the window
  if (isVisibleFromTop(element, threshold)) {
    animate(index * timeOut); // Apply animation with index-based timeout for initial elements visible from the top
  } else {
    // Create and set up IntersectionObserver for elements not initially visible from the top
    var observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // Only apply the animation once
          if (!element.classList.contains("animated")) {
            element.classList.add("animated");
            animate(timeOut); // Apply animation with a fixed timeout for elements scrolled into view
          }
          // Stop observing after animation to improve performance
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: [0.1]
    });
    // Start observing the element
    observer.observe(element);
  }
};

/***/ }),

/***/ "./scripts/utils/CartApiEndpoints.ts":
/*!*******************************************!*\
  !*** ./scripts/utils/CartApiEndpoints.ts ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   addVariantToCart: function() { return /* binding */ addVariantToCart; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function addVariantToCart(_x) {
  return _addVariantToCart.apply(this, arguments);
}
function _addVariantToCart() {
  _addVariantToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(variantId) {
    var response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });
        case 3:
          response = _context.sent;
          if (response.ok) {
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true
            }));
          }
          _context.next = 10;
          break;
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 7]]);
  }));
  return _addVariantToCart.apply(this, arguments);
}

/***/ }),

/***/ "./scripts/utils/DiscountCode.ts":
/*!***************************************!*\
  !*** ./scripts/utils/DiscountCode.ts ***!
  \***************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   fetchDiscountCode: function() { return /* binding */ fetchDiscountCode; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function fetchDiscountCode(_x) {
  return _fetchDiscountCode.apply(this, arguments);
}
function _fetchDiscountCode() {
  _fetchDiscountCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(discountCode) {
    var response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch("/discount/".concat(discountCode));
        case 3:
          response = _context.sent;
          if (response.ok) {
            setTimeout(function () {
              document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: true
              }));
            }, 1500);
          }
          _context.next = 10;
          break;
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 7]]);
  }));
  return _fetchDiscountCode.apply(this, arguments);
}

/***/ }),

/***/ "./scripts/utils/ProductApiEndpoints.ts":
/*!**********************************************!*\
  !*** ./scripts/utils/ProductApiEndpoints.ts ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getProduct: function() { return /* binding */ getProduct; },
/* harmony export */   restapiGetProducts: function() { return /* binding */ restapiGetProducts; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function getProduct(_x) {
  return _getProduct.apply(this, arguments);
}
// function to get products using an array of ids
function _getProduct() {
  _getProduct = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(productHandle) {
    var response, data, product;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch("/products/".concat(productHandle, ".json"));
        case 3:
          response = _context.sent;
          if (!response.ok) {
            _context.next = 10;
            break;
          }
          _context.next = 7;
          return response.json();
        case 7:
          data = _context.sent;
          product = data.product;
          return _context.abrupt("return", product);
        case 10:
          _context.next = 14;
          break;
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](0);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 12]]);
  }));
  return _getProduct.apply(this, arguments);
}
function restapiGetProducts(_x2) {
  return _restapiGetProducts.apply(this, arguments);
}
function _restapiGetProducts() {
  _restapiGetProducts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(ids) {
    var response, data, products;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return fetch("https://club-bisgaard.vercel.app/apiv1/get-products?ids=".concat(ids));
        case 3:
          response = _context2.sent;
          if (!response.ok) {
            _context2.next = 10;
            break;
          }
          _context2.next = 7;
          return response.json();
        case 7:
          data = _context2.sent;
          products = data.products;
          return _context2.abrupt("return", products);
        case 10:
          _context2.next = 14;
          break;
        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](0);
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 12]]);
  }));
  return _restapiGetProducts.apply(this, arguments);
}

/***/ }),

/***/ "./scripts/theme.js":
/*!**************************!*\
  !*** ./scripts/theme.js ***!
  \**************************/
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _classCallCheck2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _inherits2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf2(subClass, superClass);
}
function _createSuper2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct2();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf2(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf2(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn2(this, result);
  };
}
function _possibleConstructorReturn2(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized2(self);
}
function _assertThisInitialized2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper2(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper2 = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction2(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct2(Class, arguments, _getPrototypeOf2(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf2(Wrapper, Class);
  };
  return _wrapNativeSuper2(Class);
}
function _construct2(Parent, args, Class) {
  if (_isNativeReflectConstruct2()) {
    _construct2 = Reflect.construct.bind();
  } else {
    _construct2 = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf2(instance, Class.prototype);
      return instance;
    };
  }
  return _construct2.apply(null, arguments);
}
function _isNativeReflectConstruct2() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction2(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf2(o, p) {
  _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf2(o, p);
}
function _getPrototypeOf2(o) {
  _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf2(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
;
(function (factory) {
   true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 0;
})(function () {
  "use strict";

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }
    return _construct.apply(null, arguments);
  }
  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }
  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;
      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }
      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);
        _cache.set(Class, Wrapper);
      }
      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }
      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }
    return _assertThisInitialized(self);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  var Responsive = /*#__PURE__*/function () {
    function Responsive() {
      var _this = this;
      _classCallCheck(this, Responsive);
      this.currentBreakpoint = Responsive.getCurrentBreakpoint();
      window.addEventListener("resize", function () {
        var newBreakpoint = Responsive.getCurrentBreakpoint();
        if (_this.currentBreakpoint === newBreakpoint) {
          return;
        }
        document.dispatchEvent(new CustomEvent("breakpoint:changed", {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint
          }
        }));
        _this.currentBreakpoint = newBreakpoint;
      });
    }
    _createClass(Responsive, null, [{
      key: "matchesBreakpoint",
      value: function matchesBreakpoint(breakpoint) {
        switch (breakpoint) {
          case "phone":
            return window.matchMedia("screen and (max-width: 640px)").matches;
          case "tablet":
            return window.matchMedia("screen and (min-width: 641px) and (max-width: 1007px)").matches;
          case "tablet-and-up":
            return window.matchMedia("screen and (min-width: 641px)").matches;
          case "pocket":
            return window.matchMedia("screen and (max-width: 1007px)").matches;
          case "lap":
            return window.matchMedia("screen and (min-width: 1008px) and (max-width: 1279px)").matches;
          case "lap-and-up":
            return window.matchMedia("screen and (min-width: 1008px)").matches;
          case "desk":
            return window.matchMedia("screen and (min-width: 1280px)").matches;
          case "widescreen":
            return window.matchMedia("screen and (min-width: 1600px)").matches;
          case "supports-hover":
            return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
        }
      }
    }, {
      key: "getCurrentBreakpoint",
      value: function getCurrentBreakpoint() {
        if (window.matchMedia("screen and (max-width: 640px)").matches) {
          return "phone";
        }
        if (window.matchMedia("screen and (min-width: 641px) and (max-width: 1007px)").matches) {
          return "tablet";
        }
        if (window.matchMedia("screen and (min-width: 1008px) and (max-width: 1279px)").matches) {
          return "lap";
        }
        if (window.matchMedia("screen and (min-width: 1280px)").matches) {
          return "desk";
        }
      }
    }]);
    return Responsive;
  }();
  var Carousel = /*#__PURE__*/function () {
    function Carousel(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var overrideSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      _classCallCheck(this, Carousel);
      this.element = element;
      this.initialConfig = Object.assign(JSON.parse(element.getAttribute("data-flickity-config")), overrideSettings);
      this.options = options;
      this._attachListeners();
      this._build();
    }
    _createClass(Carousel, [{
      key: "destroy",
      value: function destroy() {
        this.flickityInstance.destroy();
        if (this.initialConfig["breakpoints"] !== undefined) {
          document.removeEventListener("breakpoint:changed", this._onBreakpointChangedListener);
        }
      }
    }, {
      key: "getFlickityInstance",
      value: function getFlickityInstance() {
        return this.flickityInstance;
      }
    }, {
      key: "selectCell",
      value: function selectCell(index) {
        var shouldPause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var shouldAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        if (shouldPause) {
          this.flickityInstance.pausePlayer();
        }
        this.flickityInstance.select(index, false, !shouldAnimate);
      }
    }, {
      key: "next",
      value: function next() {
        this.flickityInstance.next();
      }
    }, {
      key: "previous",
      value: function previous() {
        this.flickityInstance.previous();
      }
    }, {
      key: "pausePlayer",
      value: function pausePlayer() {
        this.flickityInstance.pausePlayer();
      }
    }, {
      key: "unpausePlayer",
      value: function unpausePlayer() {
        this.flickityInstance.unpausePlayer();
      }
    }, {
      key: "resize",
      value: function resize() {
        this.flickityInstance.resize();
      }
    }, {
      key: "getSelectedIndex",
      value: function getSelectedIndex() {
        return this.flickityInstance.selectedIndex;
      }
    }, {
      key: "getSelectedCell",
      value: function getSelectedCell() {
        return this.flickityInstance.selectedCell.element;
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        if (this.initialConfig["breakpoints"] !== undefined) {
          this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
          document.addEventListener("breakpoint:changed", this._onBreakpointChangedListener);
        }
      }
      /**
       * Create the carousel instance
       */
    }, {
      key: "_build",
      value: function _build() {
        var _this = this;
        var config = this._processConfig();
        this.flickityInstance = new Flickity(this.element, config);
        this._validateDraggable();
        this.selectedIndex = this.flickityInstance.selectedIndex;
        this.flickityInstance.on("resize", this._validateDraggable.bind(this));
        if (this.options["onSelect"]) {
          this.flickityInstance.on("select", function () {
            // Flickity will send the "select" event whenever the window resize (even on mobile...), as a consequence we need to check
            // first if the slide index have changed or not (cf: https://github.com/metafizzy/flickity/issues/529)
            if (_this.selectedIndex !== _this.flickityInstance.selectedIndex) {
              _this.options["onSelect"](_this.flickityInstance.selectedIndex, _this.flickityInstance.selectedCell.element);
              _this.selectedIndex = _this.flickityInstance.selectedIndex;
            }
          });
        }
        if (this.options["onSettle"]) {
          this.flickityInstance.on("settle", function (index) {
            _this.options["onSettle"](index, _this.flickityInstance.selectedCell.element);
          });
        }
        if (this.options["onClick"]) {
          this.flickityInstance.on("staticClick", function (event, pointer, cell, index) {
            _this.options["onClick"](cell, index);
          });
        }
      }
      /**
       * By default, Flickity does not disable draggable automatically if there is nothing to slide. We therefore manually do the check here by checking
       * if the displayed elements equals to the amount of elements
       */
    }, {
      key: "_validateDraggable",
      value: function _validateDraggable() {
        var isActive = this.flickityInstance.isActive || false;
        if (!isActive || !this.flickityInstance.options["draggable"]) {
          return; // Not draggable, so nothing to do
        }
        if (undefined === this.flickityInstance.selectedElements || this.flickityInstance.selectedElements.length === this.flickityInstance.cells.length) {
          this.flickityInstance.unbindDrag();
        } else {
          this.flickityInstance.bindDrag();
        }
      }
      /**
       * Flickity is a CSS driven library and hence it is hard to setup some stuff in pure JS
       */
    }, {
      key: "_processConfig",
      value: function _processConfig() {
        var config = Object.assign({}, this.initialConfig);
        delete config["breakpoints"];
        if (this.initialConfig["breakpoints"] === undefined) {
          return config; // No change, we simply return the config as it is
        }
        var breakpoints = this.initialConfig["breakpoints"];
        breakpoints.forEach(function (breakpoint) {
          if (Responsive.matchesBreakpoint(breakpoint["matches"])) {
            config = Object.assign(config, breakpoint["settings"]);
          }
        });
        return config;
      }
      /**
       * Verify if the breakpoint has changed, and optionally update the carousel
       */
    }, {
      key: "_onBreakpointChanged",
      value: function _onBreakpointChanged() {
        // The breakpoint may have changed, so we delete the carousel and rebuild it
        this.flickityInstance.destroy();
        this._build();
      }
    }]);
    return Carousel;
  }();
  var Animation = /*#__PURE__*/function () {
    function Animation() {
      _classCallCheck(this, Animation);
    }
    _createClass(Animation, null, [{
      key: "slideUp",
      value:
      /**
       * Slide up aims to close an element. To do that, we take the height of the element, and set it to 0 to
       * force an animation
       */
      function slideUp(element) {
        element.style.height = "".concat(element.scrollHeight, "px"); // Force previous height to allow CSS transition

        element.offsetHeight; // Force redraw

        element.style.height = 0;
      }
      /**
       * Slide down aims to open an element. To do that, you must make sure that the element you are trying to open
       * is set with height: 0; overflow: hidden in the CSS, and does not contain any padding nor margin.
       */
    }, {
      key: "slideDown",
      value: function slideDown(element) {
        if (element.style.height === "auto") {
          return;
        } // To do the animation we temporarily hide it, check the height, and transition to it

        element.style.height = "".concat(element.firstElementChild.scrollHeight, "px");
        var transitionEnded = function transitionEnded(event) {
          if (event.propertyName === "height") {
            element.style.height = "auto"; // Allows the content to grow normally

            element.removeEventListener("transitionend", transitionEnded);
          }
        };
        element.addEventListener("transitionend", transitionEnded);
      }
    }]);
    return Animation;
  }();

  /**
   * Various DOM helper
   */
  var Dom = /*#__PURE__*/function () {
    function Dom() {
      _classCallCheck(this, Dom);
    }
    _createClass(Dom, null, [{
      key: "getSiblings",
      value:
      /**
       * Get all the previous and next siblings, optionally filtered by a selector
       */
      function getSiblings(element, filter) {
        var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var siblings = [];
        var currentElement = element; // Do the previous first

        while (currentElement = currentElement.previousElementSibling) {
          if (!filter || currentElement.matches(filter)) {
            siblings.push(currentElement);
          }
        }
        if (includeSelf) {
          siblings.push(element);
        } // Then the next side

        currentElement = element;
        while (currentElement = currentElement.nextElementSibling) {
          if (!filter || currentElement.matches(filter)) {
            siblings.push(currentElement);
          }
        }
        return siblings;
      }
      /**
       * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
       * we need to normalize it
       */
    }, {
      key: "nodeListToArray",
      value: function nodeListToArray(nodeList, filter) {
        var items = [];
        for (var i = 0; i !== nodeList.length; ++i) {
          if (!filter || nodeList[i].matches(filter)) {
            items.push(nodeList[i]);
          }
        }
        return items;
      }
      /**
       * Calculate an element width with its margin
       */
    }, {
      key: "outerWidthWithMargin",
      value: function outerWidthWithMargin(element) {
        var width = element.offsetWidth,
          style = getComputedStyle(element);
        width += parseInt(style.marginLeft) + parseInt(style.marginRight);
        return width;
      }
      /**
       * Calculate an element height with its margin
       */
    }, {
      key: "outerHeightWithMargin",
      value: function outerHeightWithMargin(element) {
        var height = element.offsetHeight,
          style = getComputedStyle(element);
        height += parseInt(style.marginTop) + parseInt(style.marginBottom);
        return height;
      }
    }]);
    return Dom;
  }();
  var Collapsible = /*#__PURE__*/function () {
    function Collapsible() {
      _classCallCheck(this, Collapsible);
      this.domDelegate = new domDelegate.Delegate(document.body);
      this._attachListeners();
    }
    _createClass(Collapsible, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        this.domDelegate.on("click", '[data-action="toggle-collapsible"]', this._toggleCollapsible.bind(this));
      }
      /**
       * Toggle a given collapsible
       */
    }, {
      key: "_toggleCollapsible",
      value: function _toggleCollapsible(event, target) {
        var _this = this;

        // If this is an auto-expand and that it reaches the needed breakpoint, we do nothing
        var parentCollapsible = target.closest(".Collapsible");
        if (parentCollapsible.classList.contains("Collapsible--autoExpand") && Responsive.matchesBreakpoint("tablet-and-up")) {
          return;
        }
        var isOpen = target.getAttribute("aria-expanded") === "true";
        if (isOpen) {
          this._close(parentCollapsible, target);
        } else {
          this._open(parentCollapsible, target);
        } // We make sure to close any siblings collapsible as well

        Dom.getSiblings(parentCollapsible).forEach(function (collapsibleToClose) {
          return _this._close(collapsibleToClose);
        });
        event.preventDefault();
      }
      /**
       * Open a given collapsible
       */
    }, {
      key: "_open",
      value: function _open(collapsible) {
        var toggleButton = collapsible.querySelector(".Collapsible__Button"),
          collapsibleInner = collapsible.querySelector(".Collapsible__Inner");
        if (!collapsibleInner || toggleButton.getAttribute("aria-expanded") === "true") {
          return; // It's already open
        }
        toggleButton.setAttribute("aria-expanded", "true");
        collapsibleInner.style.overflow = "visible";
        Animation.slideDown(collapsibleInner);
        setTimeout(function () {
          collapsible.style.overflow = "visible";
        }, 350);
      }
      /**
       * Close a given collapsible
       */
    }, {
      key: "_close",
      value: function _close(collapsible) {
        var toggleButton = collapsible.querySelector(".Collapsible__Button"),
          collapsibleInner = collapsible.querySelector(".Collapsible__Inner");
        if (!collapsibleInner || toggleButton.getAttribute("aria-expanded") === "false") {
          return; // It's already closed
        }
        toggleButton.setAttribute("aria-expanded", "false");
        collapsibleInner.style.overflow = "hidden";
        collapsible.style.overflow = "hidden";
        Animation.slideUp(collapsibleInner);
      }
    }]);
    return Collapsible;
  }();
  var Accessibility = /*#__PURE__*/function () {
    function Accessibility() {
      _classCallCheck(this, Accessibility);
    }
    _createClass(Accessibility, null, [{
      key: "trapFocus",
      value:
      /**
       * Traps the focus in a particular container
       */
      function trapFocus(container, namespace) {
        this.listeners = this.listeners || {}; // We check if there is an element with the attribute "autofocus"

        var elementToFocus = container.querySelector("[autofocus]") || container;
        container.setAttribute("tabindex", "-1");
        elementToFocus.focus();
        this.listeners[namespace] = function (event) {
          if (container !== event.target && !container.contains(event.target)) {
            container.focus();
          }
        };
        document.addEventListener("focusin", this.listeners[namespace]);
      }
      /**
       * Removes the trap of focus in a particular container
       */
    }, {
      key: "removeTrapFocus",
      value: function removeTrapFocus(container, namespace) {
        if (container) {
          container.removeAttribute("tabindex");
        }
        if (this.listeners && this.listeners[namespace]) {
          document.removeEventListener("focusin", this.listeners[namespace]);
        }
      }
      /**
       * Reset any previous trap focus
       */
    }, {
      key: "clearTrapFocus",
      value: function clearTrapFocus() {
        for (var key in this.listeners) {
          if (this.listeners.hasOwnProperty(key)) {
            document.removeEventListener("focusin", this.listeners[key]);
          }
        }
        this.listeners = {};
      }
    }]);
    return Accessibility;
  }();
  var Drawer = /*#__PURE__*/function () {
    function Drawer(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _classCallCheck(this, Drawer);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateBody = new domDelegate.Delegate(document.body);
      this.onOpen = options["onOpen"] || function () {};
      this.onClose = options["onClose"] || function () {};
      this.isOpen = false;
      this.direction = this.element.classList.contains("Drawer--fromLeft") ? "fromLeft" : "fromRight";
      this.pageOverlayElement = document.querySelector(".PageOverlay");
      this._attachListeners();
    }
    _createClass(Drawer, [{
      key: "destroy",
      value: function destroy() {
        this.delegateBody.off("click", '[data-action="open-drawer"][data-drawer-id="'.concat(this.element.id, '"]'));
        this.delegateBody.off("click", '[data-action="close-drawer"][data-drawer-id="'.concat(this.element.id, '"]'));
        window.removeEventListener("resize", this._calculateMaxHeightListener);
      }
    }, {
      key: "toggle",
      value: function toggle() {
        this.isOpen ? this.close() : this.open();
      }
    }, {
      key: "open",
      value: function open(event) {
        if (this.isOpen) {
          return;
        } // Make sure that the search is closed whenever a drawer is opened

        this.element.dispatchEvent(new CustomEvent("search:close", {
          bubbles: true
        }));
        if (event) {
          event.preventDefault();
        }
        this.element.setAttribute("aria-hidden", "false");
        this._calculateMaxHeight();
        document.documentElement.classList.add("no-scroll"); // This prevent the body to scroll on iOS. This is honestly a bit hacky, but until the platform supports "touch-action: none" like
        // other browsers, this is the only way to achieve that
        //disableBodyScroll(true, '[data-scrollable]');

        Accessibility.trapFocus(this.element, "drawer");
        document.querySelector("#shopify-section-header").style.zIndex = ""; // Ugly hack
        // We attach an event to the page overlay to close it

        this.pageOverlayElement.classList.add("is-visible");
        this.pageOverlayElement.addEventListener("click", this._closeListener);
        this.isOpen = true;
        this.onOpen(); // Call the callback to allow other code to hook their logic

        return false;
      }
    }, {
      key: "close",
      value: function close(event) {
        if (!this.isOpen) {
          return;
        }
        if (event) {
          event.preventDefault();
        }
        this.element.setAttribute("aria-hidden", "true");
        document.documentElement.classList.remove("no-scroll"); //disableBodyScroll(false, '[data-scrollable]');

        Accessibility.removeTrapFocus(this.element, "drawer");
        this.pageOverlayElement.classList.remove("is-visible");
        this.pageOverlayElement.removeEventListener("click", this._closeListener);
        this.isOpen = false;
        this.onClose(); // Call the callback to allow other code to hook their logic
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._openListener = this.open.bind(this);
        this._closeListener = this.close.bind(this);
        this._calculateMaxHeightListener = this._calculateMaxHeight.bind(this);
        this.delegateBody.on("click", '[data-action="open-drawer"][data-drawer-id="'.concat(this.element.id, '"]'), this._openListener);
        this.delegateBody.on("click", '[data-action="close-drawer"][data-drawer-id="'.concat(this.element.id, '"]'), this._closeListener);
        this.element.addEventListener("keyup", this._handleKeyboard.bind(this));
        window.addEventListener("resize", this._calculateMaxHeightListener);
      }
      /**
       * Make sure that we force a max-height so that the drawer always stays on screen
       */
    }, {
      key: "_calculateMaxHeight",
      value: function _calculateMaxHeight() {
        this.element.style.maxHeight = window.innerHeight + "px";
      }
    }, {
      key: "_handleKeyboard",
      value:
      /**
       * Handle a11y events
       */
      function _handleKeyboard(event) {
        if (this.isOpen && event.keyCode === 27) {
          this.close();
        }
      }
    }]);
    return Drawer;
  }();

  /**
   * Simple plugin that handles the loading bar actions
   *
   * This plugin uses delegate events so it's independent of the sections.
   */
  var LoadingBar = /*#__PURE__*/function () {
    function LoadingBar() {
      _classCallCheck(this, LoadingBar);
      this.element = document.querySelector(".LoadingBar");
      document.addEventListener("theme:loading:start", this._onLoadingStart.bind(this));
      document.addEventListener("theme:loading:end", this._onLoadingEnd.bind(this));
      this.element.addEventListener("transitionend", this._onTransitionEnd.bind(this));
    }
    _createClass(LoadingBar, [{
      key: "_onLoadingStart",
      value: function _onLoadingStart() {
        this.element.classList.add("is-visible");
        this.element.style.width = "40%";
      }
    }, {
      key: "_onLoadingEnd",
      value: function _onLoadingEnd() {
        this.element.style.width = "100%";
        this.element.classList.add("is-finished");
      }
    }, {
      key: "_onTransitionEnd",
      value: function _onTransitionEnd(event) {
        if (event.propertyName === "width" && this.element.classList.contains("is-finished")) {
          this.element.classList.remove("is-visible");
          this.element.classList.remove("is-finished");
          this.element.style.width = "0";
        }
      }
    }]);
    return LoadingBar;
  }();
  var Modal = /*#__PURE__*/function () {
    function Modal() {
      _classCallCheck(this, Modal);
      this.domDelegate = new domDelegate.Delegate(document.body);
      this.activeModal = null; // Keep track of the active modal

      this.wasLocked = false;
      this.pageOverlayElement = document.querySelector(".PageOverlay");
      this._attachListeners();
      this._checkOpenByHash();
    }
    _createClass(Modal, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        this._closeListener = this._closeModal.bind(this);
        this._handleKeyboardListener = this._handleKeyboard.bind(this);
        this.domDelegate.on("click", '[data-action="open-modal"]', this._openModalEvent.bind(this));
        this.domDelegate.on("click", '[data-action="close-modal"]', this._closeModal.bind(this));
      }
    }, {
      key: "_openModalEvent",
      value: function _openModalEvent(event, target) {
        this._openModal(document.getElementById(target.getAttribute("aria-controls")));
        event.preventDefault();
        event.stopPropagation();
      }
    }, {
      key: "_openModal",
      value: function _openModal(modal) {
        var _this = this;
        if (this.activeModal || !modal) {
          return; // If there is already an open modal, we return as we only allows one modal at a time
        }
        this.activeModal = modal;
        this.domDelegate.on("keyup", this._handleKeyboardListener);
        if (document.documentElement.classList.contains("no-scroll")) {
          this.wasLocked = true;
        }
        fastdom.mutate(function () {
          Accessibility.clearTrapFocus(); // Needed as the modal can be open on top of a popover

          _this._onTransitionEndedListener = _this._onTransitionEnded.bind(_this);
          _this.activeModal.addEventListener("transitionend", _this._onTransitionEndedListener);
          _this.activeModal.setAttribute("aria-hidden", "false");
          document.documentElement.classList.add("no-scroll"); // If the modal is not a fullscreen modal, then we also display the overlay

          if (!_this.activeModal.classList.contains("Modal--fullScreen")) {
            _this.pageOverlayElement.classList.add("is-visible");
            _this.pageOverlayElement.addEventListener("click", _this._closeListener);
          }
        });
      }
    }, {
      key: "_closeModal",
      value: function _closeModal() {
        var _this2 = this;
        if (!this.activeModal) {
          return; // If no modal are open, we return immediately
        }
        this.activeModal.removeEventListener("keyup", this._handleKeyboardListener);
        this.domDelegate.off("keyup");
        fastdom.mutate(function () {
          // If the modal is of video type, we need to remove the iframe to stop the video
          if (_this2.activeModal.classList.contains("Modal--videoContent")) {
            _this2._resetVideoListener = _this2._resetVideo.bind(_this2);
            _this2.activeModal.addEventListener("transitionend", _this2._resetVideoListener);
          }
          Accessibility.removeTrapFocus(_this2.activeModal, "modal");
          if (!_this2.activeModal.classList.contains("Modal--fullScreen")) {
            _this2.pageOverlayElement.classList.remove("is-visible");
            _this2.pageOverlayElement.removeEventListener("click", _this2._closeListener);
          }
          _this2.activeModal.setAttribute("aria-hidden", "true");
          _this2.activeModal = null;
          if (!_this2.wasLocked) {
            document.documentElement.classList.remove("no-scroll");
          }
        });
      }
    }, {
      key: "_onTransitionEnded",
      value: function _onTransitionEnded(event) {
        if (event.propertyName !== "visibility") {
          return;
        }
        Accessibility.trapFocus(this.activeModal, "modal"); // Trap the focus first (as this trigger reflows)

        this.activeModal.removeEventListener("transitionend", this._onTransitionEndedListener);
      }
    }, {
      key: "_resetVideo",
      value: function _resetVideo(event) {
        if (event.propertyName !== "visibility") {
          return; // We check the visibility property as it's the one LazySizes uses for triggering lazyloading
        }
        var iframe = event.target.querySelector("iframe");
        iframe.parentNode.innerHTML = '<iframe class="Image--lazyLoad" data-src='.concat(iframe.getAttribute("data-src"), ' frameborder="0" allowfullscreen>');
        event.target.removeEventListener("transitionend", this._resetVideoListener);
      }
      /**
       * Some forms needs to be open inside a modal, and on page reload we must make sure to properly open the modal again
       */
    }, {
      key: "_checkOpenByHash",
      value: function _checkOpenByHash() {
        var hash = window.location.hash,
          modal = document.getElementById(hash.replace("#", ""));
        if (modal && modal.classList.contains("Modal")) {
          this._openModal(modal);
        }
      }
      /**
       * Handle a11y events
       */
    }, {
      key: "_handleKeyboard",
      value: function _handleKeyboard(event) {
        if (null !== this.activeModal && event.keyCode === 27) {
          this._closeModal();
        }
      }
    }]);
    return Modal;
  }();
  var Popover = /*#__PURE__*/function () {
    function Popover(element, options) {
      _classCallCheck(this, Popover);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.activator = options["activator"] || document.querySelector('[aria-controls="'.concat(element.getAttribute("id"), '"]'));
      this.preferredPosition = options["preferredPosition"] || "bottom";
      this.preferredAlignment = options["preferredAlignment"] || undefined;
      this.threshold = options["threshold"] || 20;
      this.isOpen = false;
      this.onValueChanged = options["onValueChanged"] || function () {};
      this.onOpen = options["onOpen"] || function () {};
      this.onClose = options["onClose"] || function () {};
      this.showOverlay = options["showOverlay"] === undefined ? true : options["showOverlay"];
      this.pageOverlayElement = document.querySelector(".PageOverlay");
      this._attachListeners();
    }
    _createClass(Popover, [{
      key: "destroy",
      value: function destroy() {
        this.element.removeEventListener("keyup", this._handleKeyboardListener);
        this.delegateElement.off("click");
        this.activator.removeEventListener("click", this._toggleListener);
      }
    }, {
      key: "toggle",
      value: function toggle() {
        this.isOpen ? this.close() : this.open();
      }
    }, {
      key: "open",
      value: function open() {
        var _this = this;

        // Note: the additional check on the aria-controls is used here so that a given activator can be used on different
        //       popovers and be modified dynamically in JavaScript
        if (this.isOpen || this.activator.getAttribute("aria-controls") !== this.element.id) {
          return;
        }
        this.element.setAttribute("aria-hidden", "false");
        this.activator.setAttribute("aria-expanded", "true");
        disableBodyScroll(true, "[data-scrollable]");
        document.documentElement.classList.add("no-scroll"); // Prevent scrolling when popover is open

        if (Responsive.matchesBreakpoint("lap-and-up")) {
          document.body.addEventListener("click", this._clickOutsideListener);
          this._position();
          this.element.setAttribute("tabindex", "-1");
          this.element.addEventListener("transitionend", function () {
            _this.element.focus();
          }, {
            once: true
          });
        } else {
          this.element.removeAttribute("style");
          if (this.showOverlay) {
            this.pageOverlayElement.classList.add("is-visible");
            this.pageOverlayElement.addEventListener("click", this._closeListener);
          }
        }
        this.onOpen(this); // Call the callback to allow other code to hook their logic

        this.isOpen = true;
      }
    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }
        this.element.setAttribute("aria-hidden", "true");
        this.activator.setAttribute("aria-expanded", "false");
        disableBodyScroll(false, "[data-scrollable]");
        document.documentElement.classList.remove("no-scroll");
        if (Responsive.matchesBreakpoint("lap-and-up")) {
          document.body.removeEventListener("click", this._clickOutsideListener);
        } else if (this.showOverlay) {
          this.pageOverlayElement.classList.remove("is-visible");
          this.pageOverlayElement.removeEventListener("click", this._closeListener);
        }
        this.element.removeAttribute("tabindex");
        this.activator.focus();
        this.onClose(this); // Call the callback to allow other code to hook their logic

        this.isOpen = false;
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._handleKeyboardListener = this._handleKeyboard.bind(this);
        this._clickOutsideListener = this._clickOutside.bind(this);
        this._closeListener = this.close.bind(this);
        this._toggleListener = this.toggle.bind(this);
        this.element.addEventListener("keyup", this._handleKeyboardListener);
        this.activator.addEventListener("click", this._toggleListener);
        this.delegateElement.on("click", '[data-action="close-popover"]', this.close.bind(this));
        this.delegateElement.on("click", '[data-action="select-value"]', this._valueChanged.bind(this));
        if (this.element.hasAttribute("id")) {
          this.delegateElement.on("focusout", "#".concat(this.element.getAttribute("id")), this._onFocusOut.bind(this));
        }
      }
      /**
       * Whenever a value is selected, it can notify a callback so that the calling code can do its own logic in response
       * of the value change
       */
    }, {
      key: "_valueChanged",
      value: function _valueChanged(event) {
        Dom.getSiblings(event.target, ".is-selected").forEach(function (item) {
          return item.classList.remove("is-selected");
        });
        event.target.classList.add("is-selected"); // If there is a callback in option we call it with the value

        this.onValueChanged(event.target.getAttribute("data-value"), event.target, this.activator);
        this.close();
      }
    }, {
      key: "_onFocusOut",
      value: function _onFocusOut(event) {
        if (!this.element.contains(event.relatedTarget) && event.relatedTarget !== this.activator) {
          this.close();
        }
      }
      /**
       * Callback that is called to decide if we should close the popover when a click is captured outside
       */
    }, {
      key: "_clickOutside",
      value: function _clickOutside(event) {
        if (!event.target.closest(".Popover") && !event.target.closest(".Modal") && event.target !== this.activator && !this.activator.contains(event.target)) {
          this.close();
        }
      }
      /**
       * On desktop, we reposition the popover in JavaScript by doing some smart logic to detect the most appropriate area
       */
    }, {
      key: "_position",
      value: function _position() {
        var _this2 = this;
        var topPosition = 0,
          rightPosition = 0,
          position = "",
          alignment = "",
          threshold = this.threshold;
        fastdom.measure(function () {
          var windowHeight = window.innerHeight,
            activatorBoundingRect = _this2.activator.getBoundingClientRect(),
            halfHeight = windowHeight / 2;
          if (_this2.preferredPosition === "bottom") {
            alignment = "right";
            if (_this2.element.clientHeight <= windowHeight - (activatorBoundingRect.bottom + threshold) || windowHeight - activatorBoundingRect.bottom >= halfHeight) {
              position = "bottom";
            } else {
              position = "top";
            }
          } else if (_this2.preferredPosition === "top") {
            alignment = "right";
            if (_this2.element.clientHeight <= activatorBoundingRect.top - threshold || activatorBoundingRect.top >= halfHeight) {
              position = "top";
            } else {
              position = "bottom";
            }
          } else {
            position = "left"; // Is there enough space to use the center alignment (which is preferred)?

            var halfElementHeight = _this2.element.clientHeight / 2;
            if (activatorBoundingRect.top >= halfElementHeight && windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
              alignment = "center";
            } else if (windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
              alignment = "bottom";
            } else {
              alignment = "top";
            }
          }
          if (_this2.preferredAlignment) {
            alignment = _this2.preferredAlignment;
          }
          if (position === "top") {
            topPosition = activatorBoundingRect.top - _this2.element.clientHeight - threshold;
            if (alignment === "center") {
              rightPosition = window.innerWidth - activatorBoundingRect.right - _this2.element.clientWidth / 2 + 3;
            } else {
              rightPosition = window.innerWidth - activatorBoundingRect.right;
            }
          } else if (position === "bottom") {
            topPosition = activatorBoundingRect.bottom + threshold;
            if (alignment === "center") {
              rightPosition = window.innerWidth - activatorBoundingRect.right - _this2.element.clientWidth / 2 + 3;
            } else {
              rightPosition = window.innerWidth - activatorBoundingRect.right;
            }
          } else {
            rightPosition = window.innerWidth - activatorBoundingRect.left + threshold;
            if (alignment === "center") {
              topPosition = activatorBoundingRect.top - _this2.element.clientHeight / 2 + _this2.activator.clientHeight / 2;
            } else if (alignment === "top") {
              topPosition = activatorBoundingRect.bottom - _this2.element.clientHeight;
            } else {
              topPosition = activatorBoundingRect.top;
            }
          }
        });
        fastdom.mutate(function () {
          ;
          ["Popover--positionBottom", "Popover--positionTop", "Popover--positionCenter", "Popover--alignTop", "Popover--alignCenter", "Popover--alignBottom"].map(function (item) {
            return _this2.element.classList.remove(item);
          });
          _this2.element.classList.add("Popover--position".concat(position.charAt(0).toUpperCase() + position.slice(1)));
          _this2.element.classList.add("Popover--align".concat(alignment.charAt(0).toUpperCase() + alignment.slice(1)));
          _this2.element.setAttribute("style", "top: ".concat(parseInt(topPosition), "px; right: ").concat(parseInt(rightPosition), "px;"));
        });
      }
      /**
       * Handle a11y events
       */
    }, {
      key: "_handleKeyboard",
      value: function _handleKeyboard(event) {
        if (this.isOpen && event.keyCode === 27) {
          this.close();
        }
      }
    }]);
    return Popover;
  }();

  /**
   * This class will coordinate all the transitions from the website
   */
  var PageTransition = /*#__PURE__*/function () {
    function PageTransition() {
      _classCallCheck(this, PageTransition);
      this.domDelegate = new domDelegate.Delegate(document.body);
      this.pageTransition = document.querySelector(".PageTransition");
      this._attachListeners();
    }
    _createClass(PageTransition, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        this.domDelegate.on("click", 'a[href]:not([href^="#"]):not([href^="javascript:"]):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])', this._onPageUnload.bind(this));
      }
      /**
       * This callback captures click and transition from one page to another by doing a transition
       */
    }, {
      key: "_onPageUnload",
      value: function _onPageUnload(event, target) {
        var _this = this;
        if (event.defaultPrevented || event.ctrlKey || event.metaKey || !window.theme.showPageTransition || !this.pageTransition) {
          return;
        }
        event.preventDefault(); // Prevent the click to happen

        if (window.theme.showPageTransition && this.pageTransition) {
          var doTransition = function doTransition(event) {
            // Animation is finished, we can transition
            if (event.propertyName === "opacity") {
              _this.pageTransition.removeEventListener("transitionend", doTransition);
              window.location.href = target.href;
            }
          };
          this.pageTransition.addEventListener("transitionend", doTransition);
          this.pageTransition.style.visibility = "visible";
          this.pageTransition.style.opacity = "1";
        }
      }
    }], [{
      key: "getInstance",
      value: function getInstance() {
        if (!this.instance) {
          this.instance = new PageTransition();
        }
        return this.instance;
      }
    }]);
    return PageTransition;
  }();

  /**
   * Note: this was a feature that was added at the very end and couldn't do something much cleaner without rewriting large parts of the theme...
   */
  var ProductItemColorSwatch = /*#__PURE__*/function () {
    function ProductItemColorSwatch(element) {
      _classCallCheck(this, ProductItemColorSwatch);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateElement.on("change", ".ColorSwatch__Radio", this._colorChanged.bind(this));
    }
    _createClass(ProductItemColorSwatch, [{
      key: "_colorChanged",
      value: function _colorChanged(event, target) {
        // We need to change the URL of the various links
        var productItem = target.closest(".ProductItem"),
          variantUrl = target.getAttribute("data-variant-url");
        productItem.querySelector(".ProductItem__ImageWrapper").setAttribute("href", variantUrl);
        productItem.querySelector(".ProductItem__Title > a").setAttribute("href", variantUrl); // If we have a custom image for the variant, we change it

        var originalImageElement = productItem.querySelector(".ProductItem__Image:not(.ProductItem__Image--alternate)");
        if (target.hasAttribute("data-image-url") && target.getAttribute("data-image-id") !== originalImageElement.getAttribute("data-image-id")) {
          var newImageElement = document.createElement("img");
          newImageElement.className = "ProductItem__Image Image--fadeIn Image--lazyLoad";
          newImageElement.setAttribute("data-image-id", target.getAttribute("data-image-id"));
          newImageElement.setAttribute("data-src", target.getAttribute("data-image-url"));
          newImageElement.setAttribute("data-widths", target.getAttribute("data-image-widths"));
          newImageElement.setAttribute("data-sizes", "auto"); // Replace the original node

          if (window.theme.productImageSize === "natural") {
            originalImageElement.parentNode.style.paddingBottom = "".concat(100.0 / target.getAttribute("data-image-aspect-ratio"), "%");
          }
          originalImageElement.parentNode.style.setProperty("--aspect-ratio", target.getAttribute("data-image-aspect-ratio"));
          originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
        }
      }
    }]);
    return ProductItemColorSwatch;
  }();
  var Image = /*#__PURE__*/function () {
    function Image() {
      _classCallCheck(this, Image);
    }
    _createClass(Image, null, [{
      key: "getSizedImageUrl",
      value:
      /**
       * Create a CDN URL (similar to the img_url filter in Liquid)
       */
      function getSizedImageUrl(src, size) {
        if (size === null) {
          return src;
        }
        if (size === "master") {
          return src.replace(/http(s)?:/, "");
        }
        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (match) {
          var prefix = src.split(match[0]);
          var suffix = match[0];
          return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
        } else {
          return null;
        }
      }
      /**
       * From a given set of desired sizes and a given image, filter out any unwanted sizes
       */
    }, {
      key: "getSupportedSizes",
      value: function getSupportedSizes(image, desiredSizes) {
        var supportedSizes = [],
          imageWidth = image["width"];
        desiredSizes.forEach(function (width) {
          if (imageWidth >= width) {
            supportedSizes.push(width);
          }
        });
        return supportedSizes;
      }
    }]);
    return Image;
  }();
  var ProductImageZoom = /*#__PURE__*/function () {
    function ProductImageZoom(element, slideshow) {
      _classCallCheck(this, ProductImageZoom);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateRoot = new domDelegate.Delegate(document.body);
      this.slideshow = slideshow;
      this._attachListeners();
    }
    _createClass(ProductImageZoom, [{
      key: "destroy",
      value: function destroy() {
        this.delegateElement.off("click");
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on("click", '[data-action="open-product-zoom"]', this._initPhotoSwipe.bind(this));
        this.delegateElement.on("click", ".Product__SlideItem--image", this._initPhotoSwipeFromImageClick.bind(this));
      }
      /**
       * To save performance, we only initialize PhotoSwipe when it's requested. All high resolution images
       * are also loaded only on demand. Also, please note that PhotoSwipe is always completely destroyed
       * whenever it is closed, so it stays super snappy
       */
    }, {
      key: "_initPhotoSwipe",
      value: function _initPhotoSwipe() {
        var images = [];
        this.slideshow.flickityInstance.cells.forEach(function (item) {
          if (item.element.classList.contains("Product__SlideItem--image")) {
            images.push(item.element.querySelector("img"));
          }
        });
        this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(images), parseInt(this.slideshow.flickityInstance.selectedElement.getAttribute("data-image-media-position")));
      }
      /**
       * On desktop we do not have the dedicated small icon, instead the zoom is triggered when clicking directly on the image
       */
    }, {
      key: "_initPhotoSwipeFromImageClick",
      value: function _initPhotoSwipeFromImageClick(event, target) {
        // Opening this way is only available on desktop
        if (Responsive.matchesBreakpoint("pocket")) {
          return;
        }
        var images = Dom.nodeListToArray(this.element.querySelectorAll(".Product__SlideItem--image img"));
        this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(images), parseInt(target.getAttribute("data-image-media-position")));
      }
      /**
       * Take a list of images and create a PhotoSwipe array. This is called whenever the gallery is initialized.
       */
    }, {
      key: "_createPhotoSwipeItemsFromImages",
      value: function _createPhotoSwipeItemsFromImages(images) {
        return images.map(function (image) {
          var maxWidth = parseInt(image.getAttribute("data-max-width")),
            maxHeight = parseInt(image.getAttribute("data-max-height")),
            maxDimension = Responsive.matchesBreakpoint("phone") ? 1200 : 1800,
            // 1200 is max size for mobile and 1800 for larger devices
            reduceFactor = 1.0;
          if (maxWidth >= maxHeight) {
            reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
          } else {
            reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
          }
          var requestedWidth = Math.floor(maxWidth / reduceFactor);
          var requestedHeight = Math.floor(maxHeight / reduceFactor);
          return {
            msrc: image.currentSrc || image.src,
            // For browser that supports srcset, currentSrc is the currently used image
            w: requestedWidth,
            h: requestedHeight,
            initialZoomLevel: 0.65,
            src: Image.getSizedImageUrl(image.getAttribute("data-original-src"), requestedWidth + "x" + requestedHeight)
          };
        });
      }
      /**
       * Take a list of nodes containing all images and create a PhotoSwipe array. This is called
       * whenever the gallery is initialized.
       */
    }, {
      key: "_createPhotoSwipeInstance",
      value: function _createPhotoSwipeInstance(items, selectedImageIndex) {
        var _this = this;
        var photoswipeContainer = document.querySelector(".pswp");
        this.photoSwipeInstance = new PhotoSwipe(photoswipeContainer, false, items, {
          index: selectedImageIndex,
          showHideOpacity: true,
          showAnimationDuration: 500,
          loop: false,
          history: false,
          closeOnVerticalDrag: false,
          allowPanToNext: false,
          pinchToClose: false,
          errorMsg: '<p class="pswp__error-msg">' + window.languages.productImageLoadingError + "</p>",
          scaleMode: "zoom",
          getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
            if (isMouseClick) {
              return 1.6;
            } else {
              return item.initialZoomLevel < 0.7 ? 1 : 1.33;
            }
          },
          getThumbBoundsFn: function getThumbBoundsFn(index) {
            var thumbnail = _this.element.querySelector('.Product__Slideshow .Carousel__Cell[data-image-media-position="'.concat(parseInt(index), '"] img')),
              pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
              rect = thumbnail.getBoundingClientRect();
            return {
              x: rect.left,
              y: rect.top + pageYScroll,
              w: rect.width
            };
          }
        }); // We need to patch PhotoSwipe update size to solve iOS 15 issue

        var originalUpdateSize = this.photoSwipeInstance.updateSize,
          lastWidth = null;
        this.photoSwipeInstance.updateSize = function () {
          if (lastWidth === null || lastWidth !== window.innerWidth) {
            originalUpdateSize(this, arguments);
          }
          lastWidth = window.innerWidth;
        };
        this.photoSwipeInstance.listen("beforeChange", this._onSlideChanged.bind(this));
        this.photoSwipeInstance.listen("destroy", this._destroyPhotoSwipe.bind(this));
        this.photoSwipeInstance.listen("doubleTap", this._onDoubleTap.bind(this));
        this.photoSwipeInstance.listen("initialZoomIn", this._onInitialZoomIn.bind(this));
        this.photoSwipeInstance.listen("initialZoomOut", this._onInitialZoomOut.bind(this));
        this.delegateRoot.on("pswpTap", ".pswp__scroll-wrap", this._onSingleTap.bind(this));
        this.delegateRoot.on("pswpTap", ".pswp__button--close", this.photoSwipeInstance.close);
        this.delegateRoot.on("pswpTap", ".pswp__button--prev", this.photoSwipeInstance.prev);
        this.delegateRoot.on("pswpTap", ".pswp__button--next", this.photoSwipeInstance.next);
        this.photoSwipeInstance.init();
      }
      /**
       * Update the nav
       */
    }, {
      key: "_onSlideChanged",
      value: function _onSlideChanged() {
        if (this.photoSwipeInstance.getCurrentIndex() === 0) {
          this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--prev").setAttribute("disabled", "disabled");
        } else {
          this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--prev").removeAttribute("disabled");
        }
        if (this.photoSwipeInstance.getCurrentIndex() + 1 === this.photoSwipeInstance.options.getNumItemsFn()) {
          this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--next").setAttribute("disabled", "disabled");
        } else {
          this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--next").removeAttribute("disabled");
        }
      }
      /**
       * This event is a bit different and is triggered when the user click somewhere. We use it do allow to zoom in and
       * zoom out in the image on desktop and use for the UI
       */
    }, {
      key: "_onSingleTap",
      value: function _onSingleTap(event) {
        if (!event.detail || event.detail.pointerType === "mouse") {
          if (event.target.classList.contains("pswp__img")) {
            this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
          }
        } else {
          if (event.target.classList.contains("pswp__button")) {
            return;
          }
          event.target.closest(".pswp").querySelector(".pswp__ui").classList.toggle("pswp__ui--hidden");
        }
      }
    }, {
      key: "_onDoubleTap",
      value: function _onDoubleTap(point) {
        var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;
        if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
          this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
        } else {
          this.photoSwipeInstance.zoomTo(initialZoomLevel < 0.7 ? 1 : 1.33, point, 333);
        }
      }
    }, {
      key: "_onInitialZoomIn",
      value: function _onInitialZoomIn() {
        document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
      }
    }, {
      key: "_onInitialZoomOut",
      value: function _onInitialZoomOut() {
        document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
      }
      /**
       * PhotoSwipe instance is automatically destroyed for us when it's closed. What we need to do is simply re-set
       * our in-memory instance to null and our own events
       */
    }, {
      key: "_destroyPhotoSwipe",
      value: function _destroyPhotoSwipe() {
        this.delegateRoot.off("pswpTap");
        this.photoSwipeInstance = null;
      }
    }]);
    return ProductImageZoom;
  }();
  var ProductModel = /*#__PURE__*/function () {
    function ProductModel(element, stackProductImages) {
      _classCallCheck(this, ProductModel);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateRoot = new domDelegate.Delegate(document.documentElement);
      this.stackProductImages = stackProductImages;
      this._attachListeners();
      var stylesheet = document.createElement("link");
      stylesheet.rel = "stylesheet";
      stylesheet.href = "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css";
      document.head.appendChild(stylesheet);
      window.Shopify.loadFeatures([{
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this._setupModelViewerUI.bind(this)
      }, {
        name: "shopify-xr",
        version: "1.0"
      }]);
    }
    _createClass(ProductModel, [{
      key: "destroy",
      value: function destroy() {}
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        var _this = this;
        this.element.querySelector("model-viewer").addEventListener("shopify_model_viewer_ui_toggle_play", function () {
          _this.element.dispatchEvent(new CustomEvent("model:played", {
            bubbles: true
          }));
        });
        this.element.querySelector("model-viewer").addEventListener("shopify_model_viewer_ui_toggle_pause", function () {
          _this.element.dispatchEvent(new CustomEvent("model:paused", {
            bubbles: true
          }));
        });
      }
    }, {
      key: "hasBeenSelected",
      value: function hasBeenSelected() {
        // As per guidelines, we only need to autoplay when it's not a touch device
        if (Responsive.matchesBreakpoint("supports-hover")) {
          this.modelUi.play();
        }
      }
    }, {
      key: "hasBeenDeselected",
      value: function hasBeenDeselected() {
        // In all cases, we just turn it off
        this.modelUi.pause();
      }
    }, {
      key: "_setupModelViewerUI",
      value: function _setupModelViewerUI() {
        this.modelElement = this.element.querySelector("model-viewer");
        this.modelUi = new window.Shopify.ModelViewerUI(this.modelElement);
      }
    }]);
    return ProductModel;
  }();
  var ProductReviews = /*#__PURE__*/function () {
    function ProductReviews(container) {
      _classCallCheck(this, ProductReviews);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateElement.on("click", ".spr-summary-actions-newreview", this._onNewReviewClicked.bind(this)); // Extending Shopify Reviews is a bit manual, but let's do it!

      window.SPRCallbacks = {};
      window.SPRCallbacks.onFormSuccess = this._onFormSuccess.bind(this);
      window.SPRCallbacks.onReviewsLoad = this._onReviewsLoad.bind(this);
    }
    _createClass(ProductReviews, [{
      key: "destroy",
      value: function destroy() {
        this.delegateElement.off();
      }
    }, {
      key: "_updatePagination",
      value: function _updatePagination(event, target) {
        // Unfortunately, we have to use this ugly jQuery style stuff
        SPR.$(target).data("page", parseInt(target.getAttribute("data-page")) + 1);
      }
    }, {
      key: "_onFormSuccess",
      value: function _onFormSuccess() {
        var formSuccess = this.element.querySelector(".spr-form-message-success");
        window.scrollTo(0, formSuccess.offsetTop - 45);
      }
    }, {
      key: "_onReviewsLoad",
      value: function _onReviewsLoad() {
        // We want to move "spr-pagination-next" before the "new review" button in the "spr-summary-actions" div
        var sprSummaryActions = this.element.querySelector(".spr-summary-actions"),
          previousSprPaginationNext = sprSummaryActions.querySelector(".spr-pagination-next"),
          sprPaginationNext = this.element.querySelector(".spr-pagination .spr-pagination-next");
        if (previousSprPaginationNext) {
          previousSprPaginationNext.remove();
        }
        if (sprPaginationNext) {
          sprSummaryActions.insertBefore(sprPaginationNext, sprSummaryActions.firstChild);
        }
      }
    }, {
      key: "_onNewReviewClicked",
      value: function _onNewReviewClicked(event, target) {
        target.style.display = "none";
        if (target.previousElementSibling) {
          target.previousElementSibling.style.display = "none";
        }
      }
    }]);
    return ProductReviews;
  }();

  /**
   * This implementation allows to serialize a form
   */
  var Form = /*#__PURE__*/function () {
    function Form() {
      _classCallCheck(this, Form);
    }
    _createClass(Form, null, [{
      key: "serialize",
      value: function serialize(form) {
        function stringKey(key, value) {
          var beginBracket = key.lastIndexOf("[");
          if (beginBracket === -1) {
            var _hash = {};
            _hash[key] = value;
            return _hash;
          }
          var newKey = key.substr(0, beginBracket);
          var newValue = {};
          newValue[key.substring(beginBracket + 1, key.length - 1)] = value;
          return stringKey(newKey, newValue);
        }
        var hash = {};
        for (var i = 0, len = form.elements.length; i < len; i++) {
          var formElement = form.elements[i];
          if (formElement.name === "" || formElement.disabled) {
            continue;
          }
          if (formElement.name && !formElement.disabled && (formElement.checked || /select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
            var stringKeys = stringKey(formElement.name, formElement.value);
            hash = Form.extend(hash, stringKeys);
          }
        }
        return hash;
      }
    }, {
      key: "extend",
      value: function extend() {
        var extended = {};
        var i = 0; // Merge the object into the extended object

        var merge = function merge(obj) {
          for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
              // If property is an object, merge properties
              if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
                extended[prop] = Form.extend(extended[prop], obj[prop]);
              } else {
                extended[prop] = obj[prop];
              }
            }
          }
        }; // Loop through each object and conduct a merge

        for (; i < arguments.length; i++) {
          merge(arguments[i]);
        }
        return extended;
      }
    }]);
    return Form;
  }();
  var Currency = /*#__PURE__*/function () {
    function Currency() {
      _classCallCheck(this, Currency);
    }
    _createClass(Currency, null, [{
      key: "formatMoney",
      value:
      /**
       * Format money values based on your shop currency settings
       *
       * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
       * @param  {String} format - shop money_format setting
       * @return {String} value - formatted value
       */
      function formatMoney(cents, format) {
        if (typeof cents === "string") {
          cents = cents.replace(".", "");
        }
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
          formatString = format || "${{amount}}";
        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }
        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultTo(precision, 2);
          thousands = defaultTo(thousands, ",");
          decimal = defaultTo(decimal, ".");
          if (isNaN(number) || number == null) {
            return 0;
          }
          number = (number / 100.0).toFixed(precision);
          var parts = number.split("."),
            dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
            centsAmount = parts[1] ? decimal + parts[1] : "";
          return dollarsAmount + centsAmount;
        }
        var value = "";
        switch (formatString.match(placeholderRegex)[1]) {
          case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
          case "amount_with_space_separator":
            value = formatWithDelimiters(cents, 2, " ", ".");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ",", ".");
            break;
          case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ");
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
        }
        if (formatString.indexOf("with_comma_separator") !== -1) {
          return formatString.replace(placeholderRegex, value).replace(",00", "");
        } else {
          return formatString.replace(placeholderRegex, value).replace(".00", "");
        }
      }
    }]);
    return Currency;
  }();
  var VariantSelector = /*#__PURE__*/function () {
    function VariantSelector(element, parentProductVariants) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      _classCallCheck(this, VariantSelector);
      this.element = element;
      this.parentProductVariants = parentProductVariants;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.activator = options["activator"] || document.querySelector('[aria-controls="'.concat(element.getAttribute("id"), '"]'));
      this.onValueChangedCallback = options["onValueChanged"] || function () {};
      this.isOpen = false;
      this.pageOverlayElement = document.querySelector(".PageOverlay");
      this.variantChoiceList = Dom.nodeListToArray(this.element.querySelectorAll(".VariantSelector__Choice"));
      this.variantCarousel = new Carousel(this.element.querySelector(".VariantSelector__Carousel"), {
        onSelect: this._variantChanged.bind(this),
        onClick: this._variantSelected.bind(this)
      });
      this._attachListeners();
    }
    _createClass(VariantSelector, [{
      key: "destroy",
      value: function destroy() {
        this.element.removeEventListener("keyup", this._handleKeyboardListener);
        this.delegateElement.off("click");
        this.activator.removeEventListener("click", this._toggleListener);
        this.variantCarousel.destroy();
      }
    }, {
      key: "toggle",
      value: function toggle() {
        this.isOpen ? this.close() : this.open();
      }
    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }
        this.element.setAttribute("aria-hidden", "false");
        this.activator.setAttribute("aria-expanded", "true");
        Accessibility.trapFocus(this.element, "variant-selector");
        document.documentElement.classList.add("no-scroll"); // Prevent scrolling when popover is open

        this.element.setAttribute("style", "");
        this.pageOverlayElement.classList.add("is-visible");
        this.pageOverlayElement.addEventListener("click", this._closeListener);
        this.isOpen = true;
      }
    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }
        this.element.setAttribute("aria-hidden", "true");
        this.activator.setAttribute("aria-expanded", "false");
        Accessibility.removeTrapFocus(this.element, "variant-selector");
        document.documentElement.classList.remove("no-scroll");
        this.pageOverlayElement.classList.remove("is-visible");
        this.pageOverlayElement.removeEventListener("click", this._closeListener);
        this.isOpen = false;
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._handleKeyboardListener = this._handleKeyboard.bind(this);
        this._closeListener = this.close.bind(this);
        this._toggleListener = this.toggle.bind(this);
        this.element.addEventListener("keyup", this._handleKeyboardListener);
        this.activator.addEventListener("click", this._toggleListener);
        this.delegateElement.on("click", '[data-action="select-variant"]', this._onVariantSelect.bind(this));
        this.parentProductVariants.delegateElement.on("variant:changed", this._onVariantChanged.bind(this));
      }
      /**
       * Called when the variant is changed (but not yet selected)
       */
    }, {
      key: "_variantChanged",
      value: function _variantChanged(selectedIndex) {
        var activeChoice = this.variantChoiceList[selectedIndex];
        activeChoice.classList.add("is-selected");
        Dom.getSiblings(activeChoice, ".is-selected").forEach(function (item) {
          return item.classList.remove("is-selected");
        });
      }
      /**
       * Called when a variant is clicked or selected
       */
    }, {
      key: "_variantSelected",
      value: function _variantSelected(cellElement, cellIndex) {
        if (this.variantCarousel.getSelectedIndex() === cellIndex) {
          this.onValueChangedCallback(cellElement.getAttribute("data-option-value"), cellElement, this.activator);
          this.close();
        } else {
          this.variantCarousel.selectCell(cellIndex);
        }
      }
    }, {
      key: "_onVariantChanged",
      value: function _onVariantChanged(event) {
        var _this = this;
        var selectedVariant = event.detail.variant,
          imageWrapperElements = this.element.querySelectorAll(".VariantSelector__ImageWrapper"),
          found = false;
        Dom.nodeListToArray(imageWrapperElements).forEach(function (image) {
          var colorPosition = parseInt(image.parentElement.getAttribute("data-option-position")) - 1,
            combinationExcludedColor = "";
          selectedVariant.options.forEach(function (optionValue, index) {
            if (index !== colorPosition) {
              combinationExcludedColor += optionValue;
            }
          });
          if (image.getAttribute("data-variant-title") === combinationExcludedColor) {
            image.setAttribute("aria-hidden", "false");
            found = true;
          } else {
            image.setAttribute("aria-hidden", "true");
          }
        });
        if (!found) {
          imageWrapperElements.children[0].setAttribute("aria-hidden", "false");
        }
        var foundColorIndex = 0;
        Dom.nodeListToArray(this.element.querySelectorAll(".VariantSelector__ChoicePrice")).forEach(function (priceElement, index) {
          var colorPosition = parseInt(priceElement.getAttribute("data-color-position")) - 1;
          _this.parentProductVariants.productData["variants"].forEach(function (variant) {
            var matchOptionsExcludedColor = true;
            variant["options"].forEach(function (option, index) {
              if (index !== colorPosition) {
                if (variant["options"][index] !== selectedVariant["options"][index]) {
                  matchOptionsExcludedColor = false;
                }
              }
            });
            if (matchOptionsExcludedColor && variant["options"][colorPosition] === selectedVariant["options"][colorPosition]) {
              if (foundColorIndex++ === index) {
                priceElement.innerHTML = '<span class="Heading Text--subdued">'.concat(Currency.formatMoney(variant["price"], window.theme.moneyFormat), "</span>");
              }
            }
          });
        });
      }
      /**
       * Called when the button "choose this variant" is explicitly clicked
       */
    }, {
      key: "_onVariantSelect",
      value: function _onVariantSelect() {
        var selectedCell = this.variantCarousel.flickityInstance.selectedCell.element;
        this.onValueChangedCallback(selectedCell.getAttribute("data-option-value"), selectedCell, this.activator);
        this.close();
      }
      /**
       * Handle a11y events
       */
    }, {
      key: "_handleKeyboard",
      value: function _handleKeyboard(event) {
        if (this.isOpen && event.keyCode === 27) {
          this.close();
        }
      }
    }]);
    return VariantSelector;
  }();

  /**
   * Handle the store availability management. The parameter is the div that will hold the content. The function
   * "updateWithVariant" must be called whenever the variant is changed.
   */

  var StoreAvailability = /*#__PURE__*/function () {
    function StoreAvailability(element, productTitle) {
      _classCallCheck(this, StoreAvailability);
      this.element = element;
      this.productTitle = productTitle;
      this.existingDrawers = {};
    }
    _createClass(StoreAvailability, [{
      key: "updateWithVariant",
      value: function updateWithVariant(variant) {
        if (!this.element) {
          return; // If the element to inject the store availability does not exist, we return immediately
        } // If the variant is null (for instance unavailable variant), we clear the container

        if (!variant) {
          this.element.textContent = "";
          return;
        } // If we have a new variant we render the section

        this._renderAvailabilitySection(variant["id"]);
      }
    }, {
      key: "_renderAvailabilitySection",
      value: function _renderAvailabilitySection(id) {
        var _this = this;

        // First we clear the previous content
        this.element.innerHTML = ""; // If there is already an element with the given modal we remove it first

        var availabilityModal = document.getElementById("StoreAvailabilityModal-".concat(id));
        if (availabilityModal) {
          availabilityModal.remove();
        }
        if (this.existingDrawers["StoreAvailabilityModal-".concat(id)]) {
          this.existingDrawers["StoreAvailabilityModal-".concat(id)].destroy();
          delete this.existingDrawers["StoreAvailabilityModal-".concat(id)];
        }
        return fetch("".concat(window.routes.rootUrlWithoutSlash, "/variants/").concat(id, "?section_id=store-availability")).then(function (response) {
          return response.text().then(function (content) {
            _this.element.innerHTML = content;
            _this.element.innerHTML = _this.element.firstElementChild.innerHTML; // The product title is not rendered so we have to render it manually

            var productTitle = _this.element.querySelector(".store-availabilities-modal__product-title");
            if (productTitle) {
              productTitle.textContent = _this.productTitle;
            } // In order for our modal system to work we have to append the modal to the body instead

            var availabilityModal = document.getElementById("StoreAvailabilityModal-".concat(id));
            document.body.appendChild(availabilityModal); // Create the drawer

            _this.existingDrawers["StoreAvailabilityModal-".concat(id)] = new Drawer(availabilityModal);
          });
        });
      }
    }]);
    return StoreAvailability;
  }();
  var ProductVariants = /*#__PURE__*/function () {
    function ProductVariants(container, options) {
      var _this = this;
      _classCallCheck(this, ProductVariants);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = options;
      var jsonData = JSON.parse(this.element.querySelector("[data-product-json]").innerHTML);
      this.productData = jsonData["product"];
      this.variantsInventories = jsonData["inventories"] || {};
      this.masterSelector = this.element.querySelector("#product-select-".concat(this.productData["id"])); // We init value with the first selected variant

      this.productData["variants"].forEach(function (variant) {
        if (variant["id"] === jsonData["selected_variant_id"]) {
          _this.currentVariant = variant;
          _this.option1 = variant["option1"];
          _this.option2 = variant["option2"];
          _this.option3 = variant["option3"];
        }
      });
      this.storeAvailability = new StoreAvailability(this.element.querySelector(".ProductMeta__StoreAvailabilityContainer"), this.productData["title"]);
      this.storeAvailability.updateWithVariant(this.currentVariant);
      this._attachListeners();
      this._createSelectors();
    }
    _createClass(ProductVariants, [{
      key: "destroy",
      value: function destroy() {
        this.delegateElement.off("click");
        this.formPopovers.forEach(function (popover) {
          return popover.destroy();
        });
        this.formVariantSelectors.forEach(function (selector) {
          return selector.destroy();
        });
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this));
        this.delegateElement.on("click", '[data-action="decrease-quantity"]', this._decreaseQuantity.bind(this));
        this.delegateElement.on("click", '[data-action="increase-quantity"]', this._increaseQuantity.bind(this));
        this.delegateElement.on("change", '[name="quantity"]', this._validateQuantity.bind(this)); // Hook when a radio button change

        this.delegateElement.on("change", '.ProductForm__Option [type="radio"]', this._onOptionChanged.bind(this));
      }
      /**
       * Selectors can either be popovers or dedicated variant selectors. We therefore pre-create them all here
       */
    }, {
      key: "_createSelectors",
      value: function _createSelectors() {
        var _this2 = this;

        // Create the instances for each selector
        this.formPopovers = [];
        this.formVariantSelectors = [];
        Dom.nodeListToArray(this.element.querySelectorAll(".OptionSelector")).forEach(function (item) {
          var popover = new Popover(item, {
            preferredPosition: "left",
            onValueChanged: _this2._onOptionChanged.bind(_this2)
          });
          _this2.formPopovers.push(popover);
        });
        Dom.nodeListToArray(this.element.querySelectorAll(".VariantSelector")).forEach(function (item) {
          var variantSelector = new VariantSelector(item, _this2, {
            onValueChanged: _this2._onOptionChanged.bind(_this2)
          });
          _this2.formVariantSelectors.push(variantSelector);
        });
      }
      /**
       * ---------------------------------------------------------------------------------------------------
       * CODE THAT HANDLE VARIANT CHANGES IN THE FRONT
       *
       * Please note that this code is highly dependant on the markup and classes, so make sure to NOT
       * edit this code
       * ---------------------------------------------------------------------------------------------------
       */

      /**
       * This callback is called whenever the variant changes and allows to update data about the active variant
       */
    }, {
      key: "_onVariantChanged",
      value: function _onVariantChanged(previousVariant, newVariant) {
        // 1st: the prices
        this._updateProductPrices(newVariant, previousVariant); // 2nd: update inventory

        this._updateInventory(newVariant, previousVariant); // 3rd: update SKU

        this._updateSku(newVariant, previousVariant); // 4th: update the price measurement

        this._updateUnitPrice(newVariant, previousVariant); // 5th: the add to cart button

        this._updateAddToCartButton(newVariant, previousVariant); // 6th: store availability

        this.storeAvailability.updateWithVariant(newVariant); // Finally, we send an event so that other system could hook and do their own logic

        this.element.dispatchEvent(new CustomEvent("variant:changed", {
          bubbles: true,
          detail: {
            variant: newVariant,
            previousVariant: previousVariant
          }
        }));
      }
      /**
       * Update the prices (optionally showing compare at price)
       */
    }, {
      key: "_updateProductPrices",
      value: function _updateProductPrices(newVariant, previousVariant) {
        var productMetaPrices = this.element.querySelector(".ProductMeta__PriceList"),
          currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
        if (!productMetaPrices) {
          return;
        }
        if (!newVariant) {
          productMetaPrices.style.display = "none";
        } else {
          if (previousVariant && previousVariant["price"] === newVariant["price"] && previousVariant["compare_at_price"] === newVariant["compare_at_price"]) {
            return; // The price do not have changed so let's return to avoid changing the DOM for nothing
          }
          productMetaPrices.innerHTML = "";
          if (newVariant["compare_at_price"] > newVariant["price"]) {
            productMetaPrices.innerHTML += '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h3" data-money-convertible>'.concat(Currency.formatMoney(newVariant["price"], currencyFormat), "</span>");
            productMetaPrices.innerHTML += '<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h3" data-money-convertible>'.concat(Currency.formatMoney(newVariant["compare_at_price"], currencyFormat), "</span>");
          } else {
            productMetaPrices.innerHTML += '<span class="ProductMeta__Price Price Text--subdued u-h3" data-money-convertible>'.concat(Currency.formatMoney(newVariant["price"], currencyFormat), "</span>");
          }
          productMetaPrices.style.display = "";
        }
      }
      /**
       * Update the inventory (if needed)
       */
    }, {
      key: "_updateInventory",
      value: function _updateInventory(newVariant) {
        if (!this.options["showInventoryQuantity"]) {
          return;
        }
        var productFormInventory = this.element.querySelector(".ProductForm__Inventory"),
          variantInventory = newVariant ? this.variantsInventories[newVariant["id"]] : null;
        if (!newVariant || null === variantInventory["inventory_management"] || variantInventory["inventory_quantity"] <= 0 || this.options["inventoryQuantityThreshold"] > 0 && variantInventory["inventory_quantity"] > this.options["inventoryQuantityThreshold"]) {
          productFormInventory.style.display = "none";
        } else {
          productFormInventory.innerHTML = variantInventory["inventory_message"];
          productFormInventory.style.display = "";
        }
      }
      /**
       * Update the SKU
       */
    }, {
      key: "_updateSku",
      value: function _updateSku(newVariant) {
        if (!this.options["showSku"] || !newVariant) {
          return;
        }
        var productSkuNumber = this.element.querySelector(".ProductMeta__SkuNumber");
        if (productSkuNumber && newVariant["sku"]) {
          productSkuNumber.innerText = newVariant["sku"];
        }
      }
      /**
       * Update the unit price
       */
    }, {
      key: "_updateUnitPrice",
      value: function _updateUnitPrice(newVariant) {
        if (!newVariant) {
          return;
        }
        var unitPriceMeasurement = this.element.querySelector(".ProductMeta__UnitPriceMeasurement");
        if (!unitPriceMeasurement) {
          return;
        }
        if (!newVariant.hasOwnProperty("unit_price")) {
          unitPriceMeasurement.style.display = "none";
          return;
        }
        unitPriceMeasurement.style.display = "block";
        unitPriceMeasurement.querySelector(".UnitPriceMeasurement__Price").innerHTML = Currency.formatMoney(newVariant["unit_price"], window.theme.moneyFormat);
        unitPriceMeasurement.querySelector(".UnitPriceMeasurement__ReferenceUnit").textContent = newVariant["unit_price_measurement"]["reference_unit"];
        var unitPriceReferenceValue = unitPriceMeasurement.querySelector(".UnitPriceMeasurement__ReferenceValue");
        unitPriceReferenceValue.textContent = newVariant["unit_price_measurement"]["reference_value"];
        unitPriceReferenceValue.style.display = newVariant["unit_price_measurement"]["reference_value"] === 1 ? "none" : "inline";
      }
      /**
       * Update the add to cart
       */
    }, {
      key: "_updateAddToCartButton",
      value: function _updateAddToCartButton(newVariant) {
        var addToCartButton = this.element.querySelector(".ProductForm__AddToCart"),
          shopifyPaymentButton = this.element.querySelector(".shopify-payment-button");
        if (addToCartButton) {
          addToCartButton.classList.remove("Button--secondary");
          addToCartButton.classList.remove("Button--primary");
          if (!newVariant) {
            addToCartButton.setAttribute("disabled", "disabled");
            addToCartButton.removeAttribute("data-action");
            addToCartButton.classList.add("Button--secondary");
            addToCartButton.innerHTML = window.languages.productFormUnavailable;
          } else {
            if (newVariant["available"]) {
              addToCartButton.removeAttribute("disabled");
              addToCartButton.classList.add(addToCartButton.getAttribute("data-use-primary-button") === "true" ? "Button--primary" : "Button--secondary");
              addToCartButton.setAttribute("data-action", "add-to-cart");
              if (undefined === this.options["showPriceInButton"] || this.options["showPriceInButton"]) {
                addToCartButton.innerHTML = "\n            <span>".concat(window.languages.productFormAddToCart, '</span>\n            <span class="Button__SeparatorDot"></span>\n            <span data-money-convertible>').concat(Currency.formatMoney(newVariant["price"], window.theme.moneyFormat), "</span>\n          ");
              } else {
                addToCartButton.innerHTML = "<span>".concat(window.languages.productFormAddToCart, "</span>");
              }
            } else {
              addToCartButton.setAttribute("disabled", "disabled");
              addToCartButton.classList.add("Button--secondary");
              addToCartButton.removeAttribute("data-action");
              addToCartButton.innerHTML = window.languages.productFormSoldOut;
            }
          }
        }
        if (this.options["showPaymentButton"] && shopifyPaymentButton) {
          if (!newVariant || !newVariant["available"]) {
            shopifyPaymentButton.style.display = "none";
          } else {
            shopifyPaymentButton.style.display = "block";
          }
        }
      }
      /**
       * ---------------------------------------------------------------------------------------------------
       * INTERNAL CODE THAT HANDLE VARIANT CHANGES
       * ---------------------------------------------------------------------------------------------------
       */

      /**
       * Whenever an option is changed, this code fetch the corresponding active variant
       */
    }, {
      key: "_onOptionChanged",
      value: function _onOptionChanged(newValue, target, activator) {
        // We change the value associated with the activator, and check if we have a color swatch
        if (activator) {
          this["option" + target.getAttribute("data-option-position")] = newValue;
          activator.querySelector(".ProductForm__SelectedValue").innerHTML = newValue;
        } else {
          this["option" + target.getAttribute("data-option-position")] = target.value;
          var selectedValue = target.closest(".ProductForm__Option").querySelector(".ProductForm__SelectedValue");
          if (selectedValue) {
            selectedValue.innerHTML = target.value;
          }
        } // Finally, we get the new variant

        var previousVariant = this.currentVariant;
        this.currentVariant = this._getCurrentVariantFromOptions();
        this._onVariantChanged(previousVariant, this.currentVariant);
        if (this.currentVariant) {
          if (this.options["enableHistoryState"]) {
            this._updateHistoryState(this.currentVariant);
          } // We need to modify the hidden select that contain the id attribute as well

          this.masterSelector.querySelector("[selected]").removeAttribute("selected");
          this.masterSelector.querySelector('[value="'.concat(this.currentVariant["id"], '"]')).setAttribute("selected", "selected");
          this.masterSelector.dispatchEvent(new Event("change", {
            bubbles: true
          }));
        }
      }
      /**
       * Get the active variant based on the options
       */
    }, {
      key: "_getCurrentVariantFromOptions",
      value: function _getCurrentVariantFromOptions() {
        var _this3 = this;
        var found = false;
        this.productData["variants"].forEach(function (variant) {
          if (variant["option1"] === _this3.option1 && variant["option2"] === _this3.option2 && variant["option3"] === _this3.option3) {
            found = variant;
          }
        });
        return found || null;
      }
      /**
       * Update the history state for browsers that support it
       */
    }, {
      key: "_updateHistoryState",
      value: function _updateHistoryState(variant) {
        if (!history.replaceState) {
          return;
        }
        var newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?variant=").concat(variant.id);
        window.history.replaceState({
          path: newUrl
        }, "", newUrl);
      }
      /**
       * ---------------------------------------------------------------------------------------------------
       * INTERNAL CODE THAT HANDLE PRODUCT ADD TO CART
       * ---------------------------------------------------------------------------------------------------
       */
    }, {
      key: "_addToCart",
      value: function _addToCart(event) {
        var _this4 = this;
        if (!this.options["useAjaxCart"]) {
          return; // When using a cart type of page, we just simply redirect to the cart page
        }
        event.preventDefault(); // Prevent form to be submitted

        var addToCartButton = this.element.querySelector(".ProductForm__AddToCart"); // First, we switch the status of the button

        addToCartButton.setAttribute("disabled", "disabled");
        document.dispatchEvent(new CustomEvent("theme:loading:start")); // Then we add the product in Ajax

        var formElement = this.element.querySelector('form[action*="/cart/add"]');
        fetch("".concat(window.routes.cartAddUrl, ".js"), {
          body: JSON.stringify(Form.serialize(formElement)),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest" // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then(function (response) {
          document.dispatchEvent(new CustomEvent("theme:loading:end"));
          var quantityElement = formElement.querySelector('[name="quantity"]');
          if (response.ok) {
            addToCartButton.removeAttribute("disabled"); // We simply trigger an event so the mini-cart can re-render

            _this4.element.dispatchEvent(new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                variant: _this4.currentVariant,
                quantity: quantityElement ? parseInt(quantityElement.value) : 1
              }
            }));
          } else {
            response.json().then(function (content) {
              var errorMessageElement = document.createElement("span");
              errorMessageElement.className = "ProductForm__Error Alert Alert--error";
              errorMessageElement.innerHTML = content["description"];
              addToCartButton.removeAttribute("disabled");
              addToCartButton.insertAdjacentElement("afterend", errorMessageElement);
              setTimeout(function () {
                errorMessageElement.remove();
              }, 2500);
            });
          }
        });
        event.preventDefault();
      }
      /**
       * ---------------------------------------------------------------------------------------------------
       * OTHER
       * ---------------------------------------------------------------------------------------------------
       */

      /**
       * When using the quantity selector, this can be used to decrease the quantity (be ensuring it won't be lower than 1)
       */
    }, {
      key: "_decreaseQuantity",
      value: function _decreaseQuantity(event, target) {
        target.nextElementSibling.value = Math.max(parseInt(target.nextElementSibling.value) - 1, 1);
      }
      /**
       * When using the quantity selector, this can be used to increase the quantity
       */
    }, {
      key: "_increaseQuantity",
      value: function _increaseQuantity(event, target) {
        target.previousElementSibling.value = parseInt(target.previousElementSibling.value) + 1;
      }
      /**
       * Make sure the quantity does not go below when manually changed
       */
    }, {
      key: "_validateQuantity",
      value: function _validateQuantity(event, target) {
        target.value = Math.max(parseInt(target.value) || 1, 1);
      }
    }]);
    return ProductVariants;
  }();
  var ProductVideo = /*#__PURE__*/function () {
    function ProductVideo(element, stackProductImages, enableVideoLooping) {
      _classCallCheck(this, ProductVideo);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.stackProductImages = stackProductImages;
      this.enableVideoLooping = enableVideoLooping;
      this.player = null;
      switch (this.element.getAttribute("data-media-type")) {
        case "video":
          var stylesheet = document.createElement("link");
          stylesheet.rel = "stylesheet";
          stylesheet.href = "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css";
          document.head.appendChild(stylesheet);
          window.Shopify.loadFeatures([{
            name: "video-ui",
            version: "1.0",
            onLoad: this._setupHtml5Video.bind(this)
          }]);
          break;
        case "external_video":
          this._setupExternalVideo();
          break;
      }
    }
    _createClass(ProductVideo, [{
      key: "destroy",
      value: function destroy() {
        if (this.player) {
          this.player.destroy(); // Both Plyr and YouTube API use the same name
        }
      }
    }, {
      key: "hasBeenSelected",
      value: function hasBeenSelected() {
        // As per guidelines, we only need to autoplay when it's not a touch device
        if (Responsive.matchesBreakpoint("supports-hover")) {
          this.play();
        }
      }
    }, {
      key: "hasBeenDeselected",
      value: function hasBeenDeselected() {
        this.pause();
      }
    }, {
      key: "play",
      value: function play() {
        switch (this.element.getAttribute("data-media-type")) {
          case "video":
            this.player.play();
            break;
          case "external_video":
            this.player.playVideo();
            break;
        }
      }
    }, {
      key: "pause",
      value: function pause() {
        switch (this.element.getAttribute("data-media-type")) {
          case "video":
            this.player.pause();
            break;
          case "external_video":
            this.player.pauseVideo();
            break;
        }
      }
    }, {
      key: "_setupHtml5Video",
      value: function _setupHtml5Video() {
        var _this = this;
        this.player = new Shopify.Plyr(this.element.querySelector("video"), {
          controls: ["play", "progress", "mute", "volume", "play-large", "fullscreen"],
          loop: {
            active: this.enableVideoLooping
          },
          hideControlsOnPause: true,
          clickToPlay: true,
          iconUrl: "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
          tooltips: {
            controls: false,
            seek: true
          }
        });
        this.player.on("play", function () {
          _this.element.dispatchEvent(new CustomEvent("video:played", {
            bubbles: true
          }));
        });
        this.player.on("pause", function () {
          _this.element.dispatchEvent(new CustomEvent("video:paused", {
            bubbles: true
          }));
        });
      }
    }, {
      key: "_setupExternalVideo",
      value: function _setupExternalVideo() {
        if (this.element.getAttribute("data-video-host") === "youtube") {
          this._loadYouTubeScript().then(this._setupYouTubePlayer.bind(this));
        }
      }
    }, {
      key: "_setupYouTubePlayer",
      value: function _setupYouTubePlayer() {
        var _this2 = this;
        var playerLoadingInterval = setInterval(function () {
          if (window.YT !== undefined && window.YT.Player !== undefined) {
            _this2.player = new YT.Player(_this2.element.querySelector("iframe"), {
              videoId: _this2.element.getAttribute("data-video-id"),
              events: {
                onStateChange: function onStateChange(event) {
                  if (event.data === window.YT.PlayerState.PLAYING) {
                    _this2.element.dispatchEvent(new CustomEvent("video:played", {
                      bubbles: true
                    }));
                  } else if (event.data === YT.PlayerState.PAUSED) {
                    _this2.element.dispatchEvent(new CustomEvent("video:paused", {
                      bubbles: true
                    }));
                  }
                  if (event.data === window.YT.PlayerState.ENDED && _this2.enableVideoLooping) {
                    event.target.seekTo(0);
                  }
                }
              }
            });
            clearInterval(playerLoadingInterval);
          }
        }, 50);
      }
    }, {
      key: "_loadYouTubeScript",
      value: function _loadYouTubeScript() {
        return new Promise(function (resolve, reject) {
          var script = document.createElement("script");
          document.body.appendChild(script);
          script.onload = resolve;
          script.onerror = reject;
          script.async = true;
          script.src = "//www.youtube.com/iframe_api";
        });
      }
    }]);
    return ProductVideo;
  }();

  /**
   * This code has been heavily inspired by this: https://kitaitimakoto.gitlab.io/scrollspy-example/index.en.html#whatsthis
   */
  var ScrollSpy = /*#__PURE__*/function () {
    function ScrollSpy(container, elementsToSpy, observerOptions) {
      var _this = this;
      _classCallCheck(this, ScrollSpy);
      this.container = container;
      this.targets = [];
      this.targetIndices = {};
      this.indicesInViewPort = [];
      this.observer = new IntersectionObserver(this._onIntersectionChange.bind(this), observerOptions);
      elementsToSpy.forEach(function (elementToSpy, index) {
        _this.targets.push(elementToSpy);
        _this.targetIndices[elementToSpy.id] = index;
        _this.observer.observe(elementToSpy);
      });
    }
    _createClass(ScrollSpy, [{
      key: "destroy",
      value: function destroy() {
        this.observer.disconnect();
      }
      /**
       * Called whenever there is a change of visibility
       */
    }, {
      key: "_onIntersectionChange",
      value: function _onIntersectionChange(changes) {
        var oldTargetIndex = this.indicesInViewPort[0] || 0;
        for (var i = changes.length - 1; i >= 0; i--) {
          this._updateIndicesInViewPort(changes[i], oldTargetIndex);
        } // Firefox generates duplicates so make sure to remove

        this.indicesInViewPort = this.indicesInViewPort.filter(function (value, index, self) {
          return self.indexOf(value) === index;
        });
        if (this.indicesInViewPort.length === 0 || oldTargetIndex === this.indicesInViewPort[0]) {
          return;
        }
        var event = new CustomEvent("scrollspy:target:changed", {
          detail: {
            newTarget: this.targets[this.indicesInViewPort[0]],
            oldTarget: this.targets[oldTargetIndex]
          }
        });
        this.container.dispatchEvent(event);
      }
      /**
       * Update indices visible in the view port
       */
    }, {
      key: "_updateIndicesInViewPort",
      value: function _updateIndicesInViewPort(change, oldTargetIndex) {
        var index = this.targetIndices[change.target.id];
        if (change.intersectionRatio === 0) {
          var indexInViewPort = this.indicesInViewPort.indexOf(index);
          if (indexInViewPort !== -1) {
            this.indicesInViewPort.splice(indexInViewPort, 1);
          }
        } else {
          if (index < oldTargetIndex) {
            this.indicesInViewPort.unshift(index);
          } else if (index > this.indicesInViewPort[this.indicesInViewPort.length - 1]) {
            this.indicesInViewPort.push(index);
          } else {
            this.indicesInViewPort.push(index);
            this.indicesInViewPort.sort();
          }
        }
      }
    }]);
    return ScrollSpy;
  }();
  var SearchBar = /*#__PURE__*/function () {
    function SearchBar() {
      _classCallCheck(this, SearchBar);
      this.documentDelegate = new domDelegate.Delegate(document.body);
      this.searchElement = document.getElementById("Search");
      this.searchInputElement = this.searchElement.querySelector('[name="q"]');
      this.searchResultsElement = this.searchElement.querySelector(".Search__Results");
      this.queryMap = {};
      this.isOpen = false;
      this.pageOverlayElement = document.querySelector(".PageOverlay");
      this._attachListeners();
    }
    _createClass(SearchBar, [{
      key: "destroy",
      value: function destroy() {
        this.searchInputElement.removeEventListener("keydown", this._preventSubmissionListener);
        this.searchInputElement.removeEventListener("input", this._onInputListener);
        this.documentDelegate.off();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._preventSubmissionListener = this._preventSubmission.bind(this);
        this._onInputListener = this._debounce(this._onInput.bind(this), 250);
        this.searchInputElement.addEventListener("keydown", this._preventSubmissionListener);
        this.searchInputElement.addEventListener("input", this._onInputListener);
        this.documentDelegate.on("click", '[data-action="toggle-search"]', this._toggleSearch.bind(this));
        this.documentDelegate.on("click", '[data-action="open-search"]', this._openSearch.bind(this));
        this.documentDelegate.on("click", '[data-action="close-search"]', this._closeSearch.bind(this));
        this.documentDelegate.on("search:close", this._closeSearch.bind(this)); // Allow for third-party elements to close the bar
      }
      /**
       * Toggle the search
       */
    }, {
      key: "_toggleSearch",
      value: function _toggleSearch(event) {
        if (this.isOpen) {
          this._closeSearch(event);
        } else {
          this._openSearch(event);
        }
        event.preventDefault();
      }
      /**
       * Open the search form and trap focus
       */
    }, {
      key: "_openSearch",
      value: function _openSearch() {
        var _this = this;
        this.searchElement.setAttribute("aria-hidden", "false");
        document.documentElement.classList.add("no-scroll");
        Accessibility.trapFocus(this.searchElement, "search", this.searchElement.querySelector('[name="q"]'));
        var onFocusListener = function onFocusListener() {
          _this.searchInputElement.focus();
          _this.searchElement.removeEventListener("transitionend", onFocusListener);
        };
        this.searchElement.addEventListener("transitionend", onFocusListener);
        this.isOpen = true;
        this.pageOverlayElement.classList.add("is-visible");
        document.querySelector("#shopify-section-header").style.zIndex = 10;
      }
      /**
       * Close the search form and clear focus
       */
    }, {
      key: "_closeSearch",
      value: function _closeSearch() {
        var _this2 = this;
        this.searchElement.setAttribute("aria-hidden", "true");
        document.documentElement.classList.remove("no-scroll");
        Accessibility.removeTrapFocus(this.searchElement, "search");
        this.isOpen = false;
        var onTransitionEnd = function onTransitionEnd(event) {
          if (event.propertyName === "visibility") {
            document.querySelector("#shopify-section-header").style.zIndex = "";
            _this2.pageOverlayElement.removeEventListener("transitionend", onTransitionEnd);
          }
        };
        this.pageOverlayElement.addEventListener("transitionend", onTransitionEnd);
        this.pageOverlayElement.classList.remove("is-visible");
      }
      /**
       * In order to prevent an odd UX where hitting the enter always choose the product results, if the search is set to product + something else,
       * then we disable submission using enter key
       */
    }, {
      key: "_preventSubmission",
      value: function _preventSubmission(event) {
        if (event.keyCode === 13 && window.theme.searchMode !== "product") {
          //event.preventDefault()
        }
      }
      /**
       * This is called when the user has stopped typing (after debounce delay)
       */
    }, {
      key: "_onInput",
      value: function _onInput(event) {
        var _this7 = this;
        var _this3 = this;
        if (event.keyCode === 13) {
          return;
        } // Unfortunately, fetch does not support as of today cancelling a request. As a consequence what we do is that we manually
        // keep track of sent requests, and only use the results of the last one

        this.lastInputValue = event.target.value;
        if (this.lastInputValue === "") {
          this._resetSearch();
          return;
        }
        var query = fetch("".concat(window.Shopify.routes.root, "search/suggest?q=").concat(this.lastInputValue, "&resources[type]=").concat(window.theme.searchMode, "&resources[options][fields]=author,body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor&resources[limit_scope]=each&resources[limit]=10&section_id=predictive-search"));
        var requestResponse;
        this.queryMap[this.lastInputValue] = true;
        document.dispatchEvent(new CustomEvent("theme:loading:start"));
        query.then(function (response) {
          requestResponse = response;
          return response.text();
        }).then(function (text) {
          if (!requestResponse.ok) {
            throw new Error(text);
          }
          var resultMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
          console.log(_this7.searchResultsElement);
          _this7.searchResultsElement.innerHTML = resultMarkup;
          _this7.searchResultsElement.setAttribute("aria-hidden", "false");
          document.dispatchEvent(new CustomEvent("theme:loading:end"));
        });
      }
    }, {
      key: "_resetSearch",
      value: function _resetSearch() {
        if (window.theme.searchMode === "product") {
          this.searchResultsElement.innerHTML = "";
        } else {
          this.searchResultsElement.innerHTML = '<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section"></div>\n              <div class="PageLayout__Section PageLayout__Section--secondary"></div>\n            </div>';
        }
        this.searchResultsElement.setAttribute("aria-hidden", "true");
        document.dispatchEvent(new CustomEvent("theme:loading:end")); // Just in case
      }
      /**
       * Simple function that allows to debounce
       */
    }, {
      key: "_debounce",
      value: function _debounce(fn, delay) {
        var _this4 = this;
        var timer = null;
        return function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          clearTimeout(timer);
          timer = setTimeout(function () {
            fn.apply(_this4, args);
          }, delay);
        };
      }
    }]);
    return SearchBar;
  }();
  var CountrySelector = /*#__PURE__*/function () {
    function CountrySelector(countrySelect, provinceSelect) {
      _classCallCheck(this, CountrySelector);
      this.countrySelect = countrySelect;
      this.provinceSelect = provinceSelect;
      if (this.countrySelect && this.provinceSelect) {
        this._attachListeners();
        this._initSelectors();
      }
    }
    _createClass(CountrySelector, [{
      key: "destroy",
      value: function destroy() {
        if (this.countrySelect) {
          this.countrySelect.removeEventListener("change", this._onCountryChangedListener);
        }
      }
    }, {
      key: "_initSelectors",
      value: function _initSelectors() {
        // Check first the default value of country
        var defaultCountry = this.countrySelect.getAttribute("data-default");
        if (defaultCountry) {
          for (var i = 0; i !== this.countrySelect.options.length; ++i) {
            if (this.countrySelect.options[i].text === defaultCountry) {
              this.countrySelect.selectedIndex = i;
              break;
            }
          }
        } else {
          this.countrySelect.selectedIndex = 0;
        }
        var event = new Event("change", {
          bubbles: true
        });
        this.countrySelect.dispatchEvent(event); // Then the province

        var defaultProvince = this.provinceSelect.getAttribute("data-default");
        if (defaultProvince) {
          for (var _i = 0; _i !== this.provinceSelect.options.length; ++_i) {
            if (this.provinceSelect.options[_i].text === defaultProvince) {
              this.provinceSelect.selectedIndex = _i;
              break;
            }
          }
        }
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onCountryChangedListener = this._onCountryChanged.bind(this);
        this.countrySelect.addEventListener("change", this._onCountryChangedListener);
      }
    }, {
      key: "_onCountryChanged",
      value: function _onCountryChanged() {
        var _this = this;
        var selectedOption = this.countrySelect.options[this.countrySelect.selectedIndex],
          provinces = JSON.parse(selectedOption.getAttribute("data-provinces") || "[]"); // First remove all options

        this.provinceSelect.innerHTML = "";
        if (provinces.length === 0) {
          this.provinceSelect.parentNode.style.display = "none";
          return;
        } // We need to build the provinces array

        provinces.forEach(function (data) {
          _this.provinceSelect.options.add(new Option(data[1], data[0]));
        });
        this.provinceSelect.parentNode.style.display = "block";
      }
    }]);
    return CountrySelector;
  }();
  var ShippingEstimator = /*#__PURE__*/function () {
    function ShippingEstimator(element) {
      _classCallCheck(this, ShippingEstimator);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.countrySelector = new CountrySelector(this.element.querySelector('[name="country"]'), this.element.querySelector('[name="province"]'));
      this._attachListeners();
    }
    _createClass(ShippingEstimator, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off("click");
        this.countrySelector.destroy();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on("click", ".ShippingEstimator__Submit", this._fetchRates.bind(this));
      }
    }, {
      key: "_fetchRates",
      value: function _fetchRates() {
        var _this = this;
        var country = this.element.querySelector('[name="country"]').value,
          province = this.element.querySelector('[name="province"]').value,
          zip = this.element.querySelector('[name="zip"]').value;
        document.dispatchEvent(new CustomEvent("theme:loading:start"));
        fetch("".concat(window.routes.cartUrl, "/shipping_rates.json?shipping_address[zip]=").concat(zip, "&shipping_address[country]=").concat(country, "&shipping_address[province]=").concat(province), {
          credentials: "same-origin",
          method: "GET"
        }).then(function (response) {
          response.json().then(function (result) {
            document.dispatchEvent(new CustomEvent("theme:loading:end"));
            var resultsContainer = _this.element.querySelector(".ShippingEstimator__Results"),
              errorContainer = _this.element.querySelector(".ShippingEstimator__Error");
            if (response.ok) {
              var shippingRates = result["shipping_rates"];
              if (shippingRates.length === 0) {
                resultsContainer.innerHTML = "<p>".concat(window.languages.shippingEstimatorNoResults, "</p>");
              } else {
                var html = "";
                if (shippingRates.length === 1) {
                  html += "<p>".concat(window.languages.shippingEstimatorOneResult, "</p><ul>");
                } else {
                  html += "<p>".concat(window.languages.shippingEstimatorMoreResults.replace("{{count}}", shippingRates.length), "</p><ul>");
                }
                shippingRates.forEach(function (item) {
                  html += "<li>".concat(item["name"], ": ").concat(Currency.formatMoney(item["price"], window.theme.moneyFormat), "</li>");
                });
                html += "</ul>";
                resultsContainer.firstElementChild.innerHTML = html;
              }
              TweenLite.fromTo(resultsContainer.firstElementChild, 0.6, {
                autoAlpha: 0,
                y: -15
              }, {
                autoAlpha: 1,
                y: 0,
                delay: 0.35
              });
              errorContainer.style.display = "none";
              resultsContainer.style.display = "block";
              Animation.slideDown(resultsContainer);
            } else {
              var errorHtml = "";
              Object.keys(result).forEach(function (key) {
                errorHtml += '<li class="Alert__ErrorItem">'.concat(key, " ").concat(result[key], "</li>");
              });
              errorContainer.innerHTML = '<ul class="Alert__ErrorList">'.concat(errorHtml, "</ul>");
              resultsContainer.style.display = "none";
              errorContainer.style.display = "block";
            }
          });
        });
      }
    }]);
    return ShippingEstimator;
  }();
  var AddressesSection = function AddressesSection() {
    var _this = this;
    _classCallCheck(this, AddressesSection);
    this.countrySelectors = [];
    Dom.nodeListToArray(document.querySelectorAll(".Modal--address")).forEach(function (modal) {
      _this.countrySelectors.push(new CountrySelector(modal.querySelector('[name="address[country]"]'), modal.querySelector('[name="address[province]"]')));
    });
  };
  var ArticleList = /*#__PURE__*/function () {
    function ArticleList(container) {
      var _this = this;
      _classCallCheck(this, ArticleList);
      this.element = container;
      if (window.theme.showElementStaggering) {
        this.timeline = new TimelineLite({
          delay: window.theme.showPageTransition ? 0.5 : 0
        });
        this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
        Dom.nodeListToArray(this.element.querySelectorAll(".ArticleItem")).forEach(function (item) {
          _this.intersectionObserver.observe(item);
        });
      }
    }
    _createClass(ArticleList, [{
      key: "onUnload",
      value: function onUnload() {
        if (window.theme.showElementStaggering) {
          this.intersectionObserver.disconnect();
          this.timeline.kill();
        }
      }
    }, {
      key: "_reveal",
      value: function _reveal(results) {
        var _this2 = this;
        var toReveal = [];
        results.forEach(function (result) {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // isIntersecting does not exist on Samsung Android browser
            toReveal.push(result.target);
            _this2.intersectionObserver.unobserve(result.target);
          }
        });
        if (toReveal.length === 0) {
          return;
        }
        this.timeline.staggerFromTo(toReveal, 0.45, {
          autoAlpha: 0,
          y: 30
        }, {
          autoAlpha: 1,
          y: 0
        }, 0.2);
      }
    }]);
    return ArticleList;
  }();
  var ArticleSection = /*#__PURE__*/function () {
    function ArticleSection(container) {
      var _this = this;
      _classCallCheck(this, ArticleSection);
      this.element = container;
      this.toolbarElement = this.element.querySelector(".ArticleToolbar");
      this.articleNavElement = this.element.querySelector(".ArticleNav");
      var articleImageElement = this.element.querySelector(".Article__Image");
      if (articleImageElement && window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches) {
        this.parallaxInstance = new Rellax(".Article__Image", {
          speed: -7,
          center: false,
          round: true
        });
      }
      if (window.theme.showElementStaggering) {
        this.timeline = new TimelineLite({
          delay: window.theme.showPageTransition ? 0.5 : 0
        });
        this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
        Dom.nodeListToArray(this.element.querySelectorAll(".ArticleItem")).forEach(function (item) {
          _this.intersectionObserver.observe(item);
        });
      }
      this._attachListeners();
    }
    _createClass(ArticleSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.parallaxInstance) {
          this.parallaxInstance.destroy();
        }
        if (window.theme.showElementStaggering) {
          this.intersectionObserver.disconnect();
          this.timeline.kill();
        }
        window.removeEventListener("scroll", this._onScrollListener);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onScrollListener = this._checkToolbarVisibility.bind(this);
        window.addEventListener("scroll", this._onScrollListener);
      }
    }, {
      key: "_checkToolbarVisibility",
      value: function _checkToolbarVisibility() {
        var _this2 = this;
        var lastYPosition = 0,
          headerHeight = 0,
          navBottom = 0,
          isFixedHeader = 0,
          header = document.querySelector(".Header");
        fastdom.measure(function () {
          lastYPosition = window.pageYOffset;
          headerHeight = header.offsetHeight;
          isFixedHeader = parseInt(window.getComputedStyle(document.body).getPropertyValue("--use-sticky-header") || 0);
          if (_this2.articleNavElement) {
            navBottom = _this2.articleNavElement.offsetTop + _this2.articleNavElement.clientHeight - headerHeight;
          }
        });
        fastdom.mutate(function () {
          _this2.toolbarElement.style.top = isFixedHeader ? headerHeight + "px" : null;
          if (_this2.articleNavElement) {
            if (lastYPosition > 150 && _this2.articleNavElement && lastYPosition < navBottom) {
              _this2.toolbarElement.classList.add("is-visible");
            } else {
              _this2.toolbarElement.classList.remove("is-visible");
            }
          } else {
            if (lastYPosition > 150) {
              _this2.toolbarElement.classList.add("is-visible");
            } else {
              _this2.toolbarElement.classList.remove("is-visible");
            }
          }
        });
      }
    }, {
      key: "_reveal",
      value: function _reveal(results) {
        var _this3 = this;
        var toReveal = [];
        results.forEach(function (result) {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // isIntersecting does not exist on Samsung Android browser
            toReveal.push(result.target);
            _this3.intersectionObserver.unobserve(result.target);
          }
        });
        if (toReveal.length === 0) {
          return;
        }
        this.timeline.staggerFromTo(toReveal, 0.45, {
          autoAlpha: 0,
          y: 30
        }, {
          autoAlpha: 1,
          y: 0
        }, 0.2);
      }
    }]);
    return ArticleSection;
  }();
  var CartSection = /*#__PURE__*/function () {
    function CartSection(container) {
      _classCallCheck(this, CartSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.documentDelegate = new domDelegate.Delegate(document.documentElement);
      this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
      this.itemCount = this.options["itemCount"];
      this.isCartNoteOpen = false;
      if (this.options["drawer"]) {
        this.sidebarDrawer = new Drawer(this.element, {
          onClose: this._onDrawerClosed.bind(this)
        });
      }
      if (this.options["hasShippingEstimator"]) {
        this.shippingEstimator = new ShippingEstimator(this.element.querySelector(".ShippingEstimator"));
      }
      this._attachListeners();
    }
    _createClass(CartSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.options["hasShippingEstimator"]) {
          this.shippingEstimator.destroy();
        }
        this.delegateElement.off();
        document.removeEventListener("product:added", this._onProductAddedListener);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onProductAddedListener = this._onProductAdded.bind(this);
        this.delegateElement.on("change", "#cart-note", this._updateCartNote.bind(this));
        if (this.options["type"] !== "page") {
          this.delegateElement.on("click", '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this));
          this.delegateElement.on("change", ".QuantitySelector__CurrentQuantity", this._updateItemQuantity.bind(this));
        } else {
          this.delegateElement.on("change", ".QuantitySelector__CurrentQuantity", this._reloadPageWithQuantity.bind(this));
        } // We have some listeners that are specific to the fact it's a drawer or the dedicated cart page

        if (this.options["drawer"]) {
          this.delegateElement.on("click", '[data-action="toggle-cart-note"]', this._toggleCartNote.bind(this));
        }
        document.addEventListener("product:added", this._onProductAddedListener); // We attach a listener at page level which allows to re-render the cart

        this.documentDelegate.on("cart:refresh", this._rerenderCart.bind(this, false));
      }
    }, {
      key: "_updateCartNote",
      value: function _updateCartNote(event, target) {
        fetch("".concat(window.routes.cartUrl, "/update.js"), {
          body: JSON.stringify({
            note: target.value
          }),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest" // This is needed as currently there is a bug in Shopify that assumes this header
          }
        });
      }
    }, {
      key: "_toggleCartNote",
      value: function _toggleCartNote() {
        var _this = this;
        var noteContainer = this.element.querySelector(".Cart__OffscreenNoteContainer"),
          cartNote = this.element.querySelector("#cart-note");
        this.element.classList.toggle("has-note-open");
        this.element.querySelector(".Cart__NoteButton").innerHTML = cartNote.value !== "" ? window.languages.cartEditNote : window.languages.cartAddNote;
        noteContainer.setAttribute("aria-hidden", noteContainer.getAttribute("aria-hidden") === "true" ? "false" : "true");
        this.isCartNoteOpen = noteContainer.getAttribute("aria-hidden") === "false";
        if (this.element.classList.contains("has-note-open")) {
          var transitionEndListener = function transitionEndListener() {
            _this.element.querySelector("#cart-note").focus();
            noteContainer.removeEventListener("transitionend", transitionEndListener);
          };
          noteContainer.addEventListener("transitionend", transitionEndListener);
        }
      }
    }, {
      key: "_updateItemQuantity",
      value: function _updateItemQuantity(event, target) {
        var _this2 = this;
        document.dispatchEvent(new CustomEvent("theme:loading:start"));
        var quantity = null,
          elementToAnimate = null;
        if (target.tagName === "INPUT") {
          quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
        } else {
          quantity = parseInt(target.getAttribute("data-quantity"));
        } // If the quantity is 0, then we will animate the product with a removal effect

        if (quantity === 0) {
          elementToAnimate = target.closest(".CartItemWrapper");
        }
        fetch("".concat(window.routes.cartChangeUrl, ".js"), {
          body: JSON.stringify({
            line: target.getAttribute("data-line"),
            quantity: quantity
          }),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest" // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then(function (cart) {
          cart.json().then(function (content) {
            _this2.itemCount = content["item_count"];
            _this2._rerenderCart(elementToAnimate);
            document.dispatchEvent(new CustomEvent("theme:loading:end"));
          });
        });
        event.preventDefault();
      }
    }, {
      key: "_reloadPageWithQuantity",
      value: function _reloadPageWithQuantity(event, target) {
        window.location.href = "".concat(window.routes.cartChangeUrl, "?quantity=").concat(parseInt(target.value), "&line=").concat(target.getAttribute("data-line"));
      }
    }, {
      key: "_onProductAdded",
      value: function _onProductAdded(event) {
        var _this3 = this;
        this.itemCount += event.detail.quantity;
        this._rerenderCart().then(function () {
          _this3.sidebarDrawer.open();
        });
      }
    }, {
      key: "_onDrawerClosed",
      value: function _onDrawerClosed() {
        if (this.isCartNoteOpen) {
          this._toggleCartNote();
        }
      }
      /**
       * This method is called internally to rerender the cart, based on the content returned by Shopify Ajax API.
       * We could save some performance by updating directly in JavaScript instead of doing a GET call to get the HTML
       * from Shopify, but by experience, this allows for easier app integration as it allows the Liquid to re-run
       * all the time and hence having easier logic.
       */
    }, {
      key: "_rerenderCart",
      value: function _rerenderCart(elementToAnimate) {
        var _this4 = this;

        // Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property
        return fetch("".concat(window.routes.cartUrl, "?section_id=").concat(this.options["drawer"] && window.theme.pageType !== "cart" ? "mini-cart" : "main-cart", "&timestamp=").concat(Date.now()), {
          credentials: "same-origin",
          method: "GET"
        }).then(function (content) {
          // If there is an element to animate, we animate it using a transition
          if (_this4.options["drawer"] && elementToAnimate) {
            var timelineLite = new TimelineLite({
              onComplete: function onComplete() {
                content.text().then(function (html) {
                  _this4._replaceContent(html);
                });
              }
            });
            timelineLite.to(elementToAnimate, 0.5, {
              height: 0,
              opacity: 0,
              ease: Cubic.easeOut
            }, 0);
            if (_this4.itemCount === 0) {
              timelineLite.to(_this4.element.querySelector(".Drawer__Footer"), 0.5, {
                y: "100%",
                transition: "none",
                ease: Cubic.easeInOut
              }, 0);
            }
          } else {
            content.text().then(function (html) {
              _this4._replaceContent(html);
            });
          }
        });
      }
    }, {
      key: "_replaceContent",
      value: function _replaceContent(html) {
        var _this5 = this;
        var tempElement = document.createElement("div");
        tempElement.innerHTML = html;
        var cartNodeParent = this.element.querySelector(".Cart").parentNode;
        if (this.options["drawer"] && window.theme.pageType !== "cart") {
          var currentScrollPosition = this.element.querySelector(".Drawer__Main").scrollTop;
          cartNodeParent.replaceChild(tempElement.querySelector(".Cart"), this.element.querySelector(".Cart"));
          this.element.querySelector(".Drawer__Main").scrollTop = currentScrollPosition;
        } else {
          // For dedicated page we replace the whole section if there is no more product
          if (this.itemCount === 0) {
            this.element.innerHTML = tempElement.querySelector(".shopify-section").firstElementChild.innerHTML;
          } else {
            cartNodeParent.replaceChild(tempElement.querySelector(".Cart"), this.element.querySelector(".Cart"));
            this.element.querySelector(".PageHeader").innerHTML = tempElement.querySelector(".PageHeader").innerHTML;
          }
        } // We can also update the dot and the quantity

        var cartResult = JSON.parse(tempElement.querySelector('[data-section-type="cart"]').getAttribute("data-section-settings"));
        var cartDot = Dom.nodeListToArray(document.querySelectorAll(".Header__CartDot")),
          cartQuantity = Dom.nodeListToArray(document.querySelectorAll(".Header__CartCount"));
        this.itemCount = cartResult["itemCount"];
        cartDot.forEach(function (item) {
          if (_this5.itemCount === 0) {
            item.classList.remove("is-visible"); // IE 11 and lower does not support second attribute of toggle :(

            // set item count to 0 if cart is empty
            var cartItemCounter = document.getElementById('cart_item_counter');
            cartItemCounter.innerText = '';
          } else {
            item.classList.add("is-visible");
            // set item count to _this5.itemCount if cart is empty
            var _cartItemCounter = document.getElementById('cart_item_counter');
            _cartItemCounter.innerText = _this5.itemCount;
          }
          if (_this5.itemCount > 99) {
            var _cartItemCounter2 = document.getElementById('cart_item_counter');
            _cartItemCounter2.innerText = '+';
          }
        });
        cartQuantity.forEach(function (item) {
          item.textContent = _this5.itemCount;
        });

        // Set delivery dates on cart content refresh
        var cartdeliveryText = getExpectedDeliveryDates();
        var cartdeliveryTextElement = document.querySelector(".cart-estimated-delivery-text");
        if (cartdeliveryTextElement) {
          cartdeliveryTextElement.innerText = "".concat(cartdeliveryTextElement.innerText, " ").concat(cartdeliveryText);
        }

        // fire custom cart refreshed event
        document.dispatchEvent(new CustomEvent("edition:cart:refreshed"));
      }
    }]);
    return CartSection;
  }();
  var CollectionListSection = /*#__PURE__*/function () {
    function CollectionListSection(container) {
      _classCallCheck(this, CollectionListSection);
      this.element = container;
      var collectionListElement = this.element.querySelector("[data-flickity-config]");
      if (collectionListElement) {
        this.carousel = new Carousel(collectionListElement);
      }
    }
    _createClass(CollectionListSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.carousel) {
          this.carousel.destroy();
        }
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        if (this.carousel) {
          this.carousel.selectCell(event.target.getAttribute("data-slide-index"), true, !event.detail.load);
        }
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect() {
        if (this.carousel) {
          this.carousel.unpausePlayer();
        }
      }
    }]);
    return CollectionListSection;
  }();

  /**
   * This class allows to automatically scrolls within a div when this div does not fit into the visible space
   */
  var OverflowScroller = /*#__PURE__*/function () {
    function OverflowScroller(element) {
      _classCallCheck(this, OverflowScroller);
      if (!element) {
        return;
      }
      this.element = element;
      this.lastKnownY = window.scrollY;
      this.currentTop = 0;
      this.initialTopOffset = parseInt(window.getComputedStyle(this.element).top);
      this._attachListeners();
    }
    _createClass(OverflowScroller, [{
      key: "destroy",
      value: function destroy() {
        window.removeEventListener("scroll", this._checkPositionListener);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._checkPositionListener = this._checkPosition.bind(this);
        window.addEventListener("scroll", this._checkPositionListener);
      }
    }, {
      key: "_checkPosition",
      value: function _checkPosition() {
        var _this = this;
        fastdom.measure(function () {
          var bounds = _this.element.getBoundingClientRect(),
            maxTop = bounds.top + window.scrollY - _this.element.offsetTop + _this.initialTopOffset,
            minTop = _this.element.clientHeight - window.innerHeight;
          if (window.scrollY < _this.lastKnownY) {
            _this.currentTop -= window.scrollY - _this.lastKnownY;
          } else {
            _this.currentTop += _this.lastKnownY - window.scrollY;
          }
          _this.currentTop = Math.min(Math.max(_this.currentTop, -minTop), maxTop, _this.initialTopOffset);
          _this.lastKnownY = window.scrollY;
        });
        fastdom.mutate(function () {
          _this.element.style.top = "".concat(_this.currentTop, "px");
        });
      }
    }]);
    return OverflowScroller;
  }();
  var CollectionSection = /*#__PURE__*/function () {
    function CollectionSection(element) {
      _classCallCheck(this, CollectionSection);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.toolbarElement = this.element.querySelector(".CollectionToolbar");
      this.collectionInnerElement = this.element.querySelector(".CollectionInner__Products");
      this.settings = JSON.parse(this.element.getAttribute("data-section-settings")); // Create the popover if available

      var sortPopoverElement = document.getElementById("collection-sort-popover");
      if (sortPopoverElement) {
        this.sortPopover = new Popover(sortPopoverElement, {
          onValueChanged: this._sortByChanged.bind(this)
        });
      } // Create the filter drawer if available

      var filterDrawerElement = document.getElementById("collection-filter-drawer");
      if (filterDrawerElement) {
        this.filterDrawer = new Drawer(filterDrawerElement);
      } // Create scroller of sidebar

      if (this.settings["filterPosition"] === "sidebar") {
        this.filterInnerSidebarScroller = new OverflowScroller(this.element.querySelector(".CollectionInner__Sidebar"));
      } // Setup parallax on image (if any)

      var collectionImageElement = this.element.querySelector(".PageHeader__ImageWrapper");
      if (collectionImageElement && window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches) {
        this.parallaxInstance = new Rellax(".PageHeader__ImageWrapper", {
          speed: -7,
          center: false,
          round: true
        });
      } // Setup product item color swatch

      new ProductItemColorSwatch(this.element.querySelector(".ProductList")); // Setup animation

      this.timeline = new TimelineLite({
        delay: window.theme.showPageTransition ? 0.5 : 0
      });
      this._setupAnimation();
      this._attachListeners();
    }
    _createClass(CollectionSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off("click");
        if (this.sortPopover) {
          this.sortPopover.destroy();
        }
        if (this.filterDrawer) {
          this.filterDrawer.destroy();
        }
        if (this.filterInnerSidebarScroller) {
          this.filterInnerSidebarScroller.destroy();
        }
        if (this.parallaxInstance) {
          this.parallaxInstance.destroy();
        }
        if (window.theme.showElementStaggering) {
          this.intersectionObserver.disconnect();
          this.timeline.kill();
        }
      }
    }, {
      key: "_setupAnimation",
      value: function _setupAnimation() {
        var _this = this;
        var forceLoadFromTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!window.theme.showElementStaggering) {
          return;
        } // If there is already an observer set up, we remove it first

        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
        }
        if (forceLoadFromTop) {
          this.timeline.clear();
          this.timeline.staggerFromTo(this.element.querySelectorAll(".ProductList .ProductItem, .ArticleList .ArticleItem"), 0.25, {
            autoAlpha: 0,
            y: 25
          }, {
            autoAlpha: 1,
            y: 0
          }, 0.1);
        } else {
          this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this), {
            threshold: 0.3
          });
          Dom.nodeListToArray(this.element.querySelectorAll(".ProductList .ProductItem, .ArticleList .ArticleItem")).forEach(function (item) {
            _this.intersectionObserver.observe(item);
          });
        }
      }
    }, {
      key: "_reveal",
      value: function _reveal(results) {
        var _this2 = this;
        var toReveal = [];
        results.forEach(function (result) {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // isIntersecting does not exist on Samsung Android browser
            toReveal.push(result.target);
            _this2.intersectionObserver.unobserve(result.target);
          }
        });
        if (toReveal.length === 0) {
          return;
        }
        this.timeline.staggerFromTo(toReveal, 0.35, {
          autoAlpha: 0,
          y: 25
        }, {
          autoAlpha: 1,
          y: 0
        }, 0.15);
      }
    }, {
      key: "_changeLayoutMode",
      value: function _changeLayoutMode(event, target) {
        var _this3 = this;
        var layoutType = target.getAttribute("data-grid-type"),
          newCount = parseInt(target.getAttribute("data-count")); // Otherwise we detect the mode, and change all classes

        var productList = this.collectionInnerElement.querySelector(".ProductList");
        if (productList) {
          var previousCount = parseInt(productList.getAttribute("data-".concat(layoutType, "-count")));
          if (previousCount === newCount) {
            return; // Nothing has changed so we just return to avoid reflow
          }
          productList.setAttribute("data-".concat(layoutType, "-count"), newCount);
          Dom.nodeListToArray(productList.querySelectorAll(".Grid__Cell")).forEach(function (item) {
            if (layoutType === "mobile") {
              item.classList.remove("1/".concat(previousCount, "--phone")); // IE11 and lower does not support classList.replace

              item.classList.add("1/".concat(newCount, "--phone"));
            } else {
              var previousTabletCount = previousCount === 2 ? 2 : 3,
                newTabletCount = newCount === 2 ? 2 : 3;
              if (_this3.settings["filterPosition"] === "drawer") {
                item.classList.remove("1/".concat(previousCount, "--lap-and-up"));
                item.classList.add("1/".concat(newCount, "--lap-and-up"));
              } else {
                item.classList.remove("1/".concat(previousCount, "--desk"));
                item.classList.add("1/".concat(newCount, "--desk"));
              }
              item.classList.remove("1/".concat(previousTabletCount, "--tablet-and-up"));
              item.classList.add("1/".concat(newTabletCount, "--tablet-and-up"));
            }
            if (window.theme.showElementStaggering) {
              item.firstElementChild.style.visibility = "hidden"; // Make it as hidden so we can re-trigger the animation
            }
          }); // Force lazy sizes to recalculate item sizes

          lazySizes.autoSizer.checkElems();
        }
        target.classList.add("is-active");
        Dom.getSiblings(target)[0].classList.remove("is-active");
        this._setupAnimation(); // In order to prevent reflow and provide better user experience, we save into cart attributes (those are removed before the checkout
        // is submitted) the user choices so they are preserved on page reload, without the need to use JavaScript

        fetch("".concat(window.routes.cartUrl, "/update.js"), {
          body: JSON.stringify({
            attributes: _defineProperty({}, "collection_".concat(layoutType, "_items_per_row"), newCount)
          }),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest" // This is needed as currently there is a bug in Shopify that assumes this header
          }
        });
      }
    }, {
      key: "_sortByChanged",
      value: function _sortByChanged(sortBy) {
        var currentUrl = new URL(location.href);
        currentUrl.searchParams.set("sort_by", sortBy);
        currentUrl.searchParams["delete"]("page");
        this._reloadProducts(currentUrl.toString());
      }
    }, {
      key: "_onFiltersCleared",
      value: function _onFiltersCleared(event) {
        this._reloadProducts(event.target.getAttribute("data-url"));
      }
    }, {
      key: "_onFilterChanged",
      value: function _onFilterChanged(event) {
        var formData = new FormData(event.target.closest("form"));
        var searchParamsAsString = new URLSearchParams(formData).toString();
        this._reloadProducts("".concat(window.location.pathname, "?").concat(searchParamsAsString));
      }
    }, {
      key: "_reloadProducts",
      value: function _reloadProducts(url) {
        var _this4 = this;
        if (this.abortController) {
          this.abortController.abort();
        }
        document.dispatchEvent(new CustomEvent("theme:loading:start"));
        if (history.replaceState) {
          window.history.pushState({
            path: url
          }, "", url);
        }
        var currentUrl = new URL(window.location);
        currentUrl.searchParams.set("section_id", this.settings["sectionId"]);
        try {
          this.abortController = new AbortController();
          fetch(currentUrl.toString(), {
            signal: this.abortController.signal
          }).then(function (response) {
            response.text().then(function (content) {
              var tempElement = document.createElement("div");
              tempElement.innerHTML = content;
              _this4.collectionInnerElement.innerHTML = tempElement.querySelector(".CollectionInner__Products").innerHTML;
              var toolbarFilter = tempElement.querySelector(".CollectionToolbar__Item--filter");
              if (toolbarFilter) {
                var newToolbarFilter = _this4.element.querySelector(".CollectionToolbar__Item--filter");
                newToolbarFilter.innerHTML = toolbarFilter.innerHTML;
                newToolbarFilter.className = toolbarFilter.className;
              } // We also replace the filters

              var collectionFiltersDrawer = _this4.element.querySelector("#collection-filters-drawer-form"),
                collectionFiltersSidebar = _this4.element.querySelector("#collection-filters-sidebar-form");
              if (collectionFiltersDrawer) {
                var newDrawerContent = tempElement.querySelector("#collection-filters-drawer-form");
                Array.from(collectionFiltersDrawer.querySelectorAll(".Collapsible")).forEach(function (collapsible) {
                  var newCollapsible = newDrawerContent.querySelector('[data-filter-index="'.concat(collapsible.getAttribute("data-filter-index"), '"]'));
                  if (collapsible.firstElementChild.getAttribute("aria-expanded") === "true") {
                    newCollapsible.style.overflow = "visible";
                    newCollapsible.firstElementChild.setAttribute("aria-expanded", "true");
                    newCollapsible.lastElementChild.style.height = "auto";
                    newCollapsible.lastElementChild.style.overflow = "visible";
                  }
                });
                collectionFiltersDrawer.innerHTML = newDrawerContent.innerHTML;
                new ProductItemColorSwatch(_this4.element.querySelector(".ProductList"));
              }
              if (collectionFiltersSidebar) {
                var newSidebarContent = tempElement.querySelector("#collection-filters-sidebar-form");
                Array.from(collectionFiltersSidebar.querySelectorAll(".Collapsible")).forEach(function (collapsible) {
                  var newCollapsible = newSidebarContent.querySelector('[data-filter-index="'.concat(collapsible.getAttribute("data-filter-index"), '"]'));
                  if (collapsible.firstElementChild.getAttribute("aria-expanded") === "true") {
                    newCollapsible.style.overflow = "visible";
                    newCollapsible.firstElementChild.setAttribute("aria-expanded", "true");
                    newCollapsible.lastElementChild.style.height = "auto";
                    newCollapsible.lastElementChild.style.overflow = "visible";
                  }
                });
                collectionFiltersSidebar.innerHTML = newSidebarContent.innerHTML;
              }
              document.dispatchEvent(new CustomEvent("theme:loading:end"));
              _this4._setupAnimation(true); // We scroll to the top

              var elementOffset = _this4.element.querySelector(".CollectionMain").getBoundingClientRect().top - parseInt(document.documentElement.style.getPropertyValue("--header-height"));
              if (Responsive.matchesBreakpoint("lap-and-up") && _this4.toolbarElement && _this4.toolbarElement.clientHeight === 0) {
                elementOffset -= 50;
              }
              if (elementOffset < 0) {
                window.scrollBy({
                  top: elementOffset,
                  behavior: "smooth"
                });
              }
            });
          });
        } catch (exception) {}
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._changeLayoutModeListener = this._changeLayoutMode.bind(this);
        this.delegateElement.on("click", '[data-action="change-layout-mode"]', this._changeLayoutModeListener);
        this.delegateElement.on("click", '[data-action="clear-filters"]', this._onFiltersCleared.bind(this));
        this.delegateElement.on("change", '[name^="filter."]', this._onFilterChanged.bind(this));
        window.addEventListener("popstate", function (event) {
          if (event.state.path) {
            window.location.href = event.state.path;
          }
        });
      }
    }]);
    return CollectionSection;
  }();
  var FaqSection = /*#__PURE__*/function () {
    function FaqSection(element) {
      _classCallCheck(this, FaqSection);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this._attachListeners();
    }
    _createClass(FaqSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off();
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        this._openItem(event.target);
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect(event) {
        this._closeItem(event.target);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on("click", ".Faq__Question", this._toggleItem.bind(this));
        this.delegateElement.on("click", ".FaqSummary__Item", this._switchToCategory.bind(this));
      }
    }, {
      key: "_switchToCategory",
      value: function _switchToCategory(event, target) {
        target.classList.add("is-active");
        Dom.getSiblings(target, ".is-active").forEach(function (item) {
          item.classList.remove("is-active");
        });
      }
    }, {
      key: "_toggleItem",
      value: function _toggleItem(event, target) {
        var item = target.closest(".Faq__Item");
        if (item.getAttribute("aria-expanded") === "true") {
          this._closeItem(item);
        } else {
          this._openItem(item);
        }
      }
    }, {
      key: "_openItem",
      value: function _openItem(item) {
        var answerWrapper = item.querySelector(".Faq__AnswerWrapper");
        item.setAttribute("aria-expanded", "true");
        answerWrapper.setAttribute("aria-hidden", "false");
        Animation.slideDown(answerWrapper, true);
        Dom.getSiblings(item, '[aria-expanded="true"]').forEach(function (siblingItem) {
          var siblingAnswerWrapper = siblingItem.querySelector(".Faq__AnswerWrapper");
          siblingItem.setAttribute("aria-expanded", "false");
          siblingAnswerWrapper.setAttribute("aria-hidden", "true");
          Animation.slideUp(siblingAnswerWrapper);
        });
      }
    }, {
      key: "_closeItem",
      value: function _closeItem(item) {
        var answerWrapper = item.querySelector(".Faq__AnswerWrapper");
        item.setAttribute("aria-expanded", "false");
        answerWrapper.setAttribute("aria-hidden", "true");
        Animation.slideUp(answerWrapper);
      }
    }]);
    return FaqSection;
  }();
  var FeaturedCollectionsSection = /*#__PURE__*/function () {
    function FeaturedCollectionsSection(container) {
      var _this = this;
      _classCallCheck(this, FeaturedCollectionsSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute("data-settings"));
      this.carousels = [];
      Dom.nodeListToArray(this.element.querySelectorAll("[data-flickity-config]")).forEach(function (item) {
        _this.carousels.push(new Carousel(item));
      }); // Setup product item color swatch

      new ProductItemColorSwatch(this.element);
      this._setupAnimation();
      this._attachListeners();
    }
    _createClass(FeaturedCollectionsSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousels.forEach(function (item) {
          return item.destroy();
        });
        this.delegateElement.off("click");
        this.intersectionObserver.disconnect();
        this.timeline.kill();
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        // We simply trigger a click on the element that controls this tab
        this.element.querySelector('[aria-controls="'.concat(event.target.id, '"]')).click();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on("click", '[data-action="toggle-tab"]', this._switchTab.bind(this));
      }
    }, {
      key: "_switchTab",
      value: function _switchTab(event, target) {
        var _this2 = this;

        // If the tab is already active, do nothing
        if (target.classList.contains("is-active")) {
          return;
        } // First, switch the current tab

        target.classList.add("is-active");
        Dom.getSiblings(target, ".is-active").forEach(function (item) {
          item.classList.remove("is-active");
        }); // Then, display the panel

        var tabPanelToShow = this.element.querySelector("#".concat(target.getAttribute("aria-controls")));
        this.timeline.eventCallback("onReverseComplete", function () {
          tabPanelToShow.setAttribute("aria-hidden", "false");
          Dom.getSiblings(tabPanelToShow, '.TabPanel[aria-hidden="false"]').forEach(function (item) {
            item.setAttribute("aria-hidden", "true");
          });
          if (Responsive.matchesBreakpoint("lap-and-up")) {
            _this2.carousels.forEach(function (carousel) {
              // There is a bug in Safari where it cannot detect the pseudo-element "::after" if the tab panel is hidden. As a consequence,
              // we manually activate it
              carousel.flickityInstance.activate();
              carousel.flickityInstance.resize(); // Ugly hack
            });
          }
          _this2.timeline.clear();
          _this2._setupAnimation();
        });
        if (this.options["layout"] === "grid" && window.theme.showElementStaggering) {
          this.timeline.reverse().timeScale(3);
        } else {
          this.timeline.reverse();
        }
      }
    }, {
      key: "_setupAnimation",
      value: function _setupAnimation() {
        var _this3 = this;
        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
        }
        this.timeline = new TimelineLite({
          delay: 0.5
        });
        if (this.options["layout"] === "grid" && window.theme.showElementStaggering) {
          this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
          Dom.nodeListToArray(this.element.querySelectorAll('.TabPanel[aria-hidden="false"] .ProductList .ProductItem')).forEach(function (item) {
            _this3.intersectionObserver.observe(item);
          });
        } else {
          var productList = this.element.querySelector('.TabPanel[aria-hidden="false"] .ProductList');
          if (productList) {
            this.timeline.fromTo(productList, 0.6, {
              autoAlpha: 0,
              y: 25
            }, {
              autoAlpha: 1,
              y: 0
            });
          }
        }
      }
    }, {
      key: "_reveal",
      value: function _reveal(results) {
        var _this4 = this;
        var toReveal = [];
        results.forEach(function (result) {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // isIntersecting does not exist on Samsung Android browser
            toReveal.push(result.target);
            _this4.intersectionObserver.unobserve(result.target);
          }
        });
        if (toReveal.length === 0) {
          return;
        }
        this.timeline.staggerFromTo(toReveal, 0.45, {
          autoAlpha: 0,
          y: 25
        }, {
          autoAlpha: 1,
          y: 0
        }, 0.2);
      }
    }]);
    return FeaturedCollectionsSection;
  }();
  var FeaturedProductSection = /*#__PURE__*/function () {
    function FeaturedProductSection(container) {
      _classCallCheck(this, FeaturedProductSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
      if (!this.options["usePlaceholder"]) {
        this.productVariants = new ProductVariants(container, this.options);
      } // We have to re-order elements in the DOM

      var offscreenElement = this.element.querySelector(".Product__OffScreen");
      if (offscreenElement) {
        this.element.appendChild(offscreenElement);
      }
      this._attachListeners();
    }
    _createClass(FeaturedProductSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off("click");
        if (this.productVariants) {
          this.productVariants.destroy();
        }
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on("variant:changed", this._updateMainImage.bind(this));
      }
      /**
       * Update the main featured image
       */
    }, {
      key: "_updateMainImage",
      value: function _updateMainImage(event) {
        var variant = event.detail.variant,
          previousVariant = event.detail.previousVariant;
        if (!variant || !variant["featured_image"] || previousVariant["featured_image"] && previousVariant["featured_image"]["id"] === variant["featured_image"]["id"]) {
          return;
        } // Otherwise we are on the home page. It's a bit more complex as we have to rewrite some code normally written in Liquid

        var newImage = variant["featured_image"];
        var mainImageContainer = this.element.querySelector(".FeaturedProduct__Gallery .AspectRatio");
        mainImageContainer.style.cssText = "max-width: ".concat(newImage["width"], "px; --aspect-ratio: ").concat(newImage["width"] / newImage["height"]);
        var newImageElement = document.createElement("img");
        newImageElement.classList.add("Image--lazyLoad");
        newImageElement.setAttribute("data-src", Image.getSizedImageUrl(newImage["src"], "1x1").replace("_1x1.", "_{width}x."));
        newImageElement.setAttribute("data-widths", "[".concat(Image.getSupportedSizes(newImage, [200, 400, 600, 700, 800, 900, 1000]).join(","), "]"));
        newImageElement.setAttribute("data-sizes", "auto");
        mainImageContainer.replaceChild(newImageElement, mainImageContainer.querySelector("img"));
      }
    }]);
    return FeaturedProductSection;
  }();
  var BackgroundVideoSection = /*#__PURE__*/function () {
    function BackgroundVideoSection(container) {
      _classCallCheck(this, BackgroundVideoSection);
      this.element = container;
      this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
      this._loadScript().then(this._setupPlayer.bind(this));
    }
    _createClass(BackgroundVideoSection, [{
      key: "_loadScript",
      value: function _loadScript() {
        var _this = this;
        return new Promise(function (resolve, reject) {
          var script = document.createElement("script");
          document.body.appendChild(script);
          script.onload = resolve;
          script.onerror = reject;
          script.async = true;
          script.src = _this.options["videoType"] === "youtube" ? "//www.youtube.com/iframe_api" : "//player.vimeo.com/api/player.js";
        });
      }
    }, {
      key: "onUnload",
      value: function onUnload() {
        if (this.player) {
          this.player.destroy(); // Both YouTube and Vimeo use the same function name
        }
      }
    }, {
      key: "_setupPlayer",
      value: function _setupPlayer() {
        var _this2 = this;
        var elementToInsert = this.element.querySelector(".ImageHero__VideoHolder");
        var playerLoadingInterval = setInterval(function () {
          if (_this2.options["videoType"] === "youtube") {
            if (window.YT) {
              _this2.player = new YT.Player(elementToInsert, {
                videoId: _this2.options["videoId"],
                playerVars: {
                  showinfo: 0,
                  controls: 0,
                  fs: 0,
                  rel: 0,
                  height: "100%",
                  width: "100%",
                  iv_load_policy: 3,
                  html5: 1,
                  loop: 1,
                  playsinline: 1,
                  modestbranding: 1,
                  disablekb: 1,
                  origin: _this2.options["requestHost"]
                },
                events: {
                  onReady: _this2._onYouTubeReady.bind(_this2),
                  onStateChange: _this2._onYouTubeStateChange.bind(_this2)
                }
              });
              clearInterval(playerLoadingInterval);
            }
          } else {
            if (window.Vimeo) {
              _this2.player = new Vimeo.Player(elementToInsert.parentNode, {
                id: _this2.options["videoId"],
                autoplay: true,
                autopause: false,
                muted: true,
                background: true,
                /*height: '100%',
                width: '100%',*/
                loop: true
              });
              clearInterval(playerLoadingInterval);
            }
          }
        }, 50);
      }
    }, {
      key: "_onYouTubeReady",
      value: function _onYouTubeReady(event) {
        this.player.mute();
        this.player.playVideo();
      }
    }, {
      key: "_onYouTubeStateChange",
      value: function _onYouTubeStateChange(event) {
        if (event.data === YT.PlayerState.ENDED) {
          this.player.playVideo();
        }
      }
    }]);
    return BackgroundVideoSection;
  }();
  var GiftCardSection = /*#__PURE__*/function () {
    function GiftCardSection(container) {
      _classCallCheck(this, GiftCardSection);
      this.element = container;
      this._createQrCode();
      this._setupPrint();
    }
    _createClass(GiftCardSection, [{
      key: "_createQrCode",
      value: function _createQrCode() {
        var qrCodeElement = document.getElementById("QrCode");
        new QRCode(qrCodeElement, {
          text: qrCodeElement.getAttribute("data-identifier"),
          width: 120,
          height: 120
        });
      }
    }, {
      key: "_setupPrint",
      value: function _setupPrint() {
        var printElement = document.getElementById("PrintGiftCard");
        if (printElement) {
          printElement.addEventListener("click", function () {
            window.print();
          });
        }
      }
    }]);
    return GiftCardSection;
  }();
  var HeaderSection = /*#__PURE__*/function () {
    function HeaderSection(container) {
      var _this = this;
      _classCallCheck(this, HeaderSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
      this.lastScrollPosition = -1;
      this.isTouch = window.matchMedia("(-moz-touch-enabled: 1), (hover: none)").matches;
      if (this.options["isSticky"]) {
        Stickyfill.addOne(this.element.parentNode);
      } // Set up the search bar

      this.searchBar = new SearchBar();
      this._attachListeners();
      this._verifyNavigationOverlap(); // We set again some CSS variables that are used for some calculations in CSS

      var mainLogo = this.element.querySelector(".Header__LogoImage--primary");
      if (mainLogo && !mainLogo.complete) {
        mainLogo.addEventListener("load", function () {
          fastdom.measure(function () {
            document.documentElement.style.setProperty("--header-height", _this.element.clientHeight + "px");
            document.documentElement.style.setProperty("--header-is-not-transparent", _this.options["hasTransparentHeader"] ? 0 : 1);
          });
        });
      } else {
        fastdom.measure(function () {
          document.documentElement.style.setProperty("--header-height", _this.element.clientHeight + "px");
          document.documentElement.style.setProperty("--header-is-not-transparent", _this.options["hasTransparentHeader"] ? 0 : 1);
        });
      }
      window.addEventListener("pageshow", this._checkTransparentHeader.bind(this));
      this._setupLocalizationPopovers();
    }
    _createClass(HeaderSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.element.removeEventListener("mouseleave", this._closeNavigationListener);
        this.element.removeEventListener("mouseenter", this._focusNavigationListener);
        this.element.removeEventListener("focusin", this._focusNavigationListener);
        this.delegateElement.off();
        window.removeEventListener("scroll", this._checkTransparentHeaderListener);
        window.removeEventListener("resize", this._verifyNavigationOverlapListener);
        if (this.options["isSticky"]) {
          Stickyfill.removeOne(this.element.parentNode);
        }
        this.searchBar.destroy();
        this.localizationPopovers.forEach(function (localizationPopover) {
          localizationPopover.destroy();
        });
      }
    }, {
      key: "onSelect",
      value: function onSelect() {
        this._checkTransparentHeader();
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        var _this2 = this;
        var listItem = event.target.closest(".HorizontalList__Item");
        fastdom.mutate(function () {
          event.target.setAttribute("aria-hidden", "false");
          if (listItem) {
            listItem.classList.add("is-expanded");
            Dom.getSiblings(listItem, ".is-expanded").forEach(function (item) {
              item.classList.remove("is-expanded");
            });
          }
          _this2.element.classList.remove("Header--transparent"); // This is needed to make sure everything is visible
        });
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect(event) {
        var listItem = event.target.closest(".HorizontalList__Item");
        fastdom.mutate(function () {
          event.target.setAttribute("aria-hidden", "true");
          if (listItem) {
            listItem.classList.remove("is-expanded");
          }
        });
        this._checkTransparentHeader();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._checkTransparentHeaderListener = this._checkTransparentHeader.bind(this);
        this._closeNavigationListener = this._closeNavigation.bind(this);
        this._focusNavigationListener = this._focusNavigation.bind(this);
        this._verifyNavigationOverlapListener = this._verifyNavigationOverlap.bind(this);
        this.element.addEventListener("mouseleave", this._closeNavigationListener);
        this.delegateElement.on("mouseenter", ".Header__MainNav .HorizontalList__Item, [aria-haspopup]", this._openMenu.bind(this), true);
        this.delegateElement.on("focusin", "[aria-haspopup]", this._openMenu.bind(this), true);
        this.delegateElement.on("focusout", "[aria-haspopup]", this._closeMenu.bind(this), false);
        this.delegateElement.on("click", '[data-action="toggle-search"]', this._closeNavigationListener);
        this.delegateElement.on("mouseleave", ".DropdownMenu [aria-haspopup]", this._closeMenu.bind(this), true);
        this.delegateElement.on("mouseenter", ".DropdownMenu [aria-haspopup]", this._adjustDropdownPosition.bind(this), true);
        if (this.isTouch) {
          this.delegateElement.on("click", ".Header__MainNav [aria-haspopup]", this._handleTouchMenu.bind(this));
        }
        if (this.options["hasTransparentHeader"]) {
          this.element.addEventListener("mouseenter", this._focusNavigationListener);
          this.element.addEventListener("focusin", this._focusNavigationListener);
        }
        if (this.options["isSticky"] && this.options["hasTransparentHeader"]) {
          window.addEventListener("scroll", this._checkTransparentHeaderListener);
        }
        if (this.options["navigationStyle"] === "inline" || this.options["navigationStyle"] === "logoLeft") {
          window.addEventListener("resize", this._verifyNavigationOverlapListener);
        }
      }
    }, {
      key: "_setupLocalizationPopovers",
      value: function _setupLocalizationPopovers() {
        // Prestige is an extremely complex theme, especially in the header due to the various layouts that power different
        // features. One issue that arises with this is that we output the localization elements twice in the DOM (with the
        // same ID as we're doing a capture in Liquid), and then depending on the screen size one layout is choosen. We therefore
        // have to de-duplicate the ID here. This is honestly not the cleanest code on earth, but I prefer handling this here
        // rather than duplicating too much Liquid
        this.localizationPopovers = [];
        Dom.nodeListToArray(document.querySelectorAll("#header-locale-popover")).forEach(function (item, index) {
          item.id = "".concat(item.id, "-").concat(index);
        });
        Dom.nodeListToArray(document.querySelectorAll('[aria-controls="header-locale-popover"]')).forEach(function (item, index) {
          item.setAttribute("aria-controls", "".concat(item.getAttribute("aria-controls"), "-").concat(index));
        });
        Dom.nodeListToArray(document.querySelectorAll("#header-currency-popover")).forEach(function (item, index) {
          item.id = "".concat(item.id, "-").concat(index);
        });
        Dom.nodeListToArray(document.querySelectorAll('[aria-controls="header-currency-popover"]')).forEach(function (item, index) {
          item.setAttribute("aria-controls", "".concat(item.getAttribute("aria-controls"), "-").concat(index));
        });
        var localePopoverElement1 = document.getElementById("header-locale-popover-0");
        if (localePopoverElement1) {
          this.localizationPopovers.push(new Popover(localePopoverElement1, {
            preferredAlignment: "center",
            preferredPosition: "bottom",
            threshold: 12
          }));
        }
        var localePopoverElement2 = document.getElementById("header-locale-popover-1");
        if (localePopoverElement2) {
          this.localizationPopovers.push(new Popover(localePopoverElement2, {
            preferredAlignment: "center",
            preferredPosition: "bottom",
            threshold: 12
          }));
        }
        var currencyPopoverElement1 = document.getElementById("header-currency-popover-0");
        if (currencyPopoverElement1) {
          this.localizationPopovers.push(new Popover(currencyPopoverElement1, {
            preferredAlignment: "center",
            preferredPosition: "bottom",
            threshold: 12
          }));
        }
        var currencyPopoverElement2 = document.getElementById("header-currency-popover-1");
        if (currencyPopoverElement2) {
          this.localizationPopovers.push(new Popover(currencyPopoverElement2, {
            preferredAlignment: "center",
            preferredPosition: "bottom",
            threshold: 12
          }));
        }
      }
    }, {
      key: "_focusNavigation",
      value: function _focusNavigation() {
        var _this3 = this;
        fastdom.mutate(function () {
          if (!_this3.isTouch || Responsive.matchesBreakpoint("desk")) {
            _this3.element.classList.remove("Header--transparent");
          }
        });
      }
    }, {
      key: "_closeNavigation",
      value: function _closeNavigation() {
        var _this4 = this;
        fastdom.mutate(function () {
          Dom.nodeListToArray(_this4.element.querySelectorAll(".is-expanded")).forEach(function (item) {
            item.classList.remove("is-expanded");
          });
          Dom.nodeListToArray(_this4.element.querySelectorAll('.Header__MainNav [aria-hidden="false"]')).forEach(function (item) {
            item.setAttribute("aria-hidden", "true");
          });
        });
        if (this.options["hasTransparentHeader"]) {
          this._checkTransparentHeader();
        }
      }
    }, {
      key: "_openMenu",
      value: function _openMenu(event, target) {
        if (event.type === "mouseenter" && target !== event.target) {
          return;
        }
        fastdom.mutate(function () {
          target.classList.add("is-expanded");
          Dom.nodeListToArray(target.children, '.Header__MainNav [aria-hidden="true"]').forEach(function (item) {
            item.setAttribute("aria-hidden", "false");
          });
          Dom.getSiblings(target, ".is-expanded").forEach(function (item) {
            item.classList.remove("is-expanded");
            Dom.nodeListToArray(item.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (item) {
              item.setAttribute("aria-hidden", "true");
            });
          });
        });
      }
    }, {
      key: "_closeMenu",
      value: function _closeMenu(event, target) {
        if (event.type === "mouseleave" && target !== event.target) {
          return;
        }
        fastdom.mutate(function () {
          target.classList.remove("is-expanded");
          Dom.nodeListToArray(target.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (item) {
            item.setAttribute("aria-hidden", "true");
          });
        });
      }
    }, {
      key: "_adjustDropdownPosition",
      value: function _adjustDropdownPosition(event, target) {
        var nestedMenus = Dom.nodeListToArray(target.querySelectorAll(".DropdownMenu")),
          shouldOpenLeft = false;
        fastdom.measure(function () {
          var windowWidth = window.innerWidth,
            rightEdge = target.getBoundingClientRect().right;
          nestedMenus.forEach(function (item) {
            if (rightEdge + item.offsetWidth > windowWidth) {
              shouldOpenLeft = true;
            }
          });
        });
        fastdom.mutate(function () {
          if (shouldOpenLeft) {
            nestedMenus.forEach(function (item) {
              item.classList.add("DropdownMenu--reversed");
            });
          } else {
            nestedMenus.forEach(function (item) {
              item.classList.remove("DropdownMenu--reversed");
            });
          }
        });
      }
      /**
       * On touch devices where we display the standard menu (like landscape iPad or Surface) we need to do additional code to properly
       * handle the opening of menu. Especially, what we do is that if an item has a sub-menu, a click does not follow the link but instead open
       * the sub-menu. If this link is clicked a second twice, then the menu is followed
       */
    }, {
      key: "_handleTouchMenu",
      value: function _handleTouchMenu(event, target) {
        if (!target.classList.contains("is-expanded")) {
          event.preventDefault();
        }
      }
    }, {
      key: "_verifyNavigationOverlap",
      value: function _verifyNavigationOverlap() {
        var _this5 = this;
        var isOverlapping = false,
          mainTopMenu = this.element.querySelector(".Header__MainNav");
        fastdom.measure(function () {
          // To detect if the navigation is overlapping, we take the height of a single item and check if its height is taller than the parent
          if (mainTopMenu) {
            // Get the first element
            var firstNavElementHeight = Dom.outerHeightWithMargin(mainTopMenu.querySelector(".HorizontalList__Item")),
              mainNavHeight = mainTopMenu.scrollHeight;
            if (mainNavHeight > firstNavElementHeight) {
              isOverlapping = true;
            }
          }
        });
        this.element.classList.remove("Header--logoLeft", "Header--inline", "Header--center");
        this.element.classList.add("Header--".concat(this.options["navigationStyle"]));
        this.element.clientWidth; // Forces a reflow

        fastdom.mutate(function () {
          if (isOverlapping) {
            _this5.element.classList.remove("Header--".concat(_this5.options["navigationStyle"]));
            _this5.element.classList.add("Header--center"); // Check if still overlapping despite changing the mode

            if (mainTopMenu) {
              // Get the first element
              var itemTopSet = new Set();
              Array.from(mainTopMenu.querySelectorAll(".HorizontalList__Item")).forEach(function (item) {
                itemTopSet.add(item.getBoundingClientRect().top);
              });
              isOverlapping = itemTopSet.size > 1;
            }
          } else {
            _this5.element.classList.add("Header--".concat(_this5.options["navigationStyle"]));
            _this5.element.classList.remove("Header--center");
          }
          var logo = _this5.element.querySelector(".Header__FlexItem--logo");
          logo.classList.toggle("Header__FlexItem--increaseSpace", isOverlapping);
          _this5.element.classList.add("Header--initialized");
          fastdom.measure(function () {
            document.documentElement.style.setProperty("--header-height", _this5.element.clientHeight + "px");
          });
        });
      }
      /**
       * If the header mode is set to "transparent", we have to do extra work to automatically make it with fill colors when the
       * user starts scrolling. For performance we are using fastDOM to do that (which relies of requestAnimationFrame instead of
       * scroll listener)
       */
    }, {
      key: "_checkTransparentHeader",
      value: function _checkTransparentHeader() {
        var _this6 = this;
        if (!this.options["hasTransparentHeader"]) {
          return;
        }
        var scrollThreshold = 10;
        fastdom.measure(function () {
          _this6.lastScrollPosition = window.pageYOffset;
        });
        fastdom.mutate(function () {
          if (_this6.lastScrollPosition <= scrollThreshold) {
            _this6.element.classList.add("Header--transparent");
          } else {
            _this6.element.classList.remove("Header--transparent");
          }
        });
      }
    }]);
    return HeaderSection;
  }();
  var FooterSection = /*#__PURE__*/function () {
    function FooterSection(container) {
      _classCallCheck(this, FooterSection);
      this.element = container;
      var localePopoverElement = document.getElementById("footer-locale-popover");
      if (localePopoverElement) {
        this.localePopover = new Popover(localePopoverElement, {
          preferredAlignment: "center",
          preferredPosition: "top",
          threshold: 12
        });
      }
      var currencyPopoverElement = document.getElementById("footer-currency-popover");
      if (currencyPopoverElement) {
        this.currencyPopover = new Popover(currencyPopoverElement, {
          preferredAlignment: "center",
          preferredPosition: "top",
          threshold: 12
        });
      }
    }
    _createClass(FooterSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.localePopover) {
          this.localePopover.destroy();
        }
        if (this.currencyPopover) {
          this.currencyPopover.destroy();
        }
      }
    }]);
    return FooterSection;
  }();
  var ImageWithTextBlockSection = /*#__PURE__*/function () {
    function ImageWithTextBlockSection(container) {
      _classCallCheck(this, ImageWithTextBlockSection);
      this.element = container;
    }
    _createClass(ImageWithTextBlockSection, [{
      key: "onUnload",
      value: function onUnload() {}
    }]);
    return ImageWithTextBlockSection;
  }();
  var LoginSection = /*#__PURE__*/function () {
    function LoginSection(container) {
      _classCallCheck(this, LoginSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.timelineLite = new TimelineLite();
      this.customerLoginForm = this.element.querySelector("#customer_login");
      this.recoverPasswordForm = this.element.querySelector("#recover_customer_password");
      this.delegateElement.on("click", '[data-action="toggle-recover-form"]', this._showRecoverPassword.bind(this));
    }
    _createClass(LoginSection, [{
      key: "_showRecoverPassword",
      value: function _showRecoverPassword() {
        var isLoginActive = this.customerLoginForm.style.display === "block";
        if (isLoginActive) {
          this.timelineLite.fromTo(this.customerLoginForm, 0.5, {
            autoAlpha: 1,
            display: "block",
            y: 0
          }, {
            autoAlpha: 0,
            y: 20,
            display: "none"
          }).fromTo(this.recoverPasswordForm, 0.5, {
            autoAlpha: 0,
            display: "none",
            y: 20
          }, {
            autoAlpha: 1,
            display: "block",
            y: 0,
            delay: 0.25
          });
        } else {
          this.timelineLite.fromTo(this.recoverPasswordForm, 0.5, {
            autoAlpha: 1,
            display: "block",
            y: 0
          }, {
            autoAlpha: 0,
            y: 20,
            display: "none"
          }).fromTo(this.customerLoginForm, 0.5, {
            autoAlpha: 0,
            display: "none",
            y: 20
          }, {
            autoAlpha: 1,
            display: "block",
            y: 0,
            delay: 0.25
          });
        }
      }
    }]);
    return LoginSection;
  }();
  var MapSection = /*#__PURE__*/function () {
    function MapSection(element) {
      _classCallCheck(this, MapSection);
      this.element = element;
      this.options = JSON.parse(element.getAttribute("data-section-settings"));
      if (this.options["apiKey"] && this.options["mapAddress"]) {
        this._loadScript().then(this._initMap.bind(this));
      }
    }
    _createClass(MapSection, [{
      key: "_loadScript",
      value: function _loadScript() {
        var _this = this;
        return new Promise(function (resolve, reject) {
          var script = document.createElement("script");
          document.body.appendChild(script);
          script.onload = resolve;
          script.onerror = reject;
          script.async = true;
          script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(_this.options["apiKey"]);
        });
      }
    }, {
      key: "_initMap",
      value: function _initMap() {
        var _this2 = this;
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          address: this.options["mapAddress"]
        }, function (results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            if (Shopify.designMode) ;
          } else {
            var mapOptions = {
              zoom: _this2.options["zoom"],
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };
            var map = new google.maps.Map(_this2.element.querySelector(".FeaturedMap__GMap"), mapOptions),
              center = map.getCenter();
            map.setCenter(center);
            var icon = {
              path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
              fillColor: _this2.options["markerColor"],
              fillOpacity: 1,
              anchor: new google.maps.Point(15, 55),
              strokeWeight: 0,
              scale: 0.6
            };
            new google.maps.Marker({
              map: map,
              position: map.getCenter(),
              icon: icon
            });
            var styledMapType = new google.maps.StyledMapType(JSON.parse(_this2.element.querySelector("[data-gmap-style]").innerHTML));
            map.mapTypes.set("styled_map", styledMapType);
            map.setMapTypeId("styled_map");
            google.maps.event.addDomListener(window, "resize", function () {
              google.maps.event.trigger(map, "resize");
              map.setCenter(center);
            });
          }
        });
      }
    }]);
    return MapSection;
  }();
  var NewsletterPopupSection = /*#__PURE__*/function () {
    function NewsletterPopupSection(element) {
      _classCallCheck(this, NewsletterPopupSection);
      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(element.getAttribute("data-section-settings")); // If the popup has been already displayed, we do not display it

      try {
        if (window.location.hash === "#newsletter-popup" && window.theme.pageType !== null) {
          this._openPopup();
        } else if (!this.options["showOnlyOnce"] || this.options["showOnlyOnce"] && localStorage.getItem("themePopup") === null) {
          setTimeout(this._openPopup.bind(this), this.options["apparitionDelay"] * 1000);
        }
      } catch (error) {
        // Some browsers (especially in private mode) throw an exception when trying to access local storage, so we protect ourselves here
      }
      this._attachListeners();
    }
    _createClass(NewsletterPopupSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off();
      }
    }, {
      key: "onSelect",
      value: function onSelect() {
        this._openPopup();
      }
    }, {
      key: "onDeselect",
      value: function onDeselect() {
        this._closePopup();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on("click", '[data-action="close-popup"]', this._closePopup.bind(this));
      }
    }, {
      key: "_openPopup",
      value: function _openPopup() {
        this.element.setAttribute("aria-hidden", "false");
        localStorage.setItem("themePopup", "true");
      }
    }, {
      key: "_closePopup",
      value: function _closePopup() {
        this.element.setAttribute("aria-hidden", "true");
      }
    }]);
    return NewsletterPopupSection;
  }();
  var ProductRecommendationsSection = /*#__PURE__*/function () {
    function ProductRecommendationsSection(container) {
      _classCallCheck(this, ProductRecommendationsSection);
      this.element = container;
      this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
      if (this.options["useRecommendations"]) {
        this._loadRecommendations().then(this._createSlideshow.bind(this));
      } else {
        this._createSlideshow();
      }
    }
    _createClass(ProductRecommendationsSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousel.destroy();
      }
    }, {
      key: "_loadRecommendations",
      value: function _loadRecommendations() {
        var _this = this;
        var url = "".concat(window.routes.productRecommendationsUrl, "?section_id=").concat(this.element.getAttribute("data-section-id"), "&product_id=").concat(this.options["productId"], "&limit=").concat(this.options["recommendationsCount"]);
        return fetch(url).then(function (response) {
          return response.text().then(function (content) {
            var container = document.createElement("div");
            container.innerHTML = content;
            _this.element.querySelector(".ProductRecommendations").innerHTML = container.querySelector(".ProductRecommendations").innerHTML;
          });
        });
      }
    }, {
      key: "_createSlideshow",
      value: function _createSlideshow() {
        var flickityElement = this.element.querySelector("[data-flickity-config]");
        if (!flickityElement) {
          return;
        }
        this.carousel = new Carousel(flickityElement); // Setup product item color swatch

        new ProductItemColorSwatch(this.element);
      }
    }]);
    return ProductRecommendationsSection;
  }();
  var ProductSection = /*#__PURE__*/function () {
    function ProductSection(container) {
      var _this = this;
      _classCallCheck(this, ProductSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
      this.viewInSpaceElement = this.element.querySelector("[data-shopify-xr]");
      this.productVariants = new ProductVariants(container, this.options);
      this.productReviews = new ProductReviews(container);
      var productSlideshowElement = this.element.querySelector(".Product__Slideshow"); // If there is no image at all, there is nothing to init

      if (productSlideshowElement) {
        this.productSlideshow = new Carousel(productSlideshowElement, {
          onSelect: this._onImageChanged.bind(this),
          onSettle: this._onImageSettled.bind(this)
        }, {
          draggable: !Responsive.matchesBreakpoint("supports-hover")
        });
        this.mediaList = {}; // We keep track of a list of media element

        this.previouslySelectedMedia = null; // Keep track of the previously selected media
        // For each model and video, we register a media

        productSlideshowElement.querySelectorAll('[data-media-type="model"]').forEach(function (model) {
          _this.mediaList[model.getAttribute("data-media-id")] = new ProductModel(model, _this.options["stackProductImages"]);
        });
        productSlideshowElement.querySelectorAll('[data-media-type="video"], [data-media-type="external_video"]').forEach(function (video) {
          _this.mediaList[video.getAttribute("data-media-id")] = new ProductVideo(video, _this.options["stackProductImages"], _this.options["enableVideoLooping"]);
        });
        if (this.options["stackProductImages"]) {
          this.slideshowNavDots = this.element.querySelector(".Product__SlideshowNav--dots");
          this.slideshowNavDotsItems = this.slideshowNavDots ? Dom.nodeListToArray(this.slideshowNavDots.querySelectorAll("a")) : [];
        }
        if (this.options["showThumbnails"]) {
          this.slideshowNavThumbnails = this.element.querySelector(".Product__SlideshowNav--thumbnails");
          this.slideshowNavThumbnailsItems = this.slideshowNavThumbnails ? Dom.nodeListToArray(this.slideshowNavThumbnails.querySelectorAll(".Product__SlideshowNavImage")) : [];
        }
        this.slideshowImages = Dom.nodeListToArray(productSlideshowElement.querySelectorAll(".Carousel__Cell")); // Setup the mobile nav

        this._setupSlideshowMobileNav();
      }
      this.productWrapperElement = this.element.querySelector(".Product__Wrapper");
      this.productInfoElement = this.element.querySelector(".Product__Info");
      this.productAsideElement = this.element.querySelector(".Product__Aside");
      this.productGalleryElement = this.element.querySelector(".Product__Gallery");
      this.quickNav = this.element.querySelector(".Product__QuickNav");
      if (this.options["enableImageZoom"]) {
        this.imageZoomInstance = new ProductImageZoom(this.element, this.productSlideshow);
      }
      Stickyfill.addOne(this.productInfoElement); // We have to re-order elements in the DOM

      var offscreenElement = this.element.querySelector(".Product__OffScreen");
      if (offscreenElement) {
        this.element.appendChild(offscreenElement);
      }
      this._setupDeviceFeatures();
      this._attachListeners();
    }
    _createClass(ProductSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off("click");
        this.productReviews.destroy();
        if (this.productVariants) {
          this.productVariants.destroy();
        }
        if (this.productSlideshow) {
          this.productSlideshow.destroy();
        }
        if (this.options["enableImageZoom"]) {
          this.imageZoomInstance.destroy();
        }
        if (this.carouselNavScrollSpy) {
          this.carouselNavScrollSpy.destroy();
        }
        if (this.quickNav) {
          window.removeEventListener("scroll", this._checkQuickNavListener);
        }
        if (this.productInfoScroller) {
          this.productInfoScroller.destroy();
        }
        if (this.productThumbnailsScroller) {
          this.productThumbnailsScroller.destroy();
        }
        if (window.ResizeObserver && this.productInfoResizeObserver) {
          this.productInfoResizeObserver.disconnect();
        }
        Stickyfill.removeOne(this.productInfoElement);
        document.removeEventListener("breakpoint:changed", this._onBreakpointChangedListener);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onBreakpointChangedListener = this._setupDeviceFeatures.bind(this);
        this._checkQuickNavListener = this._checkQuickNav.bind(this);
        this.delegateElement.on("click", '[data-action="toggle-social-share"]', this._toggleSocialShare.bind(this));
        this.delegateElement.on("variant:changed", this._updateSlideshowImage.bind(this));
        this.delegateElement.on("scrollspy:target:changed", this._onScrollTargetChanged.bind(this));
        this.delegateElement.on("model:played", this._onMediaPlayed.bind(this));
        this.delegateElement.on("video:played", this._onMediaPlayed.bind(this));
        this.delegateElement.on("model:paused", this._onMediaPaused.bind(this));
        this.delegateElement.on("video:paused", this._onMediaPaused.bind(this));
        document.addEventListener("breakpoint:changed", this._onBreakpointChangedListener);
        if (this.quickNav) {
          window.addEventListener("scroll", this._checkQuickNavListener);
        }
        if (!this.options["stackProductImages"] && this.options["showThumbnails"]) {
          this.delegateElement.on("click", ".Product__SlideshowNavImage", this._switchToImage.bind(this));
          this.delegateElement.on("click", ".flickity-prev-next-button.next", this._switchToImage.bind(this));
          this.delegateElement.on("click", ".flickity-prev-next-button.previous", this._switchToImage.bind(this));
        }
      }
    }, {
      key: "_setupSlideshowMobileNav",
      value: function _setupSlideshowMobileNav() {
        var _this2 = this;
        this.slideshowMobileNav = this.element.querySelector(".Product__SlideshowMobileNav");
        if (this.slideshowMobileNav) {
          var slideshowMobileNavDelegate = new domDelegate.Delegate(this.slideshowMobileNav); // Handle the dot

          slideshowMobileNavDelegate.on("click", ".dot", function (event, element) {
            _this2._slideWillChange();
            _this2.productSlideshow.selectCell(parseInt(element.getAttribute("data-index")));
          }); // Handle the buttons

          slideshowMobileNavDelegate.on("click", ".Product__SlideshowNavArrow", function (event, element) {
            _this2._slideWillChange();
            if (element.getAttribute("data-direction") === "next") {
              _this2.productSlideshow.next();
            } else {
              _this2.productSlideshow.previous();
            }
          });
        }
      }
      /**
       * Update the main carousel image
       */
    }, {
      key: "_updateSlideshowImage",
      value: function _updateSlideshowImage(event) {
        var variant = event.detail.variant,
          previousVariant = event.detail.previousVariant;
        if (!variant || !variant["featured_media"] || previousVariant && previousVariant["featured_media"] && previousVariant["featured_media"]["id"] === variant["featured_media"]["id"]) {
          return;
        } // We have two logic here: if we are on pocket mode, we switch using the carousel, otherwise we simulate a link to the anchor

        this._slideWillChange();
        if (Responsive.matchesBreakpoint("pocket") || !this.options["stackProductImages"]) {
          for (var i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
            var cellElement = this.productSlideshow.flickityInstance.cells[i].element,
              mediaId = parseInt(cellElement.getAttribute("data-media-id"));
            if (mediaId === variant["featured_media"]["id"]) {
              this.productSlideshow.selectCell(parseInt(cellElement.getAttribute("data-media-position")) - 1);
            }
          }
        } else {
          document.querySelector('[href="#Media'.concat(variant["featured_media"]["id"], '"]')).click(); //document.getElementById(`Media${variant['featured_media']['id']}`).scrollIntoView({behavior: 'smooth'});
        }
      }
      /**
       * This happens when a media is played
       */
    }, {
      key: "_onMediaPlayed",
      value: function _onMediaPlayed(event) {
        // Remove draggability
        this.productSlideshow.getFlickityInstance().options.draggable = false;
        this.productSlideshow.getFlickityInstance().unbindDrag(); // If there is a previously enabled media, we disable it

        if (this.previouslySelectedMedia && this.previouslySelectedMedia !== event.target) {
          this.mediaList[this.previouslySelectedMedia.getAttribute("data-media-id")].hasBeenDeselected();
        } // If the slideshow is configured to stack images, the "select" method from the carousel is not called, so we
        // have to keep track of it here

        if (this.options["stackProductImages"]) {
          this.previouslySelectedMedia = event.target;
        }
      }
      /**
       * This happens when a given media is paused
       */
    }, {
      key: "_onMediaPaused",
      value: function _onMediaPaused() {
        // Enable draggability
        this.productSlideshow.getFlickityInstance().options.draggable = !Responsive.matchesBreakpoint("supports-hover");
        this.productSlideshow.getFlickityInstance().bindDrag();
      }
      /**
       * This method is called when a media changed in the slideshow
       */
    }, {
      key: "_handleMedia",
      value: function _handleMedia(item) {
        // First, we need to turn off the previous media (if any)
        if (this.previouslySelectedMedia && this.previouslySelectedMedia !== item) {
          switch (this.previouslySelectedMedia.getAttribute("data-media-type")) {
            case "video":
            case "external_video":
            case "model":
              this.mediaList[this.previouslySelectedMedia.getAttribute("data-media-id")].hasBeenDeselected();
          } // If the previous media was a model, we need to adjust the "view in space" button to go back to initial value

          if (this.previouslySelectedMedia.getAttribute("data-media-type") === "model" && this.viewInSpaceElement) {
            this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", this.viewInSpaceElement.getAttribute("data-shopify-model3d-default-id"));
          }
        } // Then, we have to handle the currently selected media

        switch (item.getAttribute("data-media-type")) {
          case "video":
          case "external_video":
          case "model":
            this.mediaList[item.getAttribute("data-media-id")].hasBeenSelected();
            break;
        } // If the media is a model, we need to adjust the "view in space" button

        if (item.getAttribute("data-media-type") === "model" && this.viewInSpaceElement) {
          this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", item.getAttribute("data-media-id"));
        } // We set the previously selected media to the currently new one, so that when it changes it can be properly accounted

        this.previouslySelectedMedia = item;
      }
      /**
       * Callback when the target changes
       */
    }, {
      key: "_onScrollTargetChanged",
      value: function _onScrollTargetChanged(event) {
        // The scrollspy emit also an "oldTarget", but when scrolling very fast with Firefox or Safari, it prevents the old to be removed, so we
        // manually iterate through all of them to remove it first
        if (this.options["stackProductImages"]) {
          this.slideshowNavDotsItems.forEach(function (item) {
            return item.classList.remove("is-selected");
          });
          this.slideshowNavDotsItems[parseInt(event.detail.newTarget.getAttribute("data-media-position")) - 1].classList.add("is-selected");
          if (this.options["showThumbnails"]) {
            this.slideshowNavThumbnailsItems.forEach(function (item) {
              return item.classList.remove("is-selected");
            });
            this.slideshowNavThumbnailsItems[parseInt(event.detail.newTarget.getAttribute("data-media-position")) - 1].classList.add("is-selected");
          }
        }
      }
    }, {
      key: "_switchToImage",
      value: function _switchToImage(event, target) {
        event.preventDefault();
        console.log(event, target);
        console.log(this);
        this._slideWillChange();
        for (var i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
          var cellElement = this.productSlideshow.flickityInstance.cells[i].element,
            mediaId = parseInt(cellElement.getAttribute("data-media-id"));
          if (mediaId === parseInt(target.getAttribute("data-media-id"))) {
            this.productSlideshow.selectCell(parseInt(cellElement.getAttribute("data-media-position")) - 1);
          }

          //this should work with flickity arrows as well, they don't have data-media-id
        }
      }
      /**
       * Check the quick nav
       */
    }, {
      key: "_checkQuickNav",
      value: function _checkQuickNav() {
        var _this3 = this;
        var showAsideQuickNav = false;
        fastdom.measure(function () {
          showAsideQuickNav = window.scrollY >= _this3.productAsideElement.offsetTop - _this3.productAsideElement.clientHeight;
        });
        fastdom.mutate(function () {
          if (showAsideQuickNav) {
            _this3.quickNav.classList.add("is-flipped");
          } else {
            _this3.quickNav.classList.remove("is-flipped");
          }
        });
      }
      /**
       * Toggle the social share icons
       */
    }, {
      key: "_toggleSocialShare",
      value: function _toggleSocialShare(event, target) {
        target.classList.toggle("is-active");
        target.classList.toggle("RoundButton--secondaryState");
        target.setAttribute("aria-expanded", target.getAttribute("aria-expanded") === "true" ? "false" : "true");
        target.nextElementSibling.setAttribute("aria-hidden", target.nextElementSibling.getAttribute("aria-hidden") === "true" ? "false" : "true");
      }
    }, {
      key: "_onImageChanged",
      value: function _onImageChanged(event, cell) {
        // If cell is video or model, we hide the action list
        if (Responsive.matchesBreakpoint("pocket")) {
          var productGalleryActionListElement = this.element.querySelector(".Product__Gallery .Product__ActionList");
          if (productGalleryActionListElement) {
            if (cell.classList.contains("Product__SlideItem--image")) {
              productGalleryActionListElement.classList.remove("is-hidden");
            } else {
              productGalleryActionListElement.classList.add("is-hidden");
            }
          }
        } // If we have non-stacked with thumbnails, update it

        if (!this.options["stackProductImages"] && this.options["showThumbnails"]) {
          var mediaId = cell.getAttribute("data-media-id");
          this.slideshowNavThumbnailsItems.forEach(function (thumbnail) {
            if (thumbnail.getAttribute("data-media-id") === mediaId) {
              thumbnail.classList.add("is-selected");
            } else {
              thumbnail.classList.remove("is-selected");
            }
          });
        } // If we have the mobile navigation, we also update it

        if (this.slideshowMobileNav) {
          var selectedIndex = parseInt(cell.getAttribute("data-media-position")) - 1; // The -1 is to make it 0 indexed

          Dom.nodeListToArray(this.slideshowMobileNav.querySelectorAll(".dot")).forEach(function (item, index) {
            if (index === selectedIndex) {
              item.classList.add("is-selected");
            } else {
              item.classList.remove("is-selected");
            }
          });
        }
      }
    }, {
      key: "_onImageSettled",
      value: function _onImageSettled(index, cell) {
        this._handleMedia(cell);
        if (Responsive.matchesBreakpoint("lap-and-up")) {
          var slides = this.element.querySelectorAll(".Product__SlideItem:not(.is-selected)");
          slides.forEach(function (slide) {
            slide.classList.add("Product__SlideItem--hidden");
          });
        }
      }
    }, {
      key: "_slideWillChange",
      value: function _slideWillChange() {
        if (Responsive.matchesBreakpoint("lap-and-up")) {
          var slides = this.element.querySelectorAll(".Product__SlideItem");
          slides.forEach(function (slide) {
            slide.classList.remove("Product__SlideItem--hidden");
          });
        }
      }
      /**
       * Verify when the screen size changes to create additional stuff on non pocket mode
       */
    }, {
      key: "_setupDeviceFeatures",
      value: function _setupDeviceFeatures(event) {
        var _this4 = this;
        var currentBreakpoint = event ? event.detail.currentBreakpoint : Responsive.getCurrentBreakpoint(),
          previousBreakpoint = event ? event.detail.previousBreakpoint : null;
        if (currentBreakpoint === previousBreakpoint) {
          return; // Nothing has changed, no specific setup to do
        }
        if (currentBreakpoint === "phone" || currentBreakpoint === "tablet") {
          if (this.carouselNavScrollSpy) {
            this.carouselNavScrollSpy.destroy();
          }
          if (this.productInfoScroller) {
            this.productInfoScroller.destroy();
          }
          if (this.productThumbnailsScroller) {
            this.productThumbnailsScroller.destroy();
          }
          if (this.productAsideElement) {
            this.productAsideElement.style.minHeight = null;
          } else {
            this.productWrapperElement.style.minHeight = null;
          }
          this.productInfoElement.parentNode.style.maxHeight = null;
        } else {
          // 1st: scrollspy for the dots and image
          if (this.slideshowImages && this.slideshowImages.length > 1) {
            var offsetTop = 0;
            if (this.options["stackProductImages"] && this.slideshowNavDots) {
              offsetTop = this.slideshowNavDots.firstElementChild.offsetTop;
            }
            if (this.options["showThumbnails"] && Responsive.matchesBreakpoint("desk")) {
              offsetTop = 250;
            }
            this.carouselNavScrollSpy = new ScrollSpy(this.element, this.slideshowImages, {
              rootMargin: "-".concat(offsetTop, "px 0px 0px 0px")
            });
          }
          var productInfoStyles = window.getComputedStyle(this.productInfoElement),
            productInfoPadding = parseInt(productInfoStyles.paddingTop) + parseInt(productInfoStyles.paddingBottom),
            productGalleryHeight = this.productGalleryElement ? parseInt(this.productGalleryElement.scrollHeight) : 0; // 2nd: making sure to set up enough space in aside part

          var calculateMinHeight = function calculateMinHeight() {
            if (_this4.productAsideElement) {
              _this4.productAsideElement.style.minHeight = "".concat(_this4.productInfoElement.scrollHeight - productInfoPadding - productGalleryHeight, "px");
              _this4.productInfoElement.closest(".Product__InfoWrapper").style.maxHeight = _this4.productAsideElement.offsetTop + _this4.productInfoElement.scrollHeight - productInfoPadding + "px";
            } else {
              _this4.productWrapperElement.style.minHeight = "".concat(_this4.productInfoElement.scrollHeight - parseInt(productInfoStyles.paddingTop), "px");
            }
          };
          calculateMinHeight(); // This code actually works well, but if a merchant is using an app that dynamically adds content (such as ReCharge or any other widget-based app), this
          // will mess the min height. There is a clean solution to this issue, which is by using ResizeObserver. However it's only supported in Chrome for now,
          // but I feel it's already good to have a clean fix

          if (window.ResizeObserver) {
            this.productInfoResizeObserver = new ResizeObserver(function () {
              calculateMinHeight(); // We currently do not take advantage of the values returned by the observer as our calculation depends on other values
            });
            this.productInfoResizeObserver.observe(this.productInfoElement);
          } // 3rd: let's handle the scroll for the product info

          this.productInfoScroller = new OverflowScroller(this.productInfoElement); // 4th: let's handle the scroll for the thumbnails

          if (this.options["showThumbnails"] && this.slideshowNavThumbnails) {
            this.productThumbnailsScroller = new OverflowScroller(this.slideshowNavThumbnails);
          }
        }
      }
    }]);
    return ProductSection;
  }();
  var RecentlyViewedProductsSection = /*#__PURE__*/function () {
    function RecentlyViewedProductsSection(container) {
      _classCallCheck(this, RecentlyViewedProductsSection);
      this.element = container;
      this.options = JSON.parse(this.element.getAttribute("data-section-settings")); // Setup product item color swatch

      new ProductItemColorSwatch(this.element);
      this._fetchProducts();
    }
    _createClass(RecentlyViewedProductsSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.carousel) {
          this.carousel.destroy();
        }
      }
      /**
       * In order to get the products to display, we hit the search template with the given IDS
       */
    }, {
      key: "_fetchProducts",
      value: function _fetchProducts() {
        var _this = this;
        var queryString = this._getSearchQueryString();
        if (queryString === "") {
          return;
        } // If we have a non empty query string we do a search query

        fetch("".concat(window.routes.searchUrl, "?section_id=").concat(this.element.getAttribute("data-section-id"), "&type=product&q=").concat(queryString), {
          credentials: "same-origin",
          method: "GET"
        }).then(function (response) {
          response.text().then(function (content) {
            var tempElement = document.createElement("div");
            tempElement.innerHTML = content; // Set the content

            _this.element.innerHTML = tempElement.querySelector(".Section").innerHTML; // Show the section

            _this.element.parentNode.style.display = "block"; // And finally let's create the carousel !

            _this.carousel = new Carousel(_this.element.querySelector("[data-flickity-config]"));
          });
        });
      }
    }, {
      key: "_getSearchQueryString",
      value: function _getSearchQueryString() {
        var items = JSON.parse(localStorage.getItem("recentlyViewedProducts") || "[]"); // If we are on a product template, we make sure to remove the main product from the related product

        if (items.includes(this.options["productId"])) {
          items.splice(items.indexOf(this.options["productId"]), 1);
        }
        return items.map(function (item) {
          return "id:" + item;
        }).join(" OR ");
      }
    }]);
    return RecentlyViewedProductsSection;
  }();

  /**
   * This code is extracted from Slate
   */

  var SectionContainer = /*#__PURE__*/function () {
    function SectionContainer() {
      _classCallCheck(this, SectionContainer);
      this.constructors = [];
      this.instances = [];
      this._attachListeners();
    }
    _createClass(SectionContainer, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this));
        document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this));
        document.addEventListener("shopify:section:select", this._onSelect.bind(this));
        document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this));
        document.addEventListener("shopify:section:reorder", this._onReorder.bind(this));
        document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this));
        document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
      }
    }, {
      key: "register",
      value: function register(type, constructor) {
        var _this = this;
        this.constructors[type] = constructor;
        Dom.nodeListToArray(document.querySelectorAll("[data-section-type=".concat(type, "]"))).forEach(function (container) {
          _this._createInstance(container, constructor);
        });
      }
      /**
       * Return an object from an array of objects that matches the provided key and value
       */
    }, {
      key: "_findInstance",
      value: function _findInstance(array, key, value) {
        for (var i = 0; i < array.length; i++) {
          if (array[i][key] === value) {
            return array[i];
          }
        }
      }
      /**
       * Remove an object from an array of objects by matching the provided key and value
       */
    }, {
      key: "_removeInstance",
      value: function _removeInstance(array, key, value) {
        var i = array.length;
        while (i--) {
          if (array[i][key] === value) {
            array.splice(i, 1);
            break;
          }
        }
        return array;
      }
    }, {
      key: "_onSectionLoad",
      value: function _onSectionLoad(event) {
        var container = event.target.querySelector("[data-section-id]");
        if (container) {
          this._createInstance(container);
        }
      }
    }, {
      key: "_onSectionUnload",
      value: function _onSectionUnload(event) {
        var instance = this._findInstance(this.instances, "id", event.detail.sectionId);
        if (!instance) {
          return;
        }
        if (typeof instance.onUnload === "function") {
          instance.onUnload(event);
        }
        this.instances = this._removeInstance(this.instances, "id", event.detail.sectionId);
      }
    }, {
      key: "_onSelect",
      value: function _onSelect(event) {
        var instance = this._findInstance(this.instances, "id", event.detail.sectionId);
        if (instance && typeof instance.onSelect === "function") {
          instance.onSelect(event);
        }
      }
    }, {
      key: "_onDeselect",
      value: function _onDeselect(event) {
        var instance = this._findInstance(this.instances, "id", event.detail.sectionId);
        if (instance && typeof instance.onDeselect === "function") {
          instance.onDeselect(event);
        }
      }
    }, {
      key: "_onReorder",
      value: function _onReorder(event) {
        var instance = this._findInstance(this.instances, "id", event.detail.sectionId);
        if (instance && typeof instance.onReorder === "function") {
          instance.onReorder(event);
        }
      }
    }, {
      key: "_onBlockSelect",
      value: function _onBlockSelect(event) {
        var instance = this._findInstance(this.instances, "id", event.detail.sectionId);
        if (instance && typeof instance.onBlockSelect === "function") {
          instance.onBlockSelect(event);
        }
      }
    }, {
      key: "_onBlockDeselect",
      value: function _onBlockDeselect(event) {
        var instance = this._findInstance(this.instances, "id", event.detail.sectionId);
        if (instance && typeof instance.onBlockDeselect === "function") {
          instance.onBlockDeselect(event);
        }
      }
    }, {
      key: "_createInstance",
      value: function _createInstance(container, constructor) {
        var id = container.getAttribute("data-section-id"),
          type = container.getAttribute("data-section-type");
        constructor = constructor || this.constructors[type];
        if (typeof constructor === "undefined") {
          return;
        }
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      }
    }]);
    return SectionContainer;
  }();
  var ShopNowSection = /*#__PURE__*/function () {
    function ShopNowSection(container) {
      _classCallCheck(this, ShopNowSection);
      this.element = container;
      this.carousel = new Carousel(this.element.querySelector("[data-flickity-config]")); // Setup product item color swatch

      new ProductItemColorSwatch(this.element);
    }
    _createClass(ShopNowSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousel.destroy();
      }
    }]);
    return ShopNowSection;
  }();
  var ShopTheLookSection = /*#__PURE__*/function () {
    function ShopTheLookSection(container) {
      _classCallCheck(this, ShopTheLookSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.usePocketMode = Responsive.matchesBreakpoint("pocket");
      this.pocketActivatorButton = this.element.querySelector('[data-action="open-look"]');
      this._createOuterCarousel();
      this._createPocketPopovers();
      this._attachListeners();
    }
    _createClass(ShopTheLookSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.outerCarousel.destroy();
        this.innerCarousels.forEach(function (item) {
          item.forEach(function (innerItem) {
            return innerItem.destroy();
          });
        });
        this.popovers.forEach(function (item) {
          return item.destroy();
        });
        this.delegateElement.off();
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        this.outerCarousel.selectCell(event.target.getAttribute("data-slide-index"), true, !event.detail.load);
      }
      /**
       * Attach all the listeners
       */
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on("click", ".ShopTheLook__Dot", this._onDotClicked.bind(this));
      }
      /**
       * There is one mobile and tablet popover per look, so we pre-create them
       */
    }, {
      key: "_createPocketPopovers",
      value: function _createPocketPopovers() {
        var _this = this;
        this.popovers = [];
        Dom.nodeListToArray(this.element.querySelectorAll(".Popover")).forEach(function (popover) {
          _this.popovers.push(new Popover(popover, {
            activator: _this.pocketActivatorButton,
            showOverlay: false,
            onOpen: _this._openPocketZoom.bind(_this),
            onClose: _this._closePocketZoom.bind(_this)
          }));
        });
      }
      /**
       * The outer carousel is the carousel that holds the main one (all the looks). Internally, it also creates
       * a sub-carousel for each inner carousel
       */
    }, {
      key: "_createOuterCarousel",
      value: function _createOuterCarousel() {
        var _this2 = this;
        this.outerCarousel = new Carousel(this.element.querySelector(".ShopTheLook"), {
          onSelect: this._onLookChanged.bind(this)
        });
        this.innerCarousels = new Array(this.outerCarousel.flickityInstance.cells.length);
        for (var i = 0; i !== this.innerCarousels.length; ++i) {
          this.innerCarousels[i] = [];
        } // We need to create ALL the carousels (both in desktop and mobile). Fortunately Flickity is quite fast, but
        // we have no other choices if we want to have proper animations everywhere.

        Dom.nodeListToArray(this.element.querySelectorAll(".ShopTheLook__ProductList")).forEach(function (item) {
          var lookIndex = parseInt(item.getAttribute("data-look-index"));
          _this2.innerCarousels[lookIndex].push(new Carousel(item, {
            onSelect: _this2._onProductChanged.bind(_this2)
          })); // By default, Flickity will append the carousel, hence making the "ViewButton" before the carousel. We need to manipulate it to move it after

          item.insertBefore(item.querySelector(".flickity-viewport"), item.querySelector(".ShopTheLook__ViewButton"));
        });
        this.outerCarousel.resize(); // Needed in case the products are taller than the image
      }
      /**
       * This function is called whenever the main look has changed, so that we can modify the popover activator
       */
    }, {
      key: "_onLookChanged",
      value: function _onLookChanged(selectedIndex, selectedCell) {
        // Then, we update the mobile button so that it opens the correct block
        this.pocketActivatorButton.setAttribute("aria-controls", "".concat(selectedCell.getAttribute("id"), "-popover"));
      }
      /**
       * This function is called whenever a product is changed in the list for a given look. This allows to focus the main dot
       */
    }, {
      key: "_onProductChanged",
      value: function _onProductChanged(selectedIndex, selectedCell) {
        var lookItem = this.outerCarousel.getSelectedCell(),
          activeDot = null;
        Dom.nodeListToArray(lookItem.querySelectorAll(".ShopTheLook__Dot")).forEach(function (dot, index) {
          dot.classList.remove("is-active"); // IE11 and lower does not support "toggle" with second parameter :(

          if (index === selectedIndex) {
            dot.classList.add("is-active");
            activeDot = dot;
          }
        }); // Update the link to the product (if using the desktop view)

        lookItem.querySelector(".ShopTheLook__ViewButton").setAttribute("href", selectedCell.getAttribute("data-product-url")); // We trigger an event so that when the dot change we can recalculate the position

        lookItem.dispatchEvent(new CustomEvent("product:changed", {
          detail: {
            dot: activeDot
          }
        }));
      }
      /**
       * This function is called whenever you explicitly click on a dot.
       *
       * On mobile and tablet, this must open the appropriate popver
       */
    }, {
      key: "_onDotClicked",
      value: function _onDotClicked(event, target) {
        var shouldAnimateCarousel = false,
          hasOnePopoverOpen = false,
          lookIndex = this.outerCarousel.getSelectedIndex();
        this.popovers.forEach(function (item) {
          if (item.isOpen) {
            hasOnePopoverOpen = true;
            shouldAnimateCarousel = true;
          }
        }); // Each inner carousel has a mobile AND desktop version, so we change both

        this.innerCarousels[lookIndex].forEach(function (innerCarousel) {
          innerCarousel.selectCell(parseInt(target.getAttribute("data-product-index")) - 1, false, shouldAnimateCarousel);
        });
        if (this.usePocketMode && !hasOnePopoverOpen) {
          this.popovers[lookIndex].open();
        }
      }
      /**
       * This is called when, on mobile, the popover is open. We must open the image in full resolution
       */
    }, {
      key: "_openPocketZoom",
      value: function _openPocketZoom(popover) {
        var _this3 = this;
        this._calculateImageTransform(popover);
        fastdom.mutate(function () {
          // We need to animate the header to avoid a slightly ugly effect if image overlap the header
          document.getElementById("shopify-section-header").style.cssText = "transform: translateY(-100%); transition: transform 0.3s ease-in-out;";
          _this3.outerCarousel.flickityInstance.unbindDrag(); // Prevent changing the active slide

          _this3.outerCarousel.flickityInstance.element.classList.add("is-zoomed");
          _this3.outerCarousel.getSelectedCell().classList.add("is-expanded");
        });
      }
      /**
       * When the mobile zoom is open, and whenever the active dot changes, we need to potentially re-calculate the transform
       */
    }, {
      key: "_calculateImageTransform",
      value: function _calculateImageTransform(openPopover) {
        var _this4 = this;
        var selectedCell = this.outerCarousel.getSelectedCell();
        fastdom.measure(function () {
          // We first need to compute the initial transform and scale factor
          var scale = window.innerWidth / (selectedCell.offsetWidth - parseInt(window.getComputedStyle(selectedCell).paddingLeft) * 2),
            heightAfterScale = Math.round(selectedCell.offsetHeight * scale),
            // Height of the selected cell once the scale transform is applied
            hiddenImageHeight = Math.round(Math.max(heightAfterScale - (window.innerHeight - openPopover.element.offsetHeight), 0)),
            // Part of image that is below popover
            visibleImageHeight = heightAfterScale - hiddenImageHeight,
            // Part of the image that is visible in the viewport
            minTranslateY = Math.round(-(selectedCell.getBoundingClientRect().top - (heightAfterScale - selectedCell.offsetHeight) / 2)),
            // The minimum translate Y transform allowed so that image is visible
            maxTranslateY = Math.round(minTranslateY - hiddenImageHeight); // The maximum translate Y transform allowed so that image is visible

          _this4._calculateTransformForDotListener = function (event) {
            var dotTopPosition = Math.round((event.detail.dot.offsetTop + event.detail.dot.offsetHeight / 2) * scale),
              offsetToMove = Math.round(dotTopPosition - visibleImageHeight / 2),
              translateY = Math.min(Math.max(minTranslateY - offsetToMove, maxTranslateY), minTranslateY);
            fastdom.mutate(function () {
              _this4.outerCarousel.flickityInstance.viewport.style.transform = "translate3d(0, ".concat(Math.round(translateY), "px, 0) scale(").concat(scale, ")");
            });
          }; // We manually generate an event the first time to trigger the positioning

          selectedCell.addEventListener("product:changed", _this4._calculateTransformForDotListener);
          selectedCell.dispatchEvent(new CustomEvent("product:changed", {
            detail: {
              dot: selectedCell.querySelector(".ShopTheLook__Dot.is-active")
            }
          }));
        });
      }
      /**
       * Close the mobile zoom (which close the popover and remove any transform
       */
    }, {
      key: "_closePocketZoom",
      value: function _closePocketZoom() {
        var _this5 = this;
        var selectedCell = this.outerCarousel.getSelectedCell();
        selectedCell.removeEventListener("product:changed", this._calculateTransformForDotListener);
        fastdom.mutate(function () {
          document.getElementById("shopify-section-header").style.cssText = "transform: translateY(0); transition: transform 0.3s ease-in-out 0.3s;";
          _this5.outerCarousel.flickityInstance.bindDrag();
          _this5.outerCarousel.flickityInstance.element.classList.remove("is-zoomed");
          _this5.outerCarousel.flickityInstance.viewport.style.transform = null;
          selectedCell.classList.remove("is-expanded");
        });
      }
    }]);
    return ShopTheLookSection;
  }();
  var SidebarMenuSection = /*#__PURE__*/function () {
    function SidebarMenuSection(container) {
      _classCallCheck(this, SidebarMenuSection);
      this.element = container;
      this.sidebarDrawer = new Drawer(container);
    }
    _createClass(SidebarMenuSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.sidebarDrawer.destroy();
      }
    }, {
      key: "onSelect",
      value: function onSelect() {
        this.sidebarDrawer.open();
      }
    }, {
      key: "onDeselect",
      value: function onDeselect() {
        this.sidebarDrawer.close();
      }
    }]);
    return SidebarMenuSection;
  }();
  var SlideshowSection = /*#__PURE__*/function () {
    function SlideshowSection(container) {
      _classCallCheck(this, SlideshowSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.slideshow = new Carousel(this.element.querySelector("[data-flickity-config]"), {
        onSelect: this._onSlideChanged.bind(this)
      });
      this.selectedSlide = null;
      this.shouldAnimate = true;
      this.timeline = new TimelineLite({
        delay: window.theme.showPageTransition ? 0.5 : 0
      });
      if (this.slideshow.flickityInstance.cells.length > 0) {
        this._transitionToSlide(this.slideshow.flickityInstance.selectedCell.element, true);
      }
      this._attachListeners();
    }
    _createClass(SlideshowSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.slideshow.destroy();
        this.timeline.kill();
        this.delegateElement.off();
        document.removeEventListener("breakpoint:changed", this._onBreakpointChangedListener);
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        if (this.slideshow.flickityInstance.options.autoPlay) {
          this.slideshow.flickityInstance.stopPlayer();
        }
        this.shouldAnimate = !event.detail.load;
        this.slideshow.selectCell(event.target.getAttribute("data-slide-index"), false, !event.detail.load);
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect() {
        this.shouldAnimate = true;
        if (this.slideshow.flickityInstance.options.autoPlay) {
          this.slideshow.flickityInstance.playPlayer();
        }
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
        this.delegateElement.on("mouseenter", ".Button", this._pauseSlideshow.bind(this), true);
        this.delegateElement.on("mouseleave", ".Button", this._resumeSlideshow.bind(this), true);
        document.addEventListener("breakpoint:changed", this._onBreakpointChangedListener);
      }
    }, {
      key: "_pauseSlideshow",
      value: function _pauseSlideshow() {
        if (this.slideshow.flickityInstance.options.autoPlay) {
          this.slideshow.flickityInstance.pausePlayer();
        }
      }
    }, {
      key: "_resumeSlideshow",
      value: function _resumeSlideshow() {
        if (this.slideshow.flickityInstance.options.autoPlay) {
          this.slideshow.flickityInstance.unpausePlayer();
        }
      }
    }, {
      key: "_onSlideChanged",
      value: function _onSlideChanged(index, element) {
        this._transitionToSlide(element);
      }
    }, {
      key: "_transitionToSlide",
      value: function _transitionToSlide(slide) {
        var _this = this;
        this.timeline.clear(); // First, we check if there is a previous slide selected, if that's the case

        if (this.selectedSlide) {
          this._slideLeave(this.selectedSlide);
          this.timeline.addLabel("enter", this.shouldAnimate ? "-=0.4" : 0);
        } // We get the next slide (if any) to preload it

        this._lazyLoadNextImage();
        this.timeline.fromTo(slide, this.selectedSlide && this.shouldAnimate ? 0.3 : 0, {
          autoAlpha: 0
        }, {
          autoAlpha: 1,
          ease: Cubic.easeInOut
        }, "enter"); // The image may take 1s or more to load depending on the network, so we make sure to pause the player, and restart it once it has transitioned

        if (this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.player.state === "playing") {
          this.slideshow.flickityInstance.pausePlayer();
        }
        Dom.nodeListToArray(slide.querySelectorAll(".Slideshow__Image")).forEach(function (image) {
          if (image.classList.contains("Image--lazyLoading") || image.classList.contains("Image--lazyLoad")) {
            image.addEventListener("lazyloaded", _this._slideEnter.bind(_this, slide));
          } else {
            _this._slideEnter(slide);
          }
        });
        this.selectedSlide = slide;
      }
    }, {
      key: "_slideLeave",
      value: function _slideLeave(slide) {
        var content = slide.querySelector(".SectionHeader"),
          buttonWrapper = slide.querySelector(".SectionHeader__ButtonWrapper");
        this.timeline.fromTo(slide, this.shouldAnimate ? 0.3 : 0, {
          autoAlpha: 1
        }, {
          autoAlpha: 0,
          ease: Cubic.easeInOut,
          delay: this.shouldAnimate ? 0.35 : 0
        });
        if (content) {
          this.timeline.fromTo(content, this.shouldAnimate ? 0.4 : 0, {
            autoAlpha: 1,
            y: 0
          }, {
            autoAlpha: 0,
            y: 20,
            ease: Cubic.easeIn
          }, 0);
        }
        if (buttonWrapper) {
          this.timeline.fromTo(buttonWrapper, this.shouldAnimate ? 0.4 : 0, {
            autoAlpha: 1,
            y: 0
          }, {
            autoAlpha: 0,
            y: 10,
            ease: Cubic.easeIn
          }, 0);
        }
      }
    }, {
      key: "_slideEnter",
      value: function _slideEnter(slide) {
        var images = slide.querySelectorAll(".Slideshow__Image"),
          content = slide.querySelector(".SectionHeader"),
          buttonWrapper = slide.querySelector(".SectionHeader__ButtonWrapper");
        if (this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.player.state === "paused") {
          this.slideshow.flickityInstance.unpausePlayer();
        }
        if (window.CSS && window.CSS.supports("(object-fit: cover) or (-o-object-fit: cover)")) {
          if (window.theme.showImageZooming) {
            this.timeline.fromTo(images, this.shouldAnimate ? 1.2 : 0, {
              opacity: 0,
              scale: 1.2
            }, {
              opacity: 1,
              scale: 1,
              ease: Quad.easeOut
            }, "enter");
          } else {
            this.timeline.fromTo(images, this.shouldAnimate ? 1.2 : 0, {
              opacity: 0
            }, {
              opacity: 1,
              ease: Quad.easeOut
            }, "enter");
          }
        }
        if (content) {
          this.timeline.fromTo(content, this.shouldAnimate ? 0.8 : 0, {
            autoAlpha: 0,
            y: 30
          }, {
            autoAlpha: 1,
            y: 0,
            delay: this.shouldAnimate ? 0.8 : 0,
            ease: Cubic.easeOut
          }, "enter");
        }
        if (buttonWrapper) {
          this.timeline.fromTo(buttonWrapper, this.shouldAnimate ? 0.8 : 0, {
            autoAlpha: 0,
            y: 20
          }, {
            autoAlpha: 1,
            y: 0,
            delay: this.shouldAnimate ? 0.8 : 0,
            ease: Cubic.easeOut
          }, "enter");
        }
      }
    }, {
      key: "_lazyLoadNextImage",
      value: function _lazyLoadNextImage() {
        var currentIndex = this.slideshow.flickityInstance.selectedIndex,
          breakpoint = Responsive.getCurrentBreakpoint();
        if (this.slideshow.flickityInstance.cells.length - 1 > currentIndex) {
          var nextCellElement = this.slideshow.flickityInstance.cells[currentIndex + 1].element,
            imageContainers = Dom.nodeListToArray(nextCellElement.querySelectorAll(".Slideshow__ImageContainer")),
            imageToReveal = null;
          if (breakpoint === "phone") {
            imageToReveal = imageContainers[0];
          } else {
            imageToReveal = imageContainers[1];
          }
          if (window.lazySizes && imageToReveal && imageToReveal.classList.contains("Image--lazyLoad")) {
            lazySizes.loader.unveil(imageToReveal.firstElementChild);
          }
        }
      }
    }, {
      key: "_onBreakpointChanged",
      value: function _onBreakpointChanged(event) {
        if (event.detail.previousBreakpoint === "phone" && event.detail.currentBreakpoint !== "phone" || event.detail.previousBreakpoint !== "phone" && event.detail.currentBreakpoint === "phone") {
          this.selectedSlide = null;
          this._transitionToSlide(this.slideshow.flickityInstance.selectedElement);
        }
      }
    }]);
    return SlideshowSection;
  }();
  var TestimonialsSection = /*#__PURE__*/function () {
    function TestimonialsSection(container) {
      _classCallCheck(this, TestimonialsSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.navItems = Dom.nodeListToArray(this.element.querySelectorAll(".TestimonialNav__Item"));
      this.carousel = new Carousel(this.element.querySelector(".TestimonialList"), {
        onSelect: this._testimonialChanged.bind(this)
      });
      this._attachListeners();
    }
    _createClass(TestimonialsSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousel.destroy();
        this.delegateElement.off("click");
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        this.carousel.selectCell(event.target.getAttribute("data-slide-index"), true);
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect() {
        this.carousel.unpausePlayer();
      }
    }, {
      key: "_testimonialClicked",
      value: function _testimonialClicked(event, target) {
        this.carousel.pausePlayer();
        this.carousel.selectCell(parseInt(target.getAttribute("data-index")));
        this.carousel.unpausePlayer();
      }
    }, {
      key: "_testimonialChanged",
      value: function _testimonialChanged(newIndex) {
        this.navItems.forEach(function (item, index) {
          item.classList.remove("is-selected"); // IE11 and lower does not support classList.toggle

          if (newIndex === index) {
            item.classList.add("is-selected");
          }
        });
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on("click", ".TestimonialNav__Item", this._testimonialClicked.bind(this));
      }
    }]);
    return TestimonialsSection;
  }();
  var TimelineSection = /*#__PURE__*/function () {
    function TimelineSection(container) {
      _classCallCheck(this, TimelineSection);
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.items = Dom.nodeListToArray(this.element.querySelectorAll(".Timeline__Item"));
      this.navItems = Dom.nodeListToArray(this.element.querySelectorAll(".Timeline__NavItem"));
      this._attachListeners();
    }
    _createClass(TimelineSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off("click");
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        this.navItems[parseInt(event.target.getAttribute("data-index"))].click(); // Simulate a click on the given nav item
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on("click", ".Timeline__NavItem", this._clickOnNavItem.bind(this));
      }
    }, {
      key: "_clickOnNavItem",
      value: function _clickOnNavItem(event, target) {
        var newItem = this.items[parseInt(target.getAttribute("data-index"))];
        if (newItem.classList.contains("is-selected")) {
          return;
        }
        var isContentLarger = false,
          navWrapper = target.parentNode,
          scrollableOffset = 0;
        fastdom.measure(function () {
          var scrollableWidth = navWrapper.scrollWidth,
            visibleWidth = navWrapper.offsetWidth;
          isContentLarger = visibleWidth < scrollableWidth;
          if (isContentLarger) {
            var beginBound = target.offsetLeft,
              endBound = beginBound + target.offsetWidth,
              closerToLeft = beginBound <= visibleWidth - endBound;
            var itemToUse = null;
            if (closerToLeft) {
              // If closer to left, we try to make the previous item visible (if possible)
              itemToUse = target.previousElementSibling || target;
            } else {
              // If closer to right, we try to make the next item visible (if possible)
              itemToUse = target.nextElementSibling || target;
            }
            var itemBeginBound = itemToUse.offsetLeft - navWrapper.scrollLeft,
              itemEndBound = itemBeginBound + itemToUse.offsetWidth;
            if (itemEndBound > visibleWidth) {
              // Element is not visible from the right, so we must move by a given amount so that endBound is within viewable screen
              scrollableOffset = itemEndBound - visibleWidth;
            } else if (itemBeginBound < 0) {
              // Element is not visible from the left, so we simply use the opposite of the negative offset
              scrollableOffset = itemBeginBound;
            }
          }
        });
        fastdom.mutate(function () {
          if (isContentLarger) {
            navWrapper.scrollBy({
              behavior: "smooth",
              left: scrollableOffset
            });
          } // First we set the class on the selected item and remove it on siblings

          target.classList.add("is-selected");
          Dom.getSiblings(target, ".is-selected").forEach(function (item) {
            item.classList.remove("is-selected");
          }); // Then we slide to the appropriate element

          newItem.classList.add("is-selected");
          Dom.getSiblings(newItem, ".is-selected").forEach(function (item) {
            item.classList.remove("is-selected");
          });
        });
      }
    }]);
    return TimelineSection;
  }();
  var PriceRange = /*#__PURE__*/function (_HTMLElement) {
    _inherits(PriceRange, _HTMLElement);
    var _super = _createSuper(PriceRange);
    function PriceRange() {
      _classCallCheck(this, PriceRange);
      return _super.apply(this, arguments);
    }
    _createClass(PriceRange, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this = this;
        this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
        this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
        this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
        this.textInputHigherBound = this.querySelector(".price-range__input:last-child input"); // Select whole text on focus for text field to improve user experience

        this.textInputLowerBound.addEventListener("focus", function () {
          return _this.textInputLowerBound.select();
        });
        this.textInputHigherBound.addEventListener("focus", function () {
          return _this.textInputHigherBound.select();
        }); // Keep in sync the range with the text input fields

        this.textInputLowerBound.addEventListener("change", function (event) {
          event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
          _this.rangeLowerBound.value = event.target.value;
          _this.rangeLowerBound.parentElement.style.setProperty("--range-min", "".concat(parseInt(_this.rangeLowerBound.value) / parseInt(_this.rangeLowerBound.max) * 100, "%"));
        });
        this.textInputHigherBound.addEventListener("change", function (event) {
          event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
          _this.rangeHigherBound.value = event.target.value;
          _this.rangeHigherBound.parentElement.style.setProperty("--range-max", "".concat(parseInt(_this.rangeHigherBound.value) / parseInt(_this.rangeHigherBound.max) * 100, "%"));
        });
        this.rangeLowerBound.addEventListener("change", function (event) {
          _this.textInputLowerBound.value = event.target.value;
          _this.textInputLowerBound.dispatchEvent(new Event("change", {
            bubbles: true
          }));
        });
        this.rangeHigherBound.addEventListener("change", function (event) {
          _this.textInputHigherBound.value = event.target.value;
          _this.textInputHigherBound.dispatchEvent(new Event("change", {
            bubbles: true
          }));
        }); // We also have to bound the two range sliders

        this.rangeLowerBound.addEventListener("input", function (event) {
          event.target.value = Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1); // Bound the value

          event.target.parentElement.style.setProperty("--range-min", "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
          _this.textInputLowerBound.value = event.target.value;
        });
        this.rangeHigherBound.addEventListener("input", function (event) {
          event.target.value = Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1); // Bound the value

          event.target.parentElement.style.setProperty("--range-max", "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
          _this.textInputHigherBound.value = event.target.value;
        });
      }
    }]);
    return PriceRange;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
  window.customElements.define("price-range", PriceRange);

  /**
   * CUSTOM SECTIONS:
   */

  /**
   * Shop Switch Script
   * ------------------------------------------------------------------------------
   * A file that contains scripts highly couple code to the Shop Switch module.
   *
   * @namespace ShopSwitch
   */

  var ShopSwitch = /*#__PURE__*/function () {
    function ShopSwitch(container) {
      _classCallCheck(this, ShopSwitch);
      this.domDelegate = new domDelegate.Delegate(document.body);
      this.element = container;
      this.settings = JSON.parse(this.element.getAttribute("data-section-settings"));
      this.templates = {};
      this.templates.switcher = this.element.querySelector("[switcher-template]").innerHTML;
      this.templates.country = this.element.querySelector("[country-template]").innerHTML;
      this.data = {};
      this.data.currentCountry = _.find(this.settings.countries, function (o) {
        return o.current;
      }) || {};
      this.data.cookie = this.settings.cookieName;
      this.data.geoData = JSON.parse(localStorage.getItem("geodata")) || undefined;
      var bisgaardCookieName = this.settings.cookieName;
      function getCookie(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return !match; // Return true if the cookie does not exist, false otherwise
      }
      if (getCookie(bisgaardCookieName)) {
        console.log("Location Cookie does not exist");
        window.locationCookied = false;
      } else {
        console.log("Location Cookie exists");
        window.locationCookied = true;
      }

      // Prestige doesn't let us open modals programmatically. Hidden button hack.
      this.modalOpenTrigger = this.element.querySelector('[aria-controls="modal-shop-switch"]');
      this.modalCloseTrigger = this.element.querySelector('[data-action="close-modal"]');
      if (window.isBot || !this.settings["apiKey"]) {
        return;
      }
      if (window.top.location.search.indexOf("switch") !== -1) {
        this.setCookie(this.settings.cookieName);
        this.data.cookie = this.data.currentCountry.domain;
      }
      if (this.settings.switcherEnable) {
        // Build dropdown
        var context = {
          currentTitle: this.data.currentCountry.title,
          currentImg: this.data.currentCountry.img,
          currentCurrency: this.data.currentCountry.currency,
          countries: _.sortBy(this.settings.countries, [function (o) {
            return !o.current;
          }])
        };
        var template = Mustache.render(this.templates.switcher, context);

        // Add final dropdown html to wrappers
        $(".shop-switch__switcher").each(function () {
          $(this).html(template);
        });
      }
      this._attachListeners();
      document.addEventListener("modal:close", function (event) {
        if (event.detail.activeModal.id) {
          this.setCookie(this.settings.cookieName);
        }
      }.bind(this));
      this._log("GeoData: " + JSON.stringify(this.data.geoData));
      this._log("Cookie: " + this.data.cookie);
      if (this.data.cookie != this.data.currentCountry.domain || window.socialReferrer || this.settings.testMode) {
        if (this.data.geoCookie) {
          this._handleLocation();
        } else {
          this._loadLocation().then(this._handleLocation.bind(this));
        }
      }
    }
    _createClass(ShopSwitch, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        this.domDelegate.on("click", '.shop-switch__dismiss [data-action="close-modal"]', this.onStayClose.bind(this));
      }
    }, {
      key: "onStayClose",
      value: function onUnload(event) {
        this.setCookie(this.settings.cookieName);
        this.data.cookie = this.data.currentCountry.domain;
      }
    }, {
      key: "onUnload",
      value: function onUnload(event) {
        this.modalCloseTrigger.click();
      }
    }, {
      key: "onSelect",
      value: function onSelect(event) {
        setTimeout(function () {
          this.modalOpenTrigger.click();
        }.bind(this), 500);
      }
    }, {
      key: "onDeselect",
      value: function onDeselect(event) {
        this.modalCloseTrigger.click();
      }
    }, {
      key: "setCookie",
      value: function setCookie(name) {
        var currentDate = new Date();
        $.cookie(name, this.data.currentCountry.domain, {
          path: "/",
          expires: new Date(currentDate.getTime() + Number(this.settings.delayDays) * 24 * 60 * 60 * 1000)
        });
      }
    }, {
      key: "_loadLocation",
      value: function () {
        var _getLocation2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var _this, url, response;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this = this;
                url = "/browsing_context_suggestions.json";
                _this._log("Loading: " + url);
                _context.next = 5;
                return fetch(url);
              case 5:
                response = _context.sent;
                _context.next = 8;
                return response.json();
              case 8:
                window.ipstack = _context.sent;
              case 9:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function _getLocation() {
          return _getLocation2.apply(this, arguments);
        }
        return _getLocation;
      }()
    }, {
      key: "_handleLocation",
      value: function _handleLocation() {
        var _this2 = this;
        var locationData = window.ipstack.detected_values.country.handle;
        localStorage.setItem("geodata", JSON.stringify(window.ipstack));
        _this2.data.geoData = JSON.parse(localStorage.getItem("geodata"));
        _this2._log("Country code: " + locationData);
        if (_.isUndefined(locationData)) {
          _this2._log("Could not get location based on IP.");
          return;
        }
        var ipCountryCode = locationData;

        // Check if the desired country is available by index
        var ip_index = _.findIndex(this.settings.countries, function (o) {
            if (o.country_code.includes(",")) {
              var countryCodes = o.country_code.split(",");
              for (var i = 0; i < countryCodes.length; i++) {
                if (countryCodes[i] == ipCountryCode) {
                  return true;
                }
              }
            } else {
              return o.country_code == ipCountryCode;
            }
          }),
          default_index = _.findIndex(this.settings.countries, function (o) {
            return o["default"];
          }),
          current_index = _.findIndex(this.settings.countries, function (o) {
            return o.current;
          });

        // Only get domain for IP if a dedicated store exists
        if (ip_index >= 0) var ip_domain = this.settings.countries[ip_index].domain;
        var default_domain = this.settings.countries[default_index].domain,
          current_domain = this.settings.countries[current_index].domain;

        // Is country from IP in our list AND is that the current shop?
        if (!_.isUndefined(ip_domain) && current_domain == ip_domain) {
          // Do nothing
        }
        // Is country from IP NOT in our list AND are we on the default shop?
        else if (_.isUndefined(ip_domain) && current_domain == default_domain) {
          // Do nothing
        } else {
          // Is country from IP in our list?
          if (!_.isUndefined(ip_domain)) {
            var new_domain = ip_domain;
          }
          // Go to default
          else {
            var new_domain = default_domain;
          }
          if (this.settings.testMode) console.info("[Shop Switch] Designated shop: " + new_domain);
          if (window.locationCookied == false) {
            // Open the modal
            if (this.settings.mode == "enabled") {
              this._initPopupDelay();
            } else if (this.settings.mode == "redirect") {
              if (Shopify.designMode) {
                _this2._log("Cannot redirect from editor: " + this.settings.countries[new_index].url);
              } else {
                var new_index = _.findIndex(this.settings.countries, function (o) {
                  return o.domain == new_domain;
                });
                this.redirect(this.settings.countries[new_index].url);
              }
            }
          }
          if (this.settings.testMode) {
            this._initPopupDelay();
          }
        }
      }
    }, {
      key: "_initPopupDelay",
      value: function () {
        var _getLocation3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                setTimeout(function () {
                  this.modalOpenTrigger.click();
                }.bind(this), this.settings.delaySeconds * 1000);
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function _getLocation() {
          return _getLocation3.apply(this, arguments);
        }
        return _getLocation;
      }()
    }, {
      key: "_redirect",
      value: function () {
        var _getLocation4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          var _this, url, response;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _this = this;
                url = "https://api.ipstack.com/check?access_key=".concat(_this.settings["apiKey"]);
                _context3.next = 4;
                return fetch(url);
              case 4:
                response = _context3.sent;
                _context3.next = 7;
                return response.json();
              case 7:
                window.ipstack = _context3.sent;
              case 8:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this);
        }));
        function _getLocation() {
          return _getLocation4.apply(this, arguments);
        }
        return _getLocation;
      }()
    }, {
      key: "_log",
      value: function () {
        var _log2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(log) {
          var _this3, message;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _this3 = this;
                message = "%c" + log;
                if (_this3.settings.testMode) {
                  console.log("%c[Shop Switch] " + message, "color: blue;", "color: black;");
                }
              case 3:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
        function _log(_x) {
          return _log2.apply(this, arguments);
        }
        return _log;
      }()
    }]);
    return ShopSwitch;
  }();
  (function () {
    // First, we register all plugins that are used for all pages
    new Collapsible();
    new Modal();
    new Responsive();
    if (window.theme.pageType !== "password" && window.theme.pageType !== "gift_card") {
      new LoadingBar();
    }
    var sections = new SectionContainer();
    sections.register("header", HeaderSection);
    sections.register("footer", FooterSection);
    sections.register("sidebar-menu", SidebarMenuSection);
    sections.register("cart", CartSection);
    sections.register("newsletter-popup", NewsletterPopupSection); // Sections used on index

    sections.register("slideshow", SlideshowSection);
    sections.register("collection-list", CollectionListSection);
    sections.register("article-list", ArticleList);
    sections.register("featured-product", FeaturedProductSection);
    sections.register("image-with-text-block", ImageWithTextBlockSection);
    sections.register("timeline", TimelineSection);
    sections.register("map", MapSection);
    sections.register("featured-collections", FeaturedCollectionsSection);
    sections.register("shop-the-look", ShopTheLookSection);
    sections.register("testimonials", TestimonialsSection);
    sections.register("background-video", BackgroundVideoSection); // Sections used on product page

    sections.register("product", ProductSection);
    sections.register("product-recommendations", ProductRecommendationsSection); // Sections used on collection page

    sections.register("collection", CollectionSection); // Sections used on blog page

    sections.register("article-list", ArticleList); // Sections used on article page

    sections.register("article", ArticleSection); // Sections used on content pages

    sections.register("faq", FaqSection); // Sections used on login page

    sections.register("login", LoginSection); // Sections used on addresses page

    sections.register("addresses", AddressesSection); // Sections used on gift card page

    sections.register("gift-card", GiftCardSection); // Sections used on different pages

    sections.register("recently-viewed-products", RecentlyViewedProductsSection);
    sections.register("shop-now", ShopNowSection);

    // Custom sections
    sections.register("shop-switch", ShopSwitch);

    /**
     * ----------------------------------------------------------------------------
     * FLICKITY
     *
     * Starting from iOS 11, Safari on iOS is experiencing a bug that prevents
     * event.preventDefault to be called on dynamically added listeners, which is
     * what Flickity is using.
     *
     * The bug is coming from iOS but it impacts indirectly Flickity. A temporary
     * fix has been suggested here: https://github.com/metafizzy/flickity/issues/740
     * and that we are using here as a temporary workaround, that should be removed
     * once the bug is fixed on iOS
     * ----------------------------------------------------------------------------
     */

    Flickity.defaults.dragThreshold = 7;
    (function () {
      var touchingCarousel = false,
        touchStartCoords;
      document.body.addEventListener("touchstart", function (e) {
        if (e.target.closest(".flickity-slider")) {
          touchingCarousel = true;
        } else {
          touchingCarousel = false;
          return;
        }
        touchStartCoords = {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY
        };
      });
      document.body.addEventListener("touchmove", function (e) {
        if (!(touchingCarousel && e.cancelable)) {
          return;
        }
        var moveVector = {
          x: e.touches[0].pageX - touchStartCoords.x,
          y: e.touches[0].pageY - touchStartCoords.y
        };
        if (Math.abs(moveVector.x) > Flickity.defaults.dragThreshold) e.preventDefault();
      }, {
        passive: false
      });
    })()
    /**
     * ----------------------------------------------------------------------------
     * FLICKITY 2
     *
     * Starting from iOS 15, Safari on iOS automatically starts to expand/collapse
     * the bottom bar as soon as you do even a minor diagonal movement. This is causing
     * a performance issue on iOS15 as it does a lot of reflow. We therefore have to
     * patch Flickity to make sure they re-size the carousel only when the width is
     * changed, by ignoring the height
     * ----------------------------------------------------------------------------
     */;
    (function () {
      if (window.Flickity) {
        var originalResizeMethod = window.Flickity.prototype.resize,
          lastWidth = window.innerWidth;
        window.Flickity.prototype.resize = function () {
          if (window.innerWidth === lastWidth && this.maxCellHeight > 0) {
            return;
          }
          lastWidth = window.innerWidth;
          originalResizeMethod.apply(this, arguments); // Call original method
        };
      }
    })()
    /**
     * ----------------------------------------------------------------------------
     * RTE
     * ----------------------------------------------------------------------------
     */;
    (function () {
      // We wrap each RTE table by a specific class to allow wrapping
      Dom.nodeListToArray(document.querySelectorAll(".Rte table")).forEach(function (table) {
        table.outerHTML = '<div class="TableWrapper">' + table.outerHTML + "</div>";
      });
      Dom.nodeListToArray(document.querySelectorAll(".Rte iframe")).forEach(function (iframe) {
        // We scope the wrapping only for YouTube and Vimeo
        if (iframe.src.indexOf("youtube") !== -1 || iframe.src.indexOf("youtu.be") !== -1 || iframe.src.indexOf("vimeo") !== -1) {
          iframe.outerHTML = '<div class="VideoWrapper">' + iframe.outerHTML + "</div>"; // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
          // https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar

          iframe.src = iframe.src;
        }
      });
    })()
    /**
     * ----------------------------------------------------------------------------
     * UTILS
     * ----------------------------------------------------------------------------
     */;
    (function () {
      var documentDelegate = new domDelegate.Delegate(document.body),
        announcementBar = document.querySelector(".AnnouncementBar");
      documentDelegate.on("click", '[href^="#"], [data-href]', function (event, target) {
        var selector = target.hasAttribute("href") ? target.getAttribute("href") : target.getAttribute("data-href");
        if (selector === "#" || selector === "#main") {
          return;
        }
        var element = document.querySelector(selector),
          offset = parseInt(target.getAttribute("data-offset") || 0);
        if (announcementBar) {
          offset -= announcementBar.clientHeight;
        }
        if (target.hasAttribute("data-focus-on-click")) {
          var prevScrollY = window.pageYOffset;
          element.focus({
            preventScroll: true
          }); // hack to fix scroll jump after focus

          if (window.pageYOffset !== prevScrollY) {
            window.scrollTo(window.pageXOffset, prevScrollY);
          }
          element.focus();
        }
        window.scrollTo({
          behavior: "smooth",
          top: element.offsetTop - offset
        });
        event.preventDefault();
      });
    })();
    (function () {
      var windowWidth = window.innerWidth,
        headerSection = document.getElementById("shopify-section-header");
      window.addEventListener("resize", function () {
        var newWidth = -1;
        fastdom.measure(function () {
          newWidth = window.innerWidth;
        });
        fastdom.mutate(function () {
          if (newWidth === windowWidth) {
            return;
          }
          windowWidth = newWidth;
          document.documentElement.style.setProperty("--window-height", window.innerHeight + "px");
          if (headerSection) {
            document.documentElement.style.setProperty("--header-height", headerSection.clientHeight + "px");
          }
        });
      });
    })();
    (function () {
      function handleFirstTab(event) {
        if (event.keyCode === 9) {
          document.body.classList.add("is-tabbing");
          window.removeEventListener("keydown", handleFirstTab);
        }
      }
      window.addEventListener("keydown", handleFirstTab);
    })();
    /**
     * ----------------------------------------------------------------------------
     * ANIMATION
     *
     * Important: this has to be at the very end of the file
     * ----------------------------------------------------------------------------
     */

    if (window.theme.showPageTransition) {
      PageTransition.getInstance();
    }
  })();
});
(function () {
  var doc = document.documentElement;
  var w = window;
  var prevScroll = w.scrollY || doc.scrollTop;
  var curScroll;
  var direction = 0;
  var prevDirection = 0;
  var header = document.getElementById("shopify-section-header");
  var checkScroll = function checkScroll() {
    /*
     ** Find the direction of scroll
     ** 0 - initial, 1 - up, 2 - down
     */

    curScroll = w.scrollY || doc.scrollTop;
    if (curScroll > prevScroll) {
      //scrolled up
      direction = 2;
    } else if (curScroll < prevScroll) {
      //scrolled down
      direction = 1;
    }
    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }
    prevScroll = curScroll;
  };
  var toggleHeader = function toggleHeader(direction, curScroll) {
    if (direction === 2 && curScroll > 66) {
      //replace 52 with the height of your header in px

      header.classList.add("hide-me");
      prevDirection = direction;
    } else if (direction === 1) {
      header.classList.remove("hide-me");
      prevDirection = direction;
    }
  };
  window.addEventListener("scroll", checkScroll);
})();
function countdown() {
  _.each($(".countdown"), function (e) {
    var $countdown = $(e),
      eventTime = moment($countdown.data("time"), "HH:mm:ss").unix(),
      currentTime = moment().unix(),
      diffTime = eventTime - currentTime,
      duration = moment.duration(diffTime * 1000, "milliseconds"),
      interval = 1000,
      isWeekend = moment().format("e") == 0 || moment().format("e") == 6;

    // if time to countdown
    if (diffTime > 0 && !isWeekend) {
      var updateClock = function updateClock() {
        duration = moment.duration(duration.asMilliseconds() - interval, "milliseconds");
        if (duration._milliseconds < 0) {
          $countdown.hide();
          return;
        }
        var d = moment.duration(duration).days(),
          h = moment.duration(duration).hours(),
          m = moment.duration(duration).minutes(),
          s = moment.duration(duration).seconds();
        d = $.trim(d).length === 1 ? "0" + d : d;
        h = $.trim(h).length === 1 ? "0" + h : h;
        m = $.trim(m).length === 1 ? "0" + m : m;
        s = $.trim(s).length === 1 ? "0" + s : s;

        // show how many hours, minutes and seconds are left
        $d.text(d);
        $h.text(h);
        $m.text(m);
        $s.text(s);
      };
      // Show countdown
      $countdown.fadeIn();
      $countdown.next(".countdown--text").fadeIn();
      var $d = $(".countdown-days"),
        $h = $(".countdown-hours"),
        $m = $(".countdown-minutes"),
        $s = $(".countdown-seconds");
      updateClock();
      setInterval(function () {
        updateClock();
      }, 1000);
    } else {
      $countdown.hide();
    }
  });
}
countdown();

// Testimonial Slider Section
var testimonalSection = /*#__PURE__*/function (_HTMLElement2) {
  _inherits2(testimonalSection, _HTMLElement2);
  var _super2 = _createSuper2(testimonalSection);
  function testimonalSection() {
    var _this8;
    _classCallCheck2(this, testimonalSection);
    _this8 = _super2.call(this);
    var testimonialSlider = _assertThisInitialized2(_this8);
    var testimonialSliderCards = _this8.querySelectorAll('.ed_testimonial_slide');
    var sliderCardsWidth = testimonialSliderCards[0].offsetWidth + 12;
    var sliderBtns = _this8.closest('.testimonial-section').querySelectorAll('.sliderbtn');
    var _iterator = _createForOfIteratorHelper(sliderBtns),
      _step;
    try {
      var _loop = function _loop() {
        var sliderBtn = _step.value;
        sliderBtn.addEventListener('click', function () {
          if (sliderBtn.getAttribute('data-id') == 'right') {
            testimonialSlider.scrollLeft += sliderCardsWidth;
          } else {
            testimonialSlider.scrollLeft -= sliderCardsWidth;
          }
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return _this8;
  }
  return _createClass2(testimonalSection);
}( /*#__PURE__*/_wrapNativeSuper2(HTMLElement));
customElements.define('ed-testimonial-slider', testimonalSection);

// Collection pages - add the picked sorting option as text to sorting button eg. "Price, low to high" instead of "Sort"
document.addEventListener('DOMContentLoaded', function () {
  var currentSortTextEle = document.querySelector('.CollectionToolbar__Item.CollectionToolbar__Item--sort.Text--subdued.u-h6');
  if (currentSortTextEle) {
    // get the current sorting option text and the dropdown svg
    var currentSortText = currentSortTextEle.innerText;
    currentSortText = currentSortText.replace(" ", "");
    var dropdownSvg = currentSortTextEle.querySelector('svg');
    currentSortTextEle.addEventListener('click', function () {
      // get the sorting option parent and its options
      var sortingOptionParent = document.querySelector('.boost-pfs-filter-top-sorting.Popover__ValueList');
      var options = sortingOptionParent.querySelectorAll('.Popover__Value.Heading.Link');
      var _iterator2 = _createForOfIteratorHelper(options),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var option = _step2.value;
          option.addEventListener('click', function () {
            var selectedSortingOption = this;
            selectedSortingOption ? currentSortTextEle.innerHTML = selectedSortingOption.textContent + dropdownSvg.outerHTML : currentSortText = currentSortTextEle.innerText;
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  var collapsibleTabButtons = document.querySelectorAll('.edition_collapsible_tab_button');
  if (collapsibleTabButtons.length >= 1) {
    var _iterator3 = _createForOfIteratorHelper(collapsibleTabButtons),
      _step3;
    try {
      var _loop2 = function _loop2() {
        var button = _step3.value;
        button.addEventListener('click', function () {
          var openTabButtons = document.querySelectorAll('.edition_collapsible_tab_button[aria-expanded="true"]');
          var openTabContents = document.querySelectorAll('.edition_collapsible_inner[style="overflow: visible; height: auto;"]');
          var openTabs = document.querySelectorAll('.edition_collapsible_tab[style="overflow: visible;"]');
          if (button.getAttribute('aria-expanded') == 'false') {
            if (openTabButtons.length >= 1) {
              var _iterator4 = _createForOfIteratorHelper(openTabButtons),
                _step4;
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  var openTabButton = _step4.value;
                  openTabButton.setAttribute('aria-expanded', 'false');
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
              var _iterator5 = _createForOfIteratorHelper(openTabContents),
                _step5;
              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  var openTabContent = _step5.value;
                  openTabContent.setAttribute('style', 'overflow: hidden; height: 0px;');
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
              var _iterator6 = _createForOfIteratorHelper(openTabs),
                _step6;
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  var openTab = _step6.value;
                  openTab.setAttribute('style', 'overflow: hidden;');
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
            }
          }
        });
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop2();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
});

// Gift with product very theme specific
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('edition:cart:refreshed', function (event) {
    // fetch the cart to see if the content of the cart
    getCart();
  });
});
function getCart() {
  return _getCart.apply(this, arguments);
}
function _getCart() {
  _getCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var response, data, items, itemCount, giftWithProductId, totalPrice, giftIsInCart, giftPrice, giftProductObject, giftItemKey, giftItem, logicProducts, logicProductIsInCart, logicCartTotal;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return fetch('/cart.js');
        case 3:
          response = _context5.sent;
          if (!response.ok) {
            _context5.next = 30;
            break;
          }
          _context5.next = 7;
          return response.json();
        case 7:
          data = _context5.sent;
          items = data.items;
          itemCount = data.item_count;
          giftWithProductId = window.giftWithProduct;
          totalPrice = data.total_price;
          if (!(itemCount > 0)) {
            _context5.next = 28;
            break;
          }
          if (!(giftWithProductId !== null && giftWithProductId !== undefined && giftWithProductId !== '')) {
            _context5.next = 28;
            break;
          }
          giftIsInCart = items.some(function (item) {
            return item.variant_id == giftWithProductId;
          });
          giftPrice = window.giftwithProductPrice; // if gift is not in cart, add it
          giftProductObject = {
            'items': [{
              'id': giftWithProductId,
              'quantity': 1,
              'properties': {
                '_free_gift': 'true'
              }
            }]
          }; // find the line item key of the gift (Used to remove the gift from the cart if needed)
          if (giftIsInCart == true) {
            giftItem = items.find(function (item) {
              return item.properties._free_gift == 'true';
            });
            if (giftItem) {
              giftItemKey = giftItem.key;
            }
          }

          // if using product based logic to add gift
          if (window.giftLogicCartProducts !== null && window.giftLogicCartProducts !== undefined && window.giftLogicCartProducts !== '') {
            logicProducts = window.giftLogicCartProducts; // checking if any of the logic products variants are in the cart
            logicProductIsInCart = logicProducts.some(function (logicProduct) {
              return items.some(function (item) {
                return item.variant_id === logicProduct.variantId;
              });
            }); // if any of the logic products are in the cart, add the gift
            if (logicProductIsInCart == true && giftIsInCart == false) {
              addProductToCart(giftProductObject);
            } else if (logicProductIsInCart == false && giftIsInCart == true) {
              removeObject = {
                id: giftItemKey,
                quantity: 0
              };
              giftIsInCart == true ? removeGiftFromCart(removeObject) : null;
            }
          }

          // if using cart total value to add gift
          if (!(window.giftLogicCartTotal !== null && window.giftLogicCartTotal !== undefined && window.giftLogicCartTotal !== '')) {
            _context5.next = 28;
            break;
          }
          logicCartTotal = window.giftLogicCartTotal;
          logicCartTotal = logicCartTotal;
          if (giftIsInCart == true) {
            totalPrice = totalPrice;
          }
          if (!(sessionStorage.getItem('giftUnwanted') == 'true')) {
            _context5.next = 27;
            break;
          }
          return _context5.abrupt("return");
        case 27:
          if (totalPrice >= logicCartTotal && giftIsInCart == false) {
            addProductToCart(giftProductObject);
          } else if (totalPrice < logicCartTotal && giftIsInCart == true) {
            removeObject = {
              id: giftItemKey,
              quantity: 0
            };
            giftIsInCart == true ? removeGiftFromCart(removeObject) : null;
          }
        case 28:
          if (response.ok) {
            _context5.next = 30;
            break;
          }
          throw new Error('Network response was not ok.');
        case 30:
          _context5.next = 35;
          break;
        case 32:
          _context5.prev = 32;
          _context5.t0 = _context5["catch"](0);
          console.log(_context5.t0);
        case 35:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 32]]);
  }));
  return _getCart.apply(this, arguments);
}
function addProductToCart(_x2) {
  return _addProductToCart.apply(this, arguments);
}
function _addProductToCart() {
  _addProductToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(formData) {
    var response, data;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          });
        case 3:
          response = _context6.sent;
          if (!response.ok) {
            _context6.next = 11;
            break;
          }
          _context6.next = 7;
          return response.json();
        case 7:
          data = _context6.sent;
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
          _context6.next = 12;
          break;
        case 11:
          throw new Error('Network response was not ok.');
        case 12:
          _context6.next = 17;
          break;
        case 14:
          _context6.prev = 14;
          _context6.t0 = _context6["catch"](0);
          console.log(_context6.t0);
        case 17:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 14]]);
  }));
  return _addProductToCart.apply(this, arguments);
}
function removeGiftFromCart(_x3) {
  return _removeGiftFromCart.apply(this, arguments);
}
function _removeGiftFromCart() {
  _removeGiftFromCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(formData) {
    var response, data;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          });
        case 3:
          response = _context7.sent;
          if (!response.ok) {
            _context7.next = 11;
            break;
          }
          _context7.next = 7;
          return response.json();
        case 7:
          data = _context7.sent;
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
          _context7.next = 12;
          break;
        case 11:
          throw new Error('Network response was not ok.');
        case 12:
          _context7.next = 17;
          break;
        case 14:
          _context7.prev = 14;
          _context7.t0 = _context7["catch"](0);
          console.log(_context7.t0);
        case 17:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 14]]);
  }));
  return _removeGiftFromCart.apply(this, arguments);
}
var EditionBreadcrumbs = /*#__PURE__*/function (_HTMLElement3) {
  _inherits2(EditionBreadcrumbs, _HTMLElement3);
  var _super3 = _createSuper2(EditionBreadcrumbs);
  function EditionBreadcrumbs() {
    var _this9;
    _classCallCheck2(this, EditionBreadcrumbs);
    _this9 = _super3.call(this);
    _this9.addEventListener('click', _this9.handleClick);
    return _this9;
  }
  _createClass2(EditionBreadcrumbs, [{
    key: "handleClick",
    value: function handleClick(event) {
      this.getPreviousUrl();
    }
  }, {
    key: "getPreviousUrl",
    value: function getPreviousUrl() {
      var history = window.history;
      if (history.length > 1) {
        var previousUrl = document.referrer;

        // check if the previous url is from the same domain

        if (previousUrl.includes(window.location.hostname)) {
          window.history.back();
        } else {
          window.location.href = '/';
        }
      }
    }
  }]);
  return EditionBreadcrumbs;
}( /*#__PURE__*/_wrapNativeSuper2(HTMLElement));
customElements.define('edition-breadcrumbs', EditionBreadcrumbs);
function asyncFetchProduct(_x4) {
  return _asyncFetchProduct.apply(this, arguments);
} // define edition-arrow custom element
function _asyncFetchProduct() {
  _asyncFetchProduct = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(productHandle) {
    var response, data;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return fetch("/products/".concat(productHandle, ".js"));
        case 3:
          response = _context8.sent;
          if (!response.ok) {
            _context8.next = 11;
            break;
          }
          _context8.next = 7;
          return response.json();
        case 7:
          data = _context8.sent;
          return _context8.abrupt("return", data);
        case 11:
          throw new Error('Network response was not ok.');
        case 12:
          _context8.next = 17;
          break;
        case 14:
          _context8.prev = 14;
          _context8.t0 = _context8["catch"](0);
          console.log(_context8.t0);
        case 17:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[0, 14]]);
  }));
  return _asyncFetchProduct.apply(this, arguments);
}
var editionArrow = /*#__PURE__*/function (_HTMLElement4) {
  _inherits2(editionArrow, _HTMLElement4);
  var _super4 = _createSuper2(editionArrow);
  function editionArrow() {
    var _this10;
    _classCallCheck2(this, editionArrow);
    _this10 = _super4.call(this);
    _this10.scroll = _this10.scroll.bind(_assertThisInitialized2(_this10));
    _this10.addEventListener('click', _this10.scroll);
    if (_this10.closest('.edition_scroller')) {
      var scroller = _this10.closest('.edition_scroller');
    } else {
      if (_this10.dataset.direction == 'left') {
        var scroller = _this10.previousElementSibling.previousElementSibling;
      } else {
        var scroller = _this10.previousElementSibling;
      }
    }
    if (scroller) {
      scroller.addEventListener('scroll', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        _this10.setScroller(scroller, _assertThisInitialized2(_this10));
      });
    }
    return _this10;
  }
  _createClass2(editionArrow, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var arrow = this;
      arrow.classList.add('edition_arrow');
    }
  }, {
    key: "scroll",
    value: function scroll() {
      var arrow = this;
      if (arrow.closest('.edition_scroller')) {
        var scroller = arrow.closest('.edition_scroller');
      } else {
        if (arrow.dataset.direction == 'left') {
          var scroller = arrow.previousElementSibling.previousElementSibling;
        } else {
          var scroller = arrow.previousElementSibling;
        }
      }
      scroller.style.scrollBehavior = 'smooth';
      var widthOfSlide = scroller.querySelector('span').offsetWidth;
      scroller.scrollLeft += widthOfSlide * 3;
      if (arrow.dataset.direction == 'left') {
        scroller.scrollLeft -= widthOfSlide * 3;
      } else {
        scroller.scrollLeft += widthOfSlide * 3;
      }
      this.setScroller(scroller, arrow);
    }
  }, {
    key: "setScroller",
    value: function setScroller(scroller, arrow) {
      setTimeout(function () {
        if (scroller.scrollLeft <= 10) {
          if (scroller == arrow.closest('.edition_scroller')) {
            scroller.querySelector('.edition_arrow[data-direction="left"]').classList.add('scroller_arrow_class');
            scroller.querySelector('.edition_arrow[data-direction="left"]').classList.remove('scoller_arrow_class_visible');
          } else {
            scroller.nextElementSibling.nextElementSibling.classList.add('scroller_arrow_class');
            scroller.nextElementSibling.nextElementSibling.classList.remove('scoller_arrow_class_visible');
          }
        } else {
          if (scroller == arrow.closest('.edition_scroller')) {
            scroller.querySelector('.edition_arrow[data-direction="left"]').classList.remove('scroller_arrow_class');
            scroller.querySelector('.edition_arrow[data-direction="left"]').classList.add('scoller_arrow_class_visible');
          } else {
            scroller.nextElementSibling.nextElementSibling.classList.remove('scroller_arrow_class');
            scroller.nextElementSibling.nextElementSibling.classList.add('scoller_arrow_class_visible');
          }
        }
        if (scroller.scrollLeft + scroller.offsetWidth >= scroller.scrollWidth) {
          if (scroller == arrow.closest('.edition_scroller')) {
            scroller.querySelector('.edition_arrow[data-direction="right"]').classList.add('scroller_arrow_class');
            scroller.querySelector('.edition_arrow[data-direction="right"]').classList.remove('scoller_arrow_class_visible');
          } else {
            scroller.nextElementSibling.classList.add('scroller_arrow_class');
            scroller.nextElementSibling.classList.remove('scoller_arrow_class_visible');
          }
        } else {
          if (scroller == arrow.closest('.edition_scroller')) {
            scroller.querySelector('.edition_arrow[data-direction="right"]').classList.remove('scroller_arrow_class');
            scroller.querySelector('.edition_arrow[data-direction="right"]').classList.add('scoller_arrow_class_visible');
          } else {
            scroller.nextElementSibling.classList.remove('scroller_arrow_class');
            scroller.nextElementSibling.classList.add('scoller_arrow_class_visible');
          }
        }
      }, 100);
    }
  }]);
  return editionArrow;
}( /*#__PURE__*/_wrapNativeSuper2(HTMLElement));
customElements.define('edition-arrow', editionArrow);
var readmore = document.getElementById('readmore-open');
var readless = document.getElementById('readmore-close');
var readmoreContent = document.getElementById('readmore-content');
if (readmore && readless && readmoreContent) {
  readmore.addEventListener('click', function (event) {
    event.preventDefault();
    readmoreContent.classList.remove('readmore-content');
    readmore.classList.add('tw-hidden');
    readless.classList.remove('tw-hidden');
  });
  readless.addEventListener('click', function (event) {
    event.preventDefault();
    readmoreContent.classList.add('readmore-content');
    readmore.classList.remove('tw-hidden');
    readless.classList.add('tw-hidden');
  });
}
var variantBtns = document.querySelectorAll('.SizeSwatch__Radio');
var clubBisgaard = document.getElementById('club-bisgaard_points');
if (variantBtns.length >= 1 && clubBisgaard) {
  variantBtns.forEach(function (btn) {
    btn.addEventListener('change', function () {
      setTimeout(function () {
        var url = window.location.href;
        reloadClubBisgaardPoints(url);
      }, 100);
    });
  });
}
function reloadClubBisgaardPoints(_x5) {
  return _reloadClubBisgaardPoints.apply(this, arguments);
}
function _reloadClubBisgaardPoints() {
  _reloadClubBisgaardPoints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(url) {
    var response, responseText, fresh, newClubBisgaard;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return window.fetch("".concat(url, "?section_id=main-product"));
        case 3:
          response = _context9.sent;
          if (!response.ok) {
            _context9.next = 12;
            break;
          }
          _context9.next = 7;
          return response.text();
        case 7:
          responseText = _context9.sent;
          fresh = document.createElement('div');
          fresh.innerHTML = responseText;
          newClubBisgaard = fresh.querySelector('#club-bisgaard_points');
          if (clubBisgaard.innerHTML !== newClubBisgaard.innerHTML) {
            clubBisgaard.innerHTML = newClubBisgaard.innerHTML;
          }
        case 12:
          _context9.next = 17;
          break;
        case 14:
          _context9.prev = 14;
          _context9.t0 = _context9["catch"](0);
          console.log(_context9.t0);
        case 17:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[0, 14]]);
  }));
  return _reloadClubBisgaardPoints.apply(this, arguments);
}

/***/ }),

/***/ "./styles/theme.scss":
/*!***************************!*\
  !*** ./styles/theme.scss ***!
  \***************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	!function() {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = function(result, chunkIds, fn, priority) {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var chunkIds = deferred[i][0];
/******/ 				var fn = deferred[i][1];
/******/ 				var priority = deferred[i][2];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every(function(key) { return __webpack_require__.O[key](chunkIds[j]); })) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/theme": 0,
/******/ 			"assets/theme": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkbisgaardshoes_dk"] = self["webpackChunkbisgaardshoes_dk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/theme"], function() { return __webpack_require__("./scripts/theme.js"); })
/******/ 	__webpack_require__.O(undefined, ["assets/theme"], function() { return __webpack_require__("./scripts/app.ts"); })
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/theme"], function() { return __webpack_require__("./styles/theme.scss"); })
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;